import { UploadIdentificationCommandResultStatus } from "Api/Api";
import {
  AddressType,
  Bank,
  BankEnvironment,
  LicenseCode,
  LoyaltyEventCode,
  PartyType,
  TransactionStatus,
  UploadIdentificationCommandResultStatus2,
  VatStatus,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "./Resources";

export const CzechResourcesDictionary: ResourceDictionary = {
  Hooks: {
    BankingAuth: {
      Error: "Připojení banky se nezdařilo",
    },
    OCR: {
      Error: "Údaje z dokumentů se nepodařilo přečíst",
      Declined: "Doklad neprošel automatickou kontrolou pravosti.",
    },
    Paypoint: {
      PaypointEdited: "Paypoint {{name}} byl upraven",
      PaypointEditError: "Chyba při úpravě paypointu",
      PaypointCreateError: "Chyba při vytváření paypointu",
      PaypointCreated: "Paypoint {{name}} byl vytvořen",
      AssignNfcCardNoConflict:
        "Chyba - Tato NFC karta je již přiřazena k jinému paypointu",
      AssignNfcCardSuccess: "NFC karta byla přiřazena k paypointu {{name}}",
      AssignNfcCardError: "Chyba při přiřazení NFC karty k paypointu",
      ScanError: "Platbu se nepodařilo zahájit, zkuste to prosím znovu",
    },
    Transaction: {
      TipUpdateError: "Spropitné se nepodařilo aktualizovat",
    },
    BankingAccount: {
      Deleted: "Bankovní účet byl smazán",
      DeleteError: "Chyba při mazání bankovního účtu",
      PrimaryAccountChanged: "Primární účet byl změněn",
      PrimaryAccountChangeError: "Primární účet se nepodařilo změnit",
      StatusChanged: "Účet byl upraven",
      StatusChangeError: "Účet se nepodařilo upravit",
    },
    TerminalContract: {
      DownloadError: "Nastala chyba při stahování smlouvy",
      UcbContractPrefix: "UCB_podklad_smlouvy_",
    },
    Verifications: {
      Error: "Registrační údaje se nepodařilo ověřit",
    },
    VerificationEmail: {
      Error: "Nepodařilo se odeslat verifikační e-mail",
      Success: "Verifikační e-mail byl odeslán",
    },
    CampaignTransaction: {
      Error: "Chyba při iniciování transakce",
      Success: "Transakce byla úspěšně iniciována",
    },
    Ares: {
      Error: "Při komunikaci s registrem firem se vyskytla chyba.",
      SubjectNotFound: "Subjekt nebyl nalezen",
    },
    Employee: {
      AccessSent: "Pozvánka zaměstnanci byla odeslána",
      BackOfficeTargetError:
        "Tato e-mailová adresa patří internímu účtu {{appName}} (Admin, AML, onboarding) a nelze ji pozvat. Použijte jinou e-mailovou adresu.",
      AccessSendError: "Přístup se nepodařilo odeslat",
      EmployeeExistsError:
        "Tato osoba už má zaměstnanecký přístup k této společnosti.",
      InviteeNotRegisteredError:
        "Pro tento e-mail neexistuje účet v {{appName}}. Dotyčná osoba se musí nejdříve v {{appName}} zaregistrovat, teprve poté ji můžete pozvat.",
      InvitationCancelled: "Pozvánka byla zrušena",
      InvitationCancelError: "Pozvánku se nepodařilo zrušit",
      EmployeeRemoved: "Zaměstnanec byl odebrán",
      EmployeeRemoveError: "Zaměstnance se nepodařilo odebrat",
    },
    Notifications: {
      Created: "Notifikace byla úspěšně vytvořena",
      CreateError: "Chyba při vytváření notifikace",
      Updated: "Notifikace byla úspěšně aktualizována",
      UpdateError: "Chyba při aktualizaci notifikace",
      Deleted: "Notifikace byla úspěšně smazána",
      DeleteError: "Chyba při mazání notifikace",
      Restored: "Notifikace byla úspěšně obnovena",
      RestoreError: "Chyba při obnovování notifikace",
    },
  },
  Stories: {
    Bar: {
      YourStory: "Moje story",
    },
    ImageUpload: {
      Prompt: "Přetáhněte obrázek nebo klikněte pro výběr",
      Error: "Nahrání obrázku se nezdařilo",
      InvalidType: "Podporovány jsou pouze obrázky PNG, JPEG nebo WebP",
      TooLarge: "Obrázek může mít maximálně {{megabytes}} MB",
    },
    VideoUpload: {
      Prompt: "Přetáhněte video nebo klikněte pro výběr",
      Error: "Nahrání videa se nezdařilo",
      TooLong: "Video může mít maximálně {{seconds}} sekund",
      InvalidType: "Podporována jsou pouze videa MP4, WebM nebo MOV",
      TooLarge: "Video může mít maximálně {{megabytes}} MB",
    },
    Management: {
      Title: "Stories",
      CreateButton: "Nové story",
      Empty: "Zatím žádná story",
      LoadError: "Story se nepodařilo načíst",
      Status: {
        Draft: "Koncept",
        Live: "Aktivní",
        Expired: "Vypršelo",
        Unpublished: "Neaktivní",
      },
      Table: {
        Author: "Autor",
        Text: "Text",
        State: "Stav",
        LastPublishedAt: "Naposledy publikováno",
        ExpiresAt: "Vyprší",
        DateCreated: "Vytvořeno",
        Publications: "Počet publikování",
        Actions: "Akce",
        Preview: "Náhled",
        Publish: "Publikovat",
        Republish: "Publikovat znovu",
        LiveUntil: "Aktivní do {{dateTime}}",
        Unpublish: "Deaktivovat",
      },
      Messages: {
        PublishSuccess: "Story bylo publikováno",
        PublishError: "Publikování se nezdařilo",
        DeleteSuccess: "Story bylo smazáno",
        DeleteError: "Smazání se nezdařilo",
        DeleteConfirmTitle: "Smazat story?",
        DeleteConfirm: "Story bude trvale odstraněno.",
        LockedWhileLive:
          "Aktivní story nelze upravovat, dokud nevyprší nebo není deaktivováno.",
        UnpublishSuccess: "Story bylo deaktivováno",
        UnpublishError: "Deaktivace story se nezdařila",
        UnpublishConfirmTitle: "Deaktivovat story?",
        UnpublishConfirm:
          "Divákům zmizí okamžitě. Story můžete později upravit a znovu publikovat; opětovné publikování čerpá další slot z denního limitu autora.",
        NotLiveAnymore: "Story už není aktivní, seznam byl obnoven",
      },
      Form: {
        CreateTitle: "Nové story",
        EditTitle: "Upravit story",
        SaveAndPublish: "Uložit a publikovat",
        SaveDraft: "Uložit jako koncept",
        Save: "Uložit",
        SaveSuccess: "Story bylo uloženo",
        SaveError: "Uložení se nezdařilo",
      },
    },
    PostStory: {
      StoryImage: "Obrázek story",
      StoryVideo: "Video story",
      Text: "Text",
      ButtonLabel: "Popisek tlačítka",
      ButtonUrl: "Odkaz tlačítka",
      SheetSection: "Detail nabídky",
      SheetTitle: "Název",
      SheetDescription: "Popis",
      SheetPrice: "Cena",
      SheetPriceNote: "Poznámka k ceně",
      SheetImage: "Obrázek nabídky",
      Form: {
        Format: {
          Title: "Formát",
          Subtitle: "Vyberte jeden — story je buď fotka, nebo video.",
          PhotoTitle: "Foto story",
          PhotoHint: "{{formats}} · zobrazí se na {{seconds}} sekund",
          VideoTitle: "Video story",
          VideoHint: "{{formats}} · nejvýše {{seconds}} sekund",
        },
        Media: {
          PhotoTitle: "Fotka",
          PhotoSubtitle:
            "Nejlépe vypadá na výšku 9:16. Nejvýše {{megabytes}} MB.",
          VideoTitle: "Video",
          VideoSubtitle:
            "Nejlépe vypadá na výšku 9:16. Nejvýše {{seconds}} sekund a {{megabytes}} MB.",
          PosterLabel: "Úvodní obrázek",
          PosterHint:
            "Nepovinné. Bez úvodního obrázku se story otevře na černém snímku, dokud se video nespustí.",
        },
        Text: {
          Title: "Text",
        },
        Button: {
          Title: "Tlačítko",
          Subtitle:
            "Zobrazí se na story a otevře tuto nabídku. Odkaz se použije na tlačítku uvnitř nabídky.",
          LabelPlaceholder: "např. Získat nabídku",
          UrlPlaceholder: "https://…",
        },
        Offer: {
          Subtitle: "Připojte ke story nabídku z marketplace.",
          Attach: "Připojit nabídku",
          Remove: "Odebrat nabídku",
        },
      },
      LimitExceeded:
        "Dosáhli jste maximálního počtu story za posledních 24 hodin. Zkuste to prosím později.",
      UsageLabel:
        "Publikovaná story za posledních 24 hodin: {{used}} / {{limit}}",
      Validation: {
        MediaRequired: "Story musí obsahovat obrázek nebo video",
        ButtonUrlInvalid: "Zadejte platný odkaz začínající https://",
        ButtonLabelRequired:
          "Nabídka potřebuje popisek tlačítka, kterým se otevře",
      },
    },
  },
  Common: {
    LoadMore: "Načíst další",
    BackToMoone: "Zpět do {{appName}}",
    DownloadError: "Stažení souboru se nezdařilo",
    SaveError: "Uložení se nezdařilo",
    UnknownUserType: "Neznámá role",
    Unsupported: "nepodporované",
    Retry: "Zkusit znovu",
    Restore: "Obnovit",
    TaxNumber: "DIČ",
    VatNumber: "IČ DPH",
    VatStatus: {
      [VatStatus.Unknown]: "Neověřeno",
      [VatStatus.NotRegistered]: "Není registrován k DPH",
      [VatStatus.Registered]: "Platné IČ DPH",
      [VatStatus.Payer]: "Plátce DPH",
      [VatStatus.RegisteredNonPayer]: "Identifikovaná osoba k DPH",
    },
    VatRegistryStatusLabel: "Stav v registru DPH",
    VatRegistryStatus: "Stav v registru DPH: {{status}}",
    VatRegistryUnavailableHint:
      "Registr DPH teď neodpověděl. IČ DPH můžete doplnit teď, nebo kdykoli později.",
    VatNumberRejectedByRegistry:
      "Toto IČ DPH registr DPH nezná. Zkontrolujte, zda je zadané správně — jinak bude plnění fakturováno s českou DPH.",
    Restart: "Restart",
    Loading: "Načítání",
    ThankYou: "Děkujeme",
    Disable: "Deaktivovat",
    Notes: "Poznámky",
    Copy: "Kopírovat",
    Status: "Stav",
    Balance: "Zůstatek",
    ComingSoon: "Obsah připravujeme",
    Month: "Měsíc",
    NotAvailable: "Není k dispozici",
    Verification: {
      Verified: "Ověřeno",
      NotVerified: "Neověřeno",
    },
    User: "Uživatel",
    AnonymousUser: "Uživatel {{appName}}",
    UnnamedChannel: "Bez názvu",
    SearchMinCharsHint:
      "Hledejte podle @přezdívky nebo jména, zadejte alespoň {{minChars}} znaky.",
    MoreOptions: "Další možnosti",
    RiskProfileStatus: {
      NotVerified: "Neověřeno",
      LowRisk: "Nízký",
      MediumRisk: "Střední",
      HighRisk: "Vysoký",
      Unacceptable: "Nepřijatelný",
    },
    UserType: {
      Hunter: "Hunter",
      Customer: "Uživatel",
      Merchant: "Obchodník",
      Admin: "Administrátor",
      Aml: "AML",
      Employee: "Zaměstnanec",
      CustomerOnboarding: "Onboarding zákazníků",
      HunterPlus: "Hunter+",
      AdminLite: "Admin (jen čtení)",
      Disponent: "Disponent",
      Child: "Dítě",
    },
    FacilityCategory: {
      Restaurants: "Restaurace",
      Food: "Jídlo",
      Car: "Auto",
      Electronics: "Elektronika",
      ClothingAndShoes: "Oblečení a obuv",
      HealthAndBeauty: "Zdraví a krása",
      Finance: "Finance",
      LeisureTime: "Volný čas",
      PhoneTvAndInternet: "Telefon, TV a internet",
      Housing: "Bydlení",
      Travel: "Cestování",
      Insurance: "Pojištění",
      Education: "Vzdělávání",
      Institutions: "Instituce",
      ConstructionAndMaintenance: "Stavebnictví a údržba",
      ECommerceAndOnlineServices: "E-commerce a online služby",
      PersonalServices: "Osobní služby",
      LegalAndConsultingServices: "Právní a poradenské služby",
      IndustrialProductionAndProcessing: "Průmyslová výroba a zpracování",
      Other: "Ostatní",
    },
    WeekDay: {
      Monday: "Pondělí",
      Tuesday: "Úterý",
      Wednesday: "Středa",
      Thursday: "Čtvrtek",
      Friday: "Pátek",
      Saturday: "Sobota",
      Sunday: "Neděle",
    },
    GeneralInfo: "Základní informace",
    Yes: "Ano",
    No: "Ne",
    Next: "Další",
    Close: "Zavřít",
    Open: "Otevřít",
    Clear: "Vymazat",
    Pause: "Pozastavit",
    Play: "Přehrát",
    Mute: "Ztlumit",
    Unmute: "Zapnout zvuk",
    BeneficialOwner: {
      Title: "Skutečný vlastník",
      Name: "Jméno",
      LastName: "Příjmení",
      Gender: "Pohlaví",
      BirthDate: "Datum narození",
      Nationality: "Státní příslušnost",
      IsForeigner: "Skutečný vlastník je cizinec",
    },
    Address: {
      Title: "Adresa",
      NoAddressAvailable: "Žádná dostupná adresa",
      Type: {
        [AddressType.Permanent]: "Trvalé bydliště",
        [AddressType.Mail]: "Korespondenční adresa",
        [AddressType.Headquarters]: "Sídlo",
      },
      Street: "Ulice",
      StreetNumber: "Číslo popisné",
      OrientationNumber: "Číslo orientační",
      PostalCode: "PSČ",
      Municipality: "Město",
    },
    Licenses: "Licence",
    QRPayment: "QR platba",
    ShareToBankApp: "Sdílet",
    AppName: "{{appName}}",
    Amount: "Částka",
    TotalAmount: "Celková částka",
    Note: "Poznámka",
    MandatoryNoteDescription:
      "Poznámku je nutné uvést! Bez poznámky nebude platba spárována.",
    Unknown: "Neznámý",
    UnknownRecipient: "Neznámý příjemce",
    ShowAll: "Zobrazit vše",
    ShowMore: "Zobrazit více",
    ShowLess: "Zobrazit méně",
    ShowProfile: "Zobrazit profil",
    VariableSymbol: "Variabilní symbol",
    Required: "Povinné pole",
    InvalidIBAN: "Neplatný IBAN",
    CancelEdit: "Zrušit úpravy",
    Cancel: "Zrušit",
    Confirm: "Potvrdit",
    UnsavedChangesTitle: "Neuložené změny",
    UnsavedChangesWarning:
      "Máte neuložené změny. Opravdu chcete zavřít formulář? Všechny neuložené údaje budou ztraceny.",
    DiscardChanges: "Zahodit změny",
    NiceDay: "Hezký den",
    Send: "Odeslat",
    Continue: "Pokračovat",
    FillMissing: "Vyplňte všechny povinné údaje",
    IncompleteSection: "Údaje v této sekci nejsou kompletní",
    FirstName: "Jméno",
    LastName: "Příjmení",
    Gender: "Pohlaví",
    PersonalNumber: "Rodné číslo",
    BirthPlace: "Místo narození",
    Nationality: "Státní příslušnost",
    OtherNationalities: "Další státní příslušnost",
    Number: "Číslo",
    Type: "Typ",
    IdentityDocument: "Doklad totožnosti",
    Contact: "Kontakt",
    Phone: "Telefon",
    PhoneVerified: "Telefon ověřen",
    PhoneVerificationDescription:
      "Prosím ověřte své telefonní číslo. Pomáhá to chránit {{appName}} před spamem a falešnými účty.",
    Remove: "Odebrat",
    Replace: "Nahradit",
    Optional: "nepovinné",
    Delete: "Odstranit",
    Edit: "Upravit",
    Verify: "Ověřit",
    BirthDate: "Datum narození",
    AccountNumber: "Číslo účtu",
    TransactionPaymentCode: "ID transakce",
    IBAN: "IBAN",
    Save: "Uložit",
    Saved: "Uloženo",
    DownloadQRCode: "Uložit QR kód",
    Email: "E-mail",
    Login: "Login",
    CompanyName: "Název subjektu",
    CompanyNumber: "IČO",
    PartyTypeLabel: "Forma podnikání",
    Back: "Zpět",
    PartyType: {
      [PartyType.LegalEntity]: "Právnická osoba",
      [PartyType.SelfEmployed]: "OSVČ",
      [PartyType.NaturalPerson]: "Fyzická osoba",
    },
    PartyTypeShortcut: {
      [PartyType.LegalEntity]: "PO",
      [PartyType.SelfEmployed]: "OSVČ",
      [PartyType.NaturalPerson]: "FO",
    },
    Sent: "Odesláno",
    UnknownDate: "Neznámé datum",
    Time: {
      TimePassed: {
        Now: "právě teď",
        Minute: "před minutou",
        Hour: "před hodinou",
        Day: "před dnem",
        Week: "před týdnem",
        Month: "před měsícem",
        Year: "před rokem",
        Minute_one: "před {{count}} minutou",
        Minute_few: "před {{count}} minutami",
        Minute_other: "před {{count}} minutami",
        Hour_one: "před {{count}} hodinou",
        Hour_few: "před {{count}} hodinami",
        Hour_other: "před {{count}} hodinami",
        Day_one: "před {{count}} dnem",
        Day_few: "před {{count}} dny",
        Day_other: "před {{count}} dny",
        Week_one: "před {{count}} týdnem",
        Week_few: "před {{count}} týdny",
        Week_other: "před {{count}} týdny",
        Month_one: "před {{count}} měsícem",
        Month_few: "před {{count}} měsíci",
        Month_other: "před {{count}} měsíci",
        Year_one: "před {{count}} rokem",
        Year_few: "před {{count}} lety",
        Year_other: "před {{count}} lety",
      },
      TimeRemaining: {
        Minute: "minuta",
        Hour: "hodina",
        Day: "den",
        Week: "týden",
        Month: "měsíc",
        Year: "rok",
        Minute_one: "{{count}} minuta",
        Minute_few: "{{count}} minuty",
        Minute_other: "{{count}} minut",
        Hour_one: "{{count}} hodina",
        Hour_few: "{{count}} hodiny",
        Hour_other: "{{count}} hodin",
        Day_one: "{{count}} den",
        Day_few: "{{count}} dny",
        Day_other: "{{count}} dny",
        Week_one: "{{count}} týden",
        Week_few: "{{count}} týdny",
        Week_other: "{{count}} týdnů",
        Month_one: "{{count}} měsíc",
        Month_few: "{{count}} měsíce",
        Month_other: "{{count}} měsíců",
        Year_one: "{{count}} rok",
        Year_few: "{{count}} roky",
        Year_other: "{{count}} let",
      },
    },
    Price: "Cena",
    License: "Licence",
    QRInstructions:
      "Neopisujte údaje ručně, využijte QR kód, který načtete ve vašem mobilním bankovnictví!",
  },
  CodeLists: {
    IdentificationList: {
      IDCard: "Občanský průkaz",
      Passport: "Pas",
      DrivingLicense: "Řidičský průkaz",
      Other: "Jiný",
    },
    IdentityDocumentVerdict: {
      NotChecked: "Nekontrolováno",
      Approved: "Schváleno",
      Declined: "Zamítnuto",
      InReview: "K ruční kontrole",
      Unavailable: "Kontrola nedostupná",
    },
  },
  Errors: {
    MissingId: "Chyba: žádné ID entity",
    DataLoadingError: "Data se nepodařilo načíst",
    RequestError:
      "Omlouváme se, ale něco se pokazilo, zkuste to prosím znovu později.",
    ApplicationError: {
      Title: "Nastala chyba",
      Home: "Domů",
      ErrorOccurred: "Je nám líto, ale v aplikaci došlo k chybě",
      TeamHasBeenInformed:
        "Naši programátoři již o chybě byli informování a na opravě už pracují.",
      AreYouDeveloper: "Jste programátor? Koukněte v čem byla chyba.",
    },
    Error404: {
      Subtitle: "Stránka nebyla nalezena",
      Home: "Domů",
    },
    Error403: {
      Subtitle: "K zobrazení této stránky nemáte přístupová práva",
    },
    NoUserRole: "Chyba, uživatel nemá přiřazenou žádnou roli",
    UnknownError: "Nastala neznámá chyba",
  },
  Offline: {
    Title: "Jste offline",
    NoInternet: "Zkontrolujte připojení k internetu a zkuste to znovu.",
    ServerUnreachable: {
      Title: "Potíže s připojením k serveru",
      Message:
        "Server {{appName}} je momentálně nedostupný. Omlouváme se za komplikace, na vyřešení technických potíží pracujeme.",
    },
    Reconnected: "Připojení obnoveno",
  },
  SignIn: {
    Title: "Přihlášení",
    Form: {
      Controls: {
        SignInButtonLabel: "Přihlásit",
        CancelButtonLabel: "Zrušit",
        ForgottenPassword: "Zapomněli jste heslo?",
      },
      Fields: {
        Email: "E-mail",
        Password: "Heslo",
      },
    },
    Error: {
      General: "Nastala chyba",
      Forbidden: "Špatné heslo nebo e-mail",
      InvalidLogin: "Špatné heslo nebo e-mail",
      InvalidCredentials: "Špatné heslo nebo e-mail",
      ApplicationVerification: "Špatné heslo nebo e-mail",
      PhoneNumberNotFound: "Telefonní číslo nebylo nalezeno",
      SmsSendingFailed: "Selhalo posílání SMS",
      InvalidToken: "Nevalidní token",
      AccountNotFound: "Špatné heslo nebo e-mail",
      NotFound: "Špatné heslo nebo e-mail",
      AccountIsDeactivated:
        "Účet byl deaktivován. Jestli chcete účet obnovit, kontaktujte podporu.",
      AccountLinkedToIdentity:
        "Tento účet byl převeden pod váš hlavní účet. Přihlaste se prosím e-mailem, který používáte jako hlavní účet.",
    },
  },
  SignUp: {
    Title: {
      Merchant: "Nový business účet",
      Customer: "Nový osobní účet",
      Hunter: "Nový hunter účet",
    },
    Form: {
      Controls: {
        SignUpButtonLabel: "Vytvořit účet",
      },
      Fields: {
        Login: "E-mail",
        Password: "Heslo",
        AgreeWithTermsAndConditions: {
          MooneLite: {
            Text: "Vytvořením účtu souhlasím s",
            LinkText: "obchodními podmínkami služby {{appName}} Lite",
            LinkUrl: "/content/terms/Moone-moone-lite.pdf",
          },
          EULACheckboxLabel: {
            StartText: "Registrací do aplikace {{appName}} uzavírám",
            ContractText: "Smlouvu o poskytování platebních služeb",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "se společností Mo.one a.s., jejíž součástí jsou tyto",
            RelatedDocsText: "Související podmínky",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
          HunterEULACheckboxLabel: {
            StartText: "Objednáním a zaplacením licence uzavírám",
            ContractText: "Smlouvu o digitální franšíze",
            ContractUrl:
              "/content/terms/legione-hunters-franchise-contract.pdf",
            MiddleText: "s LEGI.ONE LTD., jejíž součástí jsou tyto",
            RelatedDocsText: "Související podmínky",
            RelatedDocsUrl: "/content/terms/2-hunters-related-terms.pdf",
          },
          FullMooneEULA: {
            StartText: "Vytvořením účtu souhlasím s",
            ContractText: "Smlouvou o poskytování platebních služeb",
            ContractUrl:
              "/content/terms/2A-Moone-precontract-contract-info.pdf",
            MiddleText: "se společností Mo.one a.s., jejíž součástí jsou tyto",
            RelatedDocsText: "Související podmínky",
            RelatedDocsUrl: "/content/terms/2B-Moone-related-docs.pdf",
          },
        },
      },
    },
    Error: {
      General: "Nastala chyba",
      UserExists: "Účet již existuje",
      WeakPassword:
        "Heslo musí mít alespoň 8 znaků, obsahovat jedno malé, jedno velké písmeno a jedno číslo",
    },
    AffiliateLandingDisclaimer: {
      Title: "Už máš účet Mo.one?",
      Body: "Pokud už účet máš, místo registrace se přihlas a předej svůj e-mail tomu, kdo tě zve — pošle ti pozvánku přímo do schránky v aplikaci.",
      SignInButton: "Přihlásit se",
    },
  },
  Validation: {
    InvalidLogin: "Login není validní",
    InvalidPersonalNumber: "Neplatné rodné číslo",
    OtherNationalitySameAsPrimary:
      "Další státní příslušnost musí být jiná než hlavní",
    InvalidVatNumber: "Neplatný tvar IČ DPH",
    PersonalNumber:
      "Rodné číslo musí mít maximálně {{count}} číslic, číslo zadejte bez lomítka",
    CompanyName: "Název subjektu je povinný",
    CompanyNumber: "IČO musí mít {{count}} číslic",
    Phone: {
      InvalidFormat: "Neplatný formát telefonního čísla",
      MinDigits: "Telefonní číslo musí obsahovat alespoň {{count}} číslic",
      MaxCharacters: "Telefonní číslo nesmí obsahovat více než {{count}} znaků",
    },
    Required: "Povinné pole",
    InvalidEmail: "E-mail je nevalidní",
    InvalidUrl: "URL adresa není platná",
    Password: {
      Match: "Hesla se musí shodovat",
      MatchRequirement: "Hesla se shodují",
      Required: "Vyplňte heslo",
      MinLength: "Alespoň {{length}} znaků",
      MinLowercase: "Alespoň jedno malé písmeno",
      MinUppercase: "Alespoň jedno velké písmeno",
      MinNumber: "Alespoň jedno číslo",
    },
    EulaAgreement: "Musíte souhlasit s obch. podmínkami",
    WalletAddress: "U vlastní peněženky musíte vyplnit její adresu.",
    InvalidBankAccount: "Neplatný bankovní účet",
    InvalidPostalCode: "Zadejte PSČ ve formátu 763 02",
    ResidenceRequired:
      "Doplňte místo bydliště osoby — ulici nebo číslo domu, obec a PSČ",
    ExpirationAfterScheduled: "Datum expirace musí být po naplánovaném datu",
    DateMustBeInFuture: "Datum musí být v budoucnosti",
    TimeMustBeInFuture: "Čas musí být v budoucnosti",
    MaxLength: "Toto pole nesmí obsahovat více než {{count}} znaků",
  },
  ValidationMessages: {
    Required: "Toto pole je povinné",
    ArrayMinOne: "Musí být vybrána alespoň jedna možnost",
    TooSmallString: "Musí obsahovat alespoň {{minimum}} znaků",
    TooBigString: "Nesmí obsahovat více než {{maximum}} znaků",
    InvalidEmail: "Zadejte platnou e-mailovou adresu",
    InvalidUrl: "Zadejte platnou URL adresu",
  },
  Menu: {
    BottomMenuItems: {
      Overview: "Přehled",
      History: "Transakce",
      InitiateKeypadPayment: "Pokladna",
      ActionButton: "Zaplatit",
      Accounts: "Účty",
      Settings: "Více",
      Merchants: "Obchodníci",
      Licenses: "Licence",
      NewMerchant: "Obchodník",
      Users: "Uživatelé",
      Stardust: "Stardust",
      Valor: "Valor",
      Settlement: "Vyúčtování",
      ThanksToYou: "Díky tobě!",
      NotificationsManagement: "Notifikace",
      ToBeVerified: "K ověření",
      Hunters: "Hunteři",
      WhereToPay: "Kde platit",
      Chat: "Chat",
    },
    Help: "Nápověda",
    Logout: "Odhlásit se",
  },
  Onboarding: {
    ProcessTitle: "Informace o Vás",
    Title: "Ověřte svou totožnost",
    LoadingTitle: "Informace o Vás",
    ErrorTitle: "Chyba aplikace",
    BeneficialOwnersTitle: "Skuteční majitelé",
    LicenseSelectionTitle: "Vítejte v Legi.one",
    ManualLicensePaymentTitle: "Platba licence",
    BankAccountVerificationTitle: "Ověření účtu",
    PoliticallyExposed: {
      Title: "Jsem politicky exponovaná osoba",
      Alert:
        "Politicky exponovaným osobám bohužel zatím nemůžeme službu poskytnout.",
    },
    HunterDescription: {
      IdentityVerification:
        "Než spolu oficiálně začneme, potřebujeme ověřit tvoji totožnost.",
      HCRMDescription:
        "HCRM (Hunter & Customer Relationship Manager) je tvé osobní pracovní prostředí v rámci Legi.one.",
      RemoteContract:
        "Odsud budeš registrovat nové obchodníky, sledovat svou síť, spravovat odměny a mít přehled o všem důležitém. Je to tvoje digitální základna.",
      DocumentSecurity:
        "Protože spolu uzavíráme smlouvu na dálku, potřebujeme si ověřit, že jsi to opravdu ty.",
      QuickProcess:
        "Je to stejný princip, jako když podepisuješ smlouvu s operátorem nebo finanční službou online – bez osobního setkání je ověření nezbytné.",
      Welcome: "Vítej v Legi.one HCRM!",
      IdentityVerificationRequired:
        "Než spolu oficiálně začneme, potřebujeme ověřit tvoji totožnost.",
      HCRMWorkEnvironment:
        "Odsud budeš registrovat nové obchodníky, sledovat svou síť, spravovat odměny a mít přehled o všem důležitém. Je to tvoje digitální základna.",
      RemoteContractVerification:
        "Protože spolu uzavíráme smlouvu na dálku, potřebujeme si ověřit, že jsi to opravdu ty.",
      VerificationPrinciple:
        "Je to stejný princip, jako když podepisuješ smlouvu s operátorem nebo finanční službou online – bez osobního setkání je ověření nezbytné.",
      QuickProcessAndWelcome:
        "Stačí minuta – a pak můžeš začít naplno využívat všechny funkce HCRM. Vítej v týmu!",
    },
    MerchantOrCustomerDescription: {
      Welcome: "Vítejte v {{appName}}!",
      IdentityVerificationRequired:
        "Než Vám otevřeme účet, potřebujeme ověřit Vaši totožnost.",
      MoonePaymentIdentity:
        "{{appName}} není jen aplikace – je to vaše platební identita.",
      PaymentIdentityDescription:
        "Díky ní budete platit, potvrzovat transakce a bezpečně se prokazovat napříč službami. Proto je důležité ověřit, že jste to skutečně vy.",
      LicensedPaymentInstitution:
        "Jsme licencovaná platební instituce pod dohledem České národní banky.",
      BankLevelIdentityVerification:
        "Při ověřování totožnosti pro nás platí stejná pravidla jako pro banky – ukládá nám je zákon č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu.",
      DocumentsUsagePurpose:
        "Vaše doklady slouží výhradně k tomuto účelu. Jsou šifrované, chráněné a nikdy je nepoužijeme jinak bez vašeho výslovného souhlasu.",
      QuickProcessAndThankYou:
        "Zvládnete to za minutu – a pak můžete {{appName}} začít naplno využívat. Díky, že nám důvěřujete.",
    },
    Steps: {
      Documents: {
        NoOwningPartyError: "Nepodařilo se načíst údaje o uživateli",
        Declined: {
          Title: "Doklad neprošel automatickou kontrolou",
          Description:
            "Zkuste doklad vyfotit znovu (ne sken ani snímek obrazovky), nebo pokračujte – doklad pak ověří náš operátor ručně.",
          Retry: "Nahrát znovu",
          Continue: "Pokračovat s ruční kontrolou",
          AttemptsLeft: "Zbývající počet pokusů: {{count}}",
          AttemptsExhausted:
            "Automatickou kontrolu už nelze opakovat. Pokračujte dalším krokem, doklad ověří náš operátor.",
          Reasons: {
            DocumentExpired: "Doklad má prošlou platnost.",
            NotOriginal:
              "Nejde o fotografii fyzického dokladu (sken, kopie nebo snímek obrazovky).",
            Unreadable:
              "Doklad je nečitelný – vyfoťte ho celý, ostře a bez odlesků.",
            Unsupported: "Tento typ dokladu neumíme automaticky ověřit.",
            Generic: "Automatická kontrola doklad nepotvrdila.",
          },
        },
        ExistingDocumentsInfo:
          "Vaše doklady jsou již nahrány a probíhá jejich zpracování. Můžete pokračovat dalším krokem.",
        LoadingError: "Nepodařilo se načíst údaje, zkuste to prosím později.",
        Processing: "Zpracováváme údaje. Chvilinku strpení.",
        ProcessingFailed: "Nepodařilo se zpracovat údaje z občanského průkazu",
        FirstDocumentTitle: "Občanský průkaz",
        SecondDocumentTitle: "Druhý doklad",
        SecondDocumentDescription:
          "Druhým dokladem může být řidičský průkaz nebo cestovní pas.",
        Forms: {
          DocumentTitle: "Nahrát sken dokladu",
          DocumentDescription: "Klikněte zde pro nahrání nebo vyfocení",
          FrontSide: "Přední strana občanského průkazu",
          BackSide: "Zadní strana občanského průkazu",
          SecondDocumentFrontSide: "Přední strana druhého dokladu",
          SecondDocumentBackSide: "Zadní strana druhého dokladu",
          SecondDocumentTypeLabel: "Typ druhého dokladu",
          SecondDocumentTypePassport: "Cestovní pas",
          SecondDocumentTypeDrivingLicense: "Řidičský průkaz",
          SecondDocumentTypeOther: "Jiný",
        },
        Validations: {
          ForegroundMissing: "Nahrajte prosím přední stranu občanského průkazu",
          BackgroundMissing: "Nahrajte prosím zadní stranu občanského průkazu",
          SecondForegroundMissing:
            "Nahrajte prosím přední stranu druhého dokladu",
          SecondBackgroundMissing:
            "Nahrajte prosím zadní stranu druhého dokladu",
          SecondDocumentTypeMissing: "Vyberte prosím typ druhého dokladu",
        },
      },
      PersonalInformation: {
        SaveError: "Chyba při ukládání údajů",
        LoadingError: "Chyba při načítání údajů",
        Title: "Z nahraných dokladů jsme vyčetli následující údaje:",
        DataConfirmation: "Potvrzuji správnost základních údajů a adresy",
        StardustParticipation: {
          Text: "Souhlasím se zařazením do věrnostního programu",
          LinkText: "Stardust",
          LinkUrl: "/content/terms/Moone-stardust-general.pdf",
        },
        ThanksToYouParticipation: {
          Text: "Souhlasím se zařazením do programu doporučení",
          LinkText: "Díky Tobě!",
        },
        FormGroups: {
          PersonalInformation: "Základní údaje",
          Address: "Adresa",
          IdentityDocument: "Doklad totožnosti",
        },
        DocumentValidity: {
          Generic: "Platnost dokladu",
          From: "Platnost dokladu od",
          To: "Platnost dokladu do",
        },
        ScanIncomplete:
          "Některé hodnoty se nepodařilo načíst, bude provedena kontrola naším pracovníkem.",
        DataMarkedAsIncorrect:
          "Děkujeme za informaci, do 24h bude provedena kontrola našim pracovníkem.",
        DocumentIssued: "Doklad vydal",
        StreetAddress: "Ulice",
        ConfirmDataRequest: "Musíte potvrdit správnost údajů",
        UseCompanyAddress: "Bydlím na adrese sídla firmy",
        ValueLabels: {
          PersonalInfo: {
            FirstName: "Jméno",
            LastName: "Příjmení",
            PersonalNumber: "Rodné číslo",
            BirthPlace: "Místo narození",
            Gender: "Pohlaví",
            Nationality: "Státní příslušnost",
          },
          AddressInfo: {
            StreetWithNumber: "Ulice a č.p.",
            Municipality: "Město",
            PostalCode: "PSČ",
          },
          DocumentInfo: {
            Type: "Typ",
            Number: "Číslo",
            Validity: "Platnost",
            Issued: "Vydal",
          },
        },
      },
      FinalStep: {
        SubmitButton: "Dokončit",
        LoadingError: "Chyba, nepodařilo se načíst potřebná data.",
        SuccessToast: "Vaše údaje byly úspěšně odeslány.",
        Form: {
          HasNonEUResidence:
            "Mám aktuálně (ke dni registrace) bydliště mimo EU po dobu delší než 12 měsíců",
          HasNonEUNationality: "Jsem státním příslušníkem jiné země mimo EU",
        },
      },
    },
    BusinessOnboarding: {
      Steps: {
        LicenseSelection: {
          Title: "Vítejte v Legi.one",
          Description:
            "Koupí licence získáváte právo stát se hunterem pro Legi.one.",
          AlreadyOwned: "Tuto licenci již vlastníte.",
          Form: {
            PriceIncludesVAT: "Uvedené ceny jsou včetně 21% DPH.",
            ChooseLicense: "Vyberte verzi licence, kterou si chcete zakoupit.",
            WalletCheckboxLabel: "Chci poslat do vlastní peněženky",
            PrivateWalletAddress: "Adresa peněženky",
            PrivateWalletAddressDescription:
              "Zadejte adresu své peněženky na Polygon blockchain.",
            NoLicensesAvailableForCountry:
              "Pro zvolenou zemi již nejsou k dispozici žádné dostupné licence.",
            SelectCountryFirst: "Pro objednávku licence nejprve vyberte zemi.",
            SubmitButton: "Objednat a zaplatit",
            SeePaymentDetails: "Zobrazit platební údaje",
            AlreadyOrdered: "Tuto licenci jste si již objednali.",
          },
        },
        BankAccount: {
          Title: "Připojení účtu",
          AvailableBanks: "Nabídka bank",
          BanksComingSoon: "Banky, které připravujeme",
        },
        FacilityCompletion: {
          Title: "Údaje o provozovně",
          Description:
            "Doplňte prosím údaje o svých provozovnách. Vyplňte adresu, kontaktní údaje a další potřebné informace. Pokud nemáte provozovnu, tento krok přeskočte a klikněte dole na Pokračovat.",
          IncompleteFacilitiesWarning:
            "Údaje některých provozoven nejsou kompletní. Doplňte prosím všechny údaje, nebo nekompletní provozovny odstraňte.",
          OrbitLFacilityRequiredWarning:
            "Pro aktivaci terminálu je nutné přidat provozovnu s fotografiemi.",
          ContinueWithoutFacility: "Pokračovat bez provozovny",
        },
        OwnerModal: {
          Title: "Informace o skutečném majiteli",
        },
        BeneficialOwners: {
          SaveError: "Chyba při ukládání údajů o majiteli",
          Title: "Skutečný majitel",
          Question: "Jste jediným skutečným majitelem firmy?",
          SecondaryQuestion: "Víte, kdo jsou skuteční majitelé?",
          Description:
            "Skutečným majitelem je každá fyzická osoba, která v konečném důsledku tzv. vlastní nebo kontroluje právnickou osobu nebo právní uspořádání",
          CheckboxTitle: "Jsem skutečný majitel",
          CheckboxDescription:
            "Skutečným majitelem je každá fyzická osoba, která v konečném důsledku tzv. vlastní nebo kontroluje právnickou osobu nebo právní uspořádání",
          OwnersTitle: "Další skuteční majitelé",
          AddOwner: "Přidat skutečného majitele",
          AddNextOwner: "Přidat dalšího skutečného majitele",
          UboChoice: {
            IAmOwner: "Ano, jsem",
            IAmOwnerDescription:
              "Údaje o skutečném majiteli budou automaticky vyplněny z Vašeho profilu",
            NotTheOnlyOwner: "Ne / Je nás více",
            ManualEntry: "Ano, vložit",
            ManualEntryDescription:
              "Zadejte údaje o skutečných majitelích ručně",
            Unknown: "Nevím",
            UnknownDescription: "Informace bude ověřena naším AML specialistou",
          },
          FormGroups: {
            BasicInformation: "Základní údaje",
            Address: "Adresa",
          },
        },
        IncomeInformation: {
          SaveError: "Chyba při ukládání údajů o příjmech",
          Title: "Informace o Vás",
          FormGroups: {
            Business: "Vaše podnikání",
            Personal: "Údaje o Vás",
          },
          Fields: {
            BusinessActivity: "Předmět podnikání",
            SourceOfIncome: "Zdroj příjmů",
            RelationType: "Vaše pozice",
            IsPoliticallyExposedPerson: "Jsem politicky exponovaná osoba",
            HasNonEUResidence:
              "Mám aktuálně (ke dni registrace) bydliště mimo EU po dobu delší než 12 měsíců",
            HasNonEUNationality: "Jsem státním příslušníkem jiné země mimo EU",
            ExpectedMonthlyRevenue: "Očekávaný měsíční objem",
            AverageTransactionValue: "Průměrná hodnota jedné transakce",
            TaxResidencyCountry: "Daňová rezidence",
            OtherBusinessActivity: "Upřesněte předmět podnikání",
            OtherSourceOfIncome: "Upřesněte zdroj příjmů",
          },
        },
        BusinessInformation: {
          SaveError: "Chyba při ukládání údajů o podnikatelském subjektu",
          CompanyNumberAresMismatch:
            "Zadané IČO se neshoduje s daty subjektu z registru firem",
          CompanyNumberAlreadyInUse:
            "Toto IČO je již registrováno jiným obchodníkem",
          LoadingError: "Data osoby se nepodařilo načíst.",
          Title: "Informace o podnikání",
          RegionLabel: "Země registrace",
          SlovakVatRegistrationNotice:
            "Upozornění k IČ DPH: Pokud jste zdanitelná osoba se sídlem na Slovensku a přijímáte službu od dodavatele z jiného členského státu, jste podle § 7a zákona č. 222/2004 Z. z. o DPH povinni požádat o registraci k dani ještě před přijetím první takové služby. Registrace podle § 7a z vás nedělá plátce DPH. Pokud nám platné IČ DPH neuvedete, bude plnění fakturováno s českou DPH, kterou si na Slovensku nemůžete odečíst ani požádat o její vrácení.",
          FormGroups: {
            BasicInformation: "Základní údaje",
            Headquarters: "Sídlo",
            Contact: "Kontakt",
          },
        },
      },
    },

    BanksInPreparation: "Banky, které připravujeme",
    PotentialYearlySavings: "Potenciální roční úspora",
  },
  Transactions: {
    Title: "Transakce",
    History: "Historie",
    NoTransactions: "Nejsou k dispozici žádné transakce.",
    CancelTransaction: "Zrušit transakci",
    RefundTransaction: "Vrátit platbu",
    TransactionCancelError: "Nastala chyba při zrušení transakce.",
    InverseTransactionCreated:
      "Byla vytvořena inverzní transakce, kterou je nutné potvrdit z uživatelského účtu obchodníka.",
    Payment: {
      Incoming: "Příchozí platba",
      Outgoing: "Odchozí platba",
      Unknown: "Platba",
    },
    Type: {
      Buy: "Nákup",
      Sell: "Prodej",
      Withdrawal: "Výběr",
      LeadReward: "Odměna za doporučení",
      LeadRewardConsumer: "Odměna za registraci",
      Voucher: {
        GiftCard: "Dárková karta",
        SignUpSubsidy: "Dárek k registraci",
      },
      Coinback: "Coinback",
    },
    ErrorPayment: {
      Title: "Nastala chyba",
      TitleNotCompleted: "Platba nebyla dokončena",
      Description: "Je nám to líto, ale během platby došlo k problému.",
    },
    SuccessPayment: {
      Title: "Úspěšně zaplaceno!",
      DescriptionFirstLine: "Peníze byly úspěšně odeslány",
      DescriptionSecondLine: "na obchodníkův účet.",
    },
    Anonymous: {
      DownloadReceipt: "Stáhnout účtenku do zařízení",
      FillEmail: "Zadejte e-mail, abychom Vám mohli zaslat účtenku.",
      SignupTitle: "Vytvořte si účet a využívejte výhody {{appName}}",
      Benefits:
        "✨ Sbírej Stardust a vydělávej s {{appName}}<newline/>🤝 Pomoz svým lokálním obchodníkům<newline/>💳 Rychlá platební metoda vždy po ruce<newline/>📖 Historie transakcí a finance na jednom místě",
      CampaignSignupTitle:
        "Vytvořením účtu se přidáš do týmu {{campaignName}} a pomáháš každou platbou!",
      CampaignSignupDescription:
        "Vyber si jednu z dostupných možností vytvoření účtu, zaregistruj se na jedno kliknutí a plať s Mo.one.",
      CreateAccountViaEmail: "Vytvořit účet přes E-mail",
      JustWantReceipt: "Chci jen účtenku",
      BackToSignup: "Zpět k vytvoření účtu",
      LoadingSkeleton: {
        loadingInfo: {
          title: "Ověření platby",
          description:
            "Probíhá kontrola platby<newline/>Načítáme informace o této platbě",
        },
        processingTransaction: {
          title: "Probíhá zpracování",
          description:
            "Vaše platba se zpracovává<newline/>Čekáme na potvrzení od Vaší banky",
        },
      },
    },
    Status: {
      Completed: "Provedeno",
      PendingTrade: "Zpracovává se",
      PendingPayout: "Čeká na potvrzení eshopem",
      WithdrawRequested: "Probíhá výběr",
      Withdrawn: "Provedeno",
    },
    TransactionStatus: {
      Created: "Čeká na zaplacení",
      Cancelled: "Zrušená",
      Fail: "Selhala",
      Initiated: "Platba zahájena",
      Processing: "Probíhá zpracování",
      Success: "Úspěšně dokončena",
      InvestigationNeeded: "Neznámý stav",
    },
    RefundState: {
      Title: "Vratka",
      Refunded: "Refundováno",
      Pending: "Čeká na vrácení",
    },
    TransactionDirection: {
      Incoming: "Příchozí platba",
      Outgoing: "Odchozí platba",
      IncomingRefund: "Příchozí vrácení platby",
      OutgoingRefund: "Odchozí vrácení platby",
      Unknown: "Neznámý směr",
    },
    BankTransferInfo:
      "Bankovní převod může trvat až 2 pracovní dny, záleží na rychlosti banky.",
    TransactionStatusDescription: {
      Created: "Tato transakce čeká na zaplacení.",
      Cancelled: "Tato transakce byla zrušena.",
      Fail: "Transakce selhala.",
      Initiated: "Platba byla zahájena, čekáme na potvrzení.",
      Processing: "Transakce se právě zpracovává.",
      Success: "Tato transakce byla úspěšně dokončena.",
      InvestigationNeeded: "Neznámý stav",
    },
    ReceiptOnly: "Chci jen účtenku",
  },
  SetPassword: {
    Error: {
      General: "Nastala chyba.",
      TokenNotFound: "Token je navalidní",
      TokenExpired: "Platnost odkazu pro nastavení hesla vypršela.",
      TokenExpiredLinkText: "Požádat o nový odkaz",
      WeakPassword:
        "Heslo musí mít alespoň 8 znaků, obsahovat jedno malé, jedno velké písmeno a jedno číslo",
    },
  },
  BankIDVerification: {
    Error: {
      General:
        "Autentifikace přes BankID se nezdařila. Zkuste to prosím znovu.",
      BankIDUserInfoError: "Nepodařilo se získat data z BankID.",
      VerificationAlreadyExists: "Uživatel z BankID byl již ověřen.",
    },
  },
  Voucher: {
    ApplyError: {
      General: "Nastala chyba",
      NotFound:
        "Zadaný kód není správný. Zkontrolujte, zda je správně opsaný. Pokud problémy přetrvávají, kontaktujte nás.",
      Applied: "Kupon byl použit",
      UserAccountNotFound: "Uživatel nenalezen",
      UserNotFound: "Uživatel nenalezen",
      UserIsWaitingForEmailVerification: "Uživatel nenalezen",
      InvalidRecaptcha:
        "Recaptcha není validní. Refreshnite aplikaci a zkuste to znovu.",
    },
    ToOverview: "Na přehled",
    SignIn: "Přihlásit",
    AgreeWith: "Souhlasím s",
    Continue: "Pokračovat",
    CardCodeInstructions: "2. Opište 16 místný kód z karty",
  },
  Balance: {
    Title: "Přehled",
    BalanceContent: {
      Title: "Dostupné prostředky",
      PayMeAction: "Zaplať mi",
      SendPaymentAction: "Platba",
      HiddenBalance:
        "Pro zobrazení zůstatku dokončete registraci a vyčkejte na ověření Vašeho účtu",
      ShowBalance: "Zobrazit zůstatek",
      HideBalance: "Skrýt zůstatek",
      CurrencyCount: "{{count}} měn",
      CurrencyCount_one: "{{count}} měna",
      CurrencyCount_few: "{{count}} měny",
      CurrencyCount_other: "{{count}} měn",
      CurrencySheetTitle: "Moje měny",
    },
  },
  Banking: {
    Auth: {
      Title: "Připojit účet",
      Description: "Vyberte si banku, kterou chcete připojit.",
      BankList: {
        Title: "Nabídka bank",
        ComingSoon: "Připravujeme",
      },
      BankConnectionInfo:
        "Připojení banky je jednorázový proces, připojte banku a používejte {{appName}} platby neomezeně!",
      BankConnectionWarning:
        "Upozornění: Kvalita připojení závisí na bankách. Pokud máte problém s přihlášením či platbou, kontaktujte svou banku.",
    },
    AccountSelection: {
      Title: "Připojení {{bankName}}",
      Description:
        "Pokud některé z připojených účtů s {{appName}} používat nechcete, odeberte je ze seznamu níže.",
      DeleteLaterInfo:
        "Účty můžete odebrat i později v záložce Více\u00A0→\u00A0Bankovní účty.",
      Cancel: "Zrušit",
      Confirm: "Potvrdit",
      AccountsSetUp: "Nastavení účtů bylo dokončeno",
      RemoveError: "Chyba při odebírání účtů",
      SelectedAccounts: "Vybrané účty",
      AllAccounts: "Všechny účty",
      WarningMessage:
        "Můžete připojit pouze účet vedený pod Vaším jménem. Pokud připojíte cizí účet, bude ze strany {{appName}} zamítnut.",
    },
    BanksInPreparation: "Banky, které připravujeme",
    QRPaymentForeignBank: "Platba cizí bankou pomocí QR kódu",
    BatchPayments: {
      Title: "Hromadné platby",
      DetailTitle: "Detail hromadné platby",
      EmptyList: "Zatím nebyly vytvořeny žádné hromadné platby.",
      NotFound: "Hromadná platba nebyla nalezena.",
      LoadMore: "Načíst další",
      Account: "Účet",
      TotalAmount: "Celková částka",
      PaymentCount: "Počet plateb",
      CreatedAt: "Vytvořeno",
      AuthorizedAt: "Autorizováno",
      CompletedAt: "Dokončeno",
      SignInBank: "Autorizovat v bance",
      PaymentsTable: "Platby",
      Columns: {
        Date: "Datum",
        Status: "Stav",
        Account: "Účet",
        PaymentCount: "Počet plateb",
        Total: "Celkem",
        Recipient: "Příjemce",
        IBAN: "IBAN",
        VS: "VS",
        Amount: "Částka",
      },
      Status: {
        Created: "Vytvořeno",
        Initiated: "Čeká na autorizaci",
        Processing: "Zpracovává se",
        Success: "Dokončeno",
        Fail: "Selhalo",
        Cancelled: "Zrušeno",
      },
    },
  },
  BankNames: {
    CSOB: "ČSOB",
    CSAS: "Česká spořitelna",
    KB: "Komerční banka",
    AirBank: "Air Bank",
    UCB: "UniCredit Bank",
    MONETA: "Moneta Money Bank",
    FIO: "Fio banka",
    MBank: "mBank",
    RB: "Raiffeisenbank",
    Citfin: "Citfin",
    TRINITY: "Trinity Bank",
    PenezniDum: "Peněžní dům",
    Artesa: "Artesa",
    CREDITAS: "CREDITAS",
    NEY: "NEY spořitelní družstvo",
    MaxBanka: "Max banka",
    NRB: "Národní rozvojová banka",
    JandT: "J&T Banka",
    PPF: "PPF banka",
    Oberbank: "Oberbank",
    PartnersBank: "Partners Banka",
    CNB: "Česká národní banka",
    Revolut: "Revolut",
    CZKT: "CZKT",
  },
  BankEnvironmentNames: {
    [BankEnvironment.CSOB_SANDBOX]: "ČSOB",
    [BankEnvironment.CSOB_PROD]: "ČSOB",
    [BankEnvironment.CSAS_SANDBOX]: "Česká spořitelna",
    [BankEnvironment.CSAS_PROD]: "Česká spořitelna",
    [BankEnvironment.KB_SANDBOX]: "Komerční banka",
    [BankEnvironment.KB_PROD]: "Komerční banka",
    [BankEnvironment.AirBank_SANDBOX]: "Air Bank",
    [BankEnvironment.AirBank_PROD]: "Air Bank",
    [BankEnvironment.UCB_SANDBOX]: "UniCredit Bank",
    [BankEnvironment.UCB_PROD]: "UniCredit Bank",
    [BankEnvironment.MONETA_SANDBOX]: "Moneta Money Bank",
    [BankEnvironment.MONETA_PROD]: "Moneta Money Bank",
    [BankEnvironment.FIO_SANDBOX]: "Fio banka",
    [BankEnvironment.FIO_PROD]: "Fio banka",
    [BankEnvironment.MBANK_SANDBOX]: "mBank",
    [BankEnvironment.MBANK_PROD]: "mBank",
    [BankEnvironment.RB_SANDBOX]: "Raiffeisenbank",
    [BankEnvironment.RB_PROD]: "Raiffeisenbank",
    [BankEnvironment.Citfin_PROD]: "Citfin",
    [BankEnvironment.TRINITY_PROD]: "Trinity Bank",
    [BankEnvironment.PenezniDum_PROD]: "Peněžní dům",
    [BankEnvironment.Artesa_PROD]: "Artesa",
    [BankEnvironment.CREDITAS_PROD]: "CREDITAS",
    [BankEnvironment.NEY_PROD]: "NEY spořitelní družstvo",
    [BankEnvironment.MaxBanka_PROD]: "Max banka",
    [BankEnvironment.NRB_PROD]: "Národní rozvojová banka",
    [BankEnvironment.JandT_PROD]: "J&T Banka",
    [BankEnvironment.PPF_PROD]: "PPF banka",
    [BankEnvironment.Oberbank_PROD]: "Oberbank",
    [BankEnvironment.PartnersBank_PROD]: "Partners Banka",
    [BankEnvironment.CNB_PROD]: "Česká národní banka",
    [BankEnvironment.Revolut_SANDBOX]: "Revolut",
    [BankEnvironment.Revolut_PROD]: "Revolut",
    [BankEnvironment.CZKT_SANDBOX]: "CZKT",
    [BankEnvironment.CZKT_PROD]: "CZKT",
  },
  BankRating: {
    Banks: {
      [Bank.CSOB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Pro připojení účtu je nutné kliknout na QR kód nebo znát uživatelské jméno a heslo<linebreak/> • Doručit push notifikaci ze Smart Klíče někdy trvá až 1 minutu<linebreak/> • Návrat z aplikace banky zpět do {{appName}} je nutné provést manuálně",
        HowToConnect:
          "Při připojení účtu přes mobilní telefon klikněte na QR kód, který vás přesměruje přímo do aplikace Smart Klíč. Pokud neobdržíte push notifikaci, otevřete Smart Klíč přímo z menu vašeho telefonu a potvrďte požadovanou akci (např. platbu) tam. Po připojení účtu/zaplacení klikněte na šipku zpět pro návrat ze Smart Klíče zpět do prostředí {{appName}}. Menší platby (zejm. do 500,- Kč) někdy nemusíte potvrzovat v aplikaci - v takovém případě posuňte webovou stránku úplně dolů a klikněte na zelené tlačítko vpravo dole.",
        Review:
          "API připojení od ČSOB hodnotíme jako průměrné. Při připojení účtu je nutno kliknout na QR kód, což pro některé uživatele může být matoucí. Texty na webu ČSOB se na telefonu zobrazují anglicky. Push notifikace z aplikace Smart Klíč se občas doručují s mnohavteřinovým zpožděním. Chybí automatické přesměrování zpět do prostředí {{appName}}. Pozitivně hodnotíme použití jednofaktorového ověření u menších plateb na ověřené účty, kdy platba proběhne velmi rychle.",
        Email: "ombudsman@csob.cz",
      },
      [Bank.CSAS]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Pro připojení účtu je nutné vyplnit Klientské číslo/Uživatelské jméno a datum narození<linebreak/> • Vrátit se z aplikace George zpět do {{appName}} je nutné provést manuálně",
        HowToConnect:
          "Před připojením účtu si ověřte, že máte po ruce své uživatelské jméno/klientské číslo, které používáte pro přihlášení do internetového bankovnictví. Po připojení účtu/zaplacení klikněte na šipku zpět pro návrat z George zpět do prostředí {{appName}}.",
        Review:
          "API připojení od České spořitelny hodnotíme jako kvalitní a poměrně stabilní. Push notifikace fungují správně a rychle. Pro připojení účtu musí uživatel vepsat uživatelské jméno/klientské číslo a datum narození, což mnohé uživatele může obtěžovat. Chybí automatické přesměrování z George zpět do prostředí {{appName}}.",
        Email: "ombudsman@csas.cz",
      },
      [Bank.KB]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Pro připojení účtu je nutné vyplnit uživatelské jméno a své telefonní číslo<linebreak/> • Návrat z aplikace banky zpět do {{appName}} je nutné provést manuálně<linebreak/> • Potvrzená platba se provede až po návratu uživatele zpět do prostředí {{appName}}!",
        HowToConnect:
          "Pro připojení účtu musíte zadat své uživatelské jméno, kterým se přihlašujete do internetového bankovnictví. <bold>Po potvrzení platby se musíte vrátit z aplikace banky zpět do prostředí {{appName}} - jinak platba neproběhne!</bold> Pokud používáte jak aplikaci KB+, tak i aplikaci KB Klíč (firemní bankovnictví), dojdou vám dvě notifikace - stačí když požadovanou akci (např. platbu) potvrdíte v kterékoli z nich.",
        Review:
          "API připojení od Komerční banky aktuálně hodnotíme jako uživatelsky nepřívětivé, až nefunkční. Pro připojení účtu musí uživatel vepsat uživatelské jméno a následně telefonní číslo, což mnohé může obtěžovat. Pro jednu akci vyskakují souběžně dvě notifikace (z aplikace KB+ i aplikace KB Klíč), což je značně matoucí. Chybí automatické přesměrování zpět do prostředí {{appName}}. Pokud se uživatel nevrátí z aplikace banky (KB+ nebo KB klíč) manuálně zpět do {{appName}}, již potvrzená platba neproběhne, což vnímáme jako zcela zásadní překážku - na problém jsme upozornili a děláme maximum pro to, aby jej banka odstranila.",
        Email: "ombudsman@kb.cz",
        NotRecommended: {
          Reason: "Podstatné porušení regulace ČNB.",
          WarningText:
            "Pokoušíte se připojit Komerční banku, která v aktuálním provedení porušuje regulaci České Národní Banky.<linebreak/><linebreak/>Připojením této banky si výrazně zkomplikujete placení přes {{appName}}. Zvažte prosím připojení jiné banky.",
          RiskItButton: "RISKNU TO S KB",
        },
      },
      [Bank.AirBank]: {
        Rating: "2.5",
        AdditionalInfo: "",
        Warnings:
          "• Neresponzivní zobrazení webu<linebreak/> • Doručit push notifikaci z aplikace MyAir někdy trvá déle <linebreak/> • Po připojení účtu odklikněte v MyAir všechna potvrzení<linebreak/> • Návrat z aplikace banky zpět do {{appName}} je nutné provést manuálně (iOS)",
        HowToConnect:
          "Pro připojení účtu klikněte na černé tlačítko “Přihlásit přes aplikaci”, které vás přesměruje přímo do aplikace MyAir. Pokud neobdržíte push notifikaci, otevřete MyAir přímo z menu vašeho telefonu a potvrďte požadovanou akci (např. platbu) tam. Díky neresponzivnímu zobrazení webu banky se může stát, že se na chvíli ztratíte - doporučujeme prstem posunovat na obrazovce, obrazovku si přiblížit a najít to správné pole či tlačítko. Po připojení účtu/zaplacení klikněte na šipku zpět pro návrat z MyAir zpět do prostředí {{appName}} (platí pro iPhone).",
        Review:
          "API připojení Air Bank hodnotíme jako jedno z lepších. Pro připojení účtu nemusíte zadávat uživatelské jméno či heslo. Za negativa považujeme neresponzivní zobrazení webu a problém s občasným pozdním doručením push notifikace. Přesměrování zpět do {{appName}} je pak doprovázeno zbytečným 5vteřinovým čekáním. Chybí automatické přesměrování zpět do prostředí {{appName}} (platí pro iPhone).",
        Email: "info@airbank.cz",
      },
      [Bank.UCB]: {
        Rating: "1.5",
        AdditionalInfo: "",
        Warnings:
          "• Aplikace SmartBanking je velmi pomalá<linebreak/> • Banka opakovaně žádá o udělení souhlasu s cookies<linebreak/> • Banka se před každou platbou dotazuje, zda se uživatel nachází na mobilu nebo počítači",
        HowToConnect:
          "Aplikace je pomalá, počkejte a nespěchejte - platbu po chvíli dokončíte. Před každou platbou musíte potvrdit, zda se nacházíte na počítači (Online Banking), mobilním telefonu (SmartBanking) nebo zda jste firemní zákazník (Corporate). Pokud po vás banka chce souhlas s cookies, musíte jej odkliknout.",
        Review:
          "API připojení od UniCredit Bank hodnotíme jako průměrné. Aplikace SmartBanking je velmi pomalá, což neúměrně prodlužuje celý proces platby. Negativně hodnotíme obtěžující dotazy na souhlas s cookies a neustálé dotazy, zda se uživatel zrovna připojuje z mobilního telefonu, z počítače či zda je korporátním zákazníkem. Zůstatek stavu účtu se aktualizuje jen 4x denně. Pozitivní je naopak připojování účtu přímo přes aplikaci SmartBanking bez nutnosti znát uživatelské jméno či heslo, a dále automatické přesměrování z aplikace banky zpět do prostředí {{appName}}.",
        Email: "info@unicreditgroup.cz",
      },
      [Bank.MONETA]: {
        Rating: "4.75",
        AdditionalInfo: "",
        Warnings:
          "Nic zásadního. Pokud ve flow narazíte na chybu, dejte nám vědět – MONETA s námi aktivně komunikuje a společně se pokusíme problém vyřešit.",
        HowToConnect:
          "Připojení bankovního účtu u MONETA provedete na jedno silné ověření a jeden klik, po potvrzení jste automaticky přesměrováni ze Smart Banky zpět do {{appName}}. Stejně hladce probíhá i platba – potvrdíte ji ve Smart Bance a aplikace vás sama vrátí do {{appName}}.",
        Review:
          "API připojení MONETA Money Bank prošlo v roce 2026 výrazným zlepšením a dnes patří k nejlepším na českém trhu. Připojení účtu i platba fungují na jedno silné ověření a jedno klepnutí, bez nadbytečných přihlášení a s automatickým návratem do {{appName}}. Z pohledu uživatelské zkušenosti jde o řádnou implementaci v souladu s regulací i výkladovým stanoviskem České národní banky RS 2025-28 ze dne 27. 11. 2025. Oceňujeme také, že MONETA na naše podněty reagovala a slíbenou opravu platebního flow dodala. Pokud byste přesto objevili chybu, nahlaste nám ji – banka s námi komunikuje a pokusí se ji odstranit.",
        Email: "ombudsmanproklienty@moneta.cz",
      },
      [Bank.FIO]: {
        Rating: "4.25",
        AdditionalInfo: "",
        Warnings:
          "Po připojení účtu i po potvrzení platby je potřeba klepnout na tlačítko „Hotovo“, teprve poté se vrátíte do {{appName}}. Stav platby se v {{appName}} načte s mírným zpožděním – chvíli vyčkejte, platba probíhá.",
        HowToConnect:
          "Připojení účtu i platbu potvrdíte přímo v aplikaci Fio banky, do které vás {{appName}} automaticky přesměruje. Po potvrzení klepněte na „Hotovo“ a budete přesměrováni zpět do {{appName}}.",
        Review:
          "API připojení Fio banky hodnotíme velmi pozitivně, a to na Androidu i iOS. Připojení účtu už nevyžaduje zadávání uživatelského jména a hesla a přesměrování přímo do aplikace Fio banky a zpět funguje spolehlivě na obou platformách. Oproti výkladovému stanovisku České národní banky RS 2025-28 ze dne 27. 11. 2025 zůstává ve flow jeden klik navíc – potvrzení tlačítkem „Hotovo“ – a stav platby se v {{appName}} načítá o něco pomaleji, než bychom si přáli. Jde o drobnosti, které Fio banku dělí od nejvyššího hodnocení. Pokud ve flow objevíte chybu, nahlaste nám ji.",
        Email: "fio@fio.cz",
      },
      [Bank.MBank]: {
        Rating: "0.5",
        AdditionalInfo: "",
        Warnings:
          "• Pro připojení účtu i provedení platby je nutné vyplnit číselný Identifikátor a heslo<linebreak/> • Před provedením platby je vždy vyžadováno přihlášení do mobilní aplikace mBank<linebreak/> • Návrat z mobilní aplikace mBank zpět do {{appName}} je nutné provést manuálně",
        HowToConnect:
          "Pro připojení účtu musíte znát svůj číselný Identifikátor a heslo. Pokud je nemáte, musíte si je vytvořit v internetovém bankovnictví mBank. Po potvrzení přihlášení v mobilní aplikaci mBank se vraťte zpět do prohlížeče a vyberte bankovní účet, který chcete do {{appName}} připojit. Před potvrzením platby se musíte opětovně přihlásit do mobilní aplikace mBank, proto vám platba s touto bankou prakticky vždy bude trvat o něco déle než u konkurence.",
        Review:
          'API připojení mBank vykazuje celou řadu překážek, které snižují naše hodnocení na pouhé půl hvězdičky. Připojení bankovního účtu do mBank znepříjemňuje nutnost znát číselný Identifikátor a heslo. Negativně hodnotíme nucené přihlašování do aplikace mBank před provedením platby, což proces platby neúměrně prodlužuje. Chybí automatické přesměrování zpět do prostředí {{appName}} - pokud nechcete čekat 15 vteřin na přesměrování, musíte klepnout na tlačítko "Rozumím".',
        Email: "kontakt@mBank.cz",
      },
      [Bank.RB]: {
        Rating: "2",
        AdditionalInfo: "",
        Warnings:
          "• Pro připojení účtu je nutné zadat klientské číslo<linebreak/> • Vrátit se z potvrzení platby zpět do {{appName}} je nutné provést manuálně",
        HowToConnect:
          "Pro připojení účtu musíte zadat své klientské číslo, které používáte pro přihlášení do internetového bankovnictví. Při potvrzování platby musíte nejdříve na webu banky klepnout na žluté tlačítko “Podepsat”, teprve poté se otevře aplikace. Po potvrzení platby klepněte pro návrat zpět do {{appName}} nejprve na šipku zpět a následně na tlačítko “Přesměrovat zpět do aplikace”.",
        Review:
          "API připojení Raiffeisenbank hodnotíme v současné konkurenci nadprůměrně. Oceňujeme rychlost platby a stabilitu doručení push notifikací. Proces platby zpomaluje potvrzování platby nadvakrát - jednou na webu Raiffesenbank klepnutím na žluté tlačítko “Podepsat” a podruhé v aplikaci banky. Chybí automatické přesměrování zpět do prostředí {{appName}} po provedení platby - musíte se proklikat zpět do Mo.one, jinak obchodník neuvidí, že platba byla skutečně zaplacena",
        Email: "reklamace@rb.cz",
      },
      [Bank.Citfin]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.TRINITY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PenezniDum]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Artesa]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CREDITAS]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NEY]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.MaxBanka]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.NRB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.JandT]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PPF]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Oberbank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.PartnersBank]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CNB]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.Revolut]: {
        Rating: "",
        AdditionalInfo: "",
        Warnings: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
      [Bank.CZKT]: {
        Rating: "",
        Warnings: "",
        AdditionalInfo: "",
        HowToConnect: "",
        Review: "",
        Email: "",
      },
    },
    NotRecommended: {
      Badge: "Nedoporučujeme",
      InfoboxTitle: "Nedoporučujeme",
      BetterButton: "Chci něco lepšího",
    },
    Title: "Hodnocení připojení bank",
    Description:
      "Obchodníkům a zákazníkům přinášíme jednoduché a pohodlné okamžité platby v kamenných obchodech i na internetu. Svůj systém a funkcionality neustále vylepšujeme.<linebreak/> Zážitek při platbě s {{appName}} je však přímo ovlivněn kvalitou napojení na technologii, kterou nám poskytují jednotlivé banky. Doporučujeme si proto předem nastudovat a vyzkoušet omezení, na která můžete u vaší banky narazit při připojení účtu nebo provedení platby. Společně s bankami na odstranění jednotlivých bariér pracujeme tak, aby do konce roku 2026 byl zážitek při platbě opravdu skvělý.<linebreak/> Zavedli jsme hodnotící systém, díky němuž se můžete podívat, jak si vaše banka stojí. Naše hodnocení se jmenuje “Miss API” a slouží jako pozitivní motivace pro banky, aby zlepšovaly své technologie a váš zážitek při platbě s {{appName}}. Pokud nebudete s kvalitou připojení své banky spokojeni, doporučujeme používat jinou banku s lepším hodnocením. Účet u jiné banky dnes založíte během pár minut a online z vašeho telefonu či počítače.",
    AccessibilityLabel: "Zobrazit hodnocení banky {{bankName}}",
    ContactUs: {
      PreText:
        "Pokud narazíte na další omezení, které není u vaší banky uvedeno, dejte nám to prosím vědět na",
      Email: "info@mo.one",
      PostText: "Vaší zpětné vazby si vážíme!",
    },
    Detail: {
      CurrentRating: "Aktuální hodnocení: {{rating}}/5.00",
      Titles: {
        Warning: "Pozor na:",
        HowToConnect: "Jak na to:",
        Review: "Hodnocení:",
        Email: "Pokud chcete věci změnit, ozvěte se ombudsmanovi vaší banky na",
      },
    },
  },
  Transfer: {
    FromAccount: "Vyber odchozí účet",
    ToAccount: "Vyber příchozí účet",
    Amount: "Zadej částku",
    Note: "Přidat poznámku",
    SubmitButton: "Převést",
    TransferButton: "Převést peníze",
    ConnectMoreAccounts: "Připojte další účet",
    NoBankAccountsError: "Nepodařilo se načíst bankovní účty.",
  },
  Merchant: {
    Employees: {
      Title: "Zaměstnanci",
    },
    LicenseShares: {
      Title: "Sdílení provize",
    },
    Payment: {
      LoadingError: "Údaje se nepodařilo načíst.",
      Title: "Dnešní tržba",
      InitiatePaymentButton: "Vyvolat platbu",
      InitiateKeypadPaymentButton: "PLATBA {{amount}}",
    },
    Initiate: {
      PaypointHasNoAccountError:
        "Na zvolený paypoint nelze provádět platby, protože nemá nastavený bankovní účet.",
      NoBankAccountsError: "Chyba - Nepodařilo se načíst bankovní účty.",
      ActiveTransactionConflict: {
        Title: "Konflikt transakcí",
        Message: "Na tomto paypointu je přiřazena aktivní transakce.",
        Description:
          "Můžete se buď vrátit zpět, a transakci vystavit na jiný paypoint, nebo původní transakci na tomto paypointu přepsat. Pokud transakci přepíšete, původní transakce bude zrušena.",
        OverwriteButton: "Přepsat existující",
        Overwriting: "Přepisování...",
      },
      ConnectBankAccountLink: {
        PreText: "Pokladnu můžete začít využívat až po",
        LinkText: "Nastavení primárního účtu.",
      },
      GenerateButton: "Generovat údaje",
      Form: {
        BusinessAccountSelectTitle: "Výběr podnikatelského účtu",
        PersonalAccountSelectTitle: "Vyberte účet pro přijetí platby",
      },
    },
    InitiateDetail: {
      MerchantInstructions:
        'Zaplatit můžete pomocí QR kódu, nebo vložením kódu transakce ve formuláři "Zaplatit".',
      CustomerInstructions:
        "Ukaž plátci unikátní QR kód platby, nebo s ním sdílej třímístné ID transakce.",
      QRInstructions:
        "Platbu můžete provést načtením QR kódu nebo sdílením kódu platby.",
      QRCodeWarning:
        "NEPOUŽÍVEJTE čtečku ve Vašem bankovnictví! Otevřete {{appName}} skrze načtení QR kódu přes fotoaparát nebo QR čtečku.",
      UsePaypointWarning:
        "Pro zvolenou platbu není nastaven PayPoint. Prosím nastavte si PayPoint pro zlepšení procesu {{appName}} platby.",
      PaymentStatus: "Status platby",
      TransactionFee: "Poplatek z transakce",
      ProgressHeader: {
        [TransactionStatus.Created]: "Zaplaťte prosím",
        [TransactionStatus.Initiated]: "Zahájeno",
        [TransactionStatus.Processing]: "Zpracovává se",
        [TransactionStatus.Success]: "Zaplaceno",
        [TransactionStatus.Cancelled]: "Zrušeno",
        [TransactionStatus.Fail]: "Chyba",
        [TransactionStatus.InvestigationNeeded]: "Neznámý stav",
      },
      Loading: "Příprava platby...",
      ShareTitle: "{{appName}}",
      ShareText:
        "{{name}} tě volá! Částka {{amount}} je připravená na cestu. Klikni a pošli ji na místo určení! Díky, že platíš s {{appName}}!",
      ShareReceiptTitle: "Potvrzení o platbě - {{appName}}",
      ShareReceiptText:
        "Potvrzení o platbě\n\nID transakce: {{transactionId}}\nČástka: {{amount}}\nPoznámka: {{note}}\nVariabilní symbol: {{reference}}\nÚčet/IBAN: {{iban}}\n\nDíky, že platíš s {{appName}}!",
      NFCInstruction: "Načtěte NFC a dokončete platbu na svém telefonu.",
      ActionButtons: {
        Share: "Sdílet",
        Info: "Informace",
        Qr: "QR {{appName}}",
      },
      Error: "Nastala chyba při načítání platebního příkazu",
      QRCodeInstructionsSuccess:
        "Pro zobrazení detailu platby načtěte<newline/> QR kód na svém telefonu.",
      CreateAnotherPayment: "Vytvořit další platbu",
      BackToOverview: "Zpět na přehled",
      ThankYouMessage: "Děkujeme, že platíte s {{ appName }}!",
    },
    MerchantStatus: {
      InDraft: "Registrace spuštěna",
      InvitedWaitingForConfirmation: "Pozvánka odeslána",
      Onboarding: "Onboarding",
      WaitingForPaymentTerminal: "Čeká na platební terminál",
      Active: "Aktivní",
      BlockedFinancialServices: "Blokovaný",
    },
    NoProductAssigned: "Nemáte přiřazen žádný produkt.",
    NoPaypointProduct:
      "Nemáte přiřazen žádný produkt umožňující vytvoření paypointu.",
    DataFailedToLoad: "Údaje se nepodařilo načíst.",
    PaymentDetails: "Platební údaje:",
    AccountNumber: "Číslo účtu:",
    VariableSymbol: "Variabilní symbol:",
    IBAN: "IBAN:",
    PaymentReference: "Reference platby:",
    Amount: "Částka:",
    Note: "Poznámka:",
    NoAccountSet: "Není nastaven žádný účet",
    ConnectedBankAccounts: "Připojené bankovní účty",
  },
  Customer: {
    Pay: {
      Title: "Zaplatit",
      DescriptionText:
        "Zaplatit můžete i pomocí oskenování QR kódu protistrany.",
      PayButton: "Zaplatit",
      PayButtonWithAmount: "Zaplatit {{amount}}",
      ChooseBankAccount: "Vyberte si účet, kterým chcete zaplatit",
      ChooseBank: "Vyberte si banku, kterou chcete zaplatit",
      AddNextBankAccount: "+ Přidat další účet",
      SelectBankAccount: "Výběr bankovního účtu",
      TransactionIdentifier: "ID transakce",
      Amount: "Částka",
      BillAmount: "Částka účtu",
      Tip: "Spropitné",
      AddTip: "Přidat spropitné",
      fivePercent: "5%",
      tenPercent: "10%",
      twentyPercent: "20%",
      custom: "Vlastní",
      TipContinueWithout: "Pokračovat bez spropitného",
      TipCustomAmountLabel: "Výše spropitného",
      BankAccount: "Bankovní účet",
      QuickPayment: {
        Processing: "Probíhá rychlá platba...",
        Error: "Rychlá platba selhala",
        QuickPaymentFailed: "Transakci se nepodařilo dokončit rychlou platbou.",
        UseAnotherAccount: "Použít jiný účet",
      },
      AnonymousCollector: {
        UnsupportedMode:
          "Tento platební odkaz zde nelze použít. Zkontrolujte prosím odkaz a zkuste to znovu.",
      },
      MooneLiteAccountExplanation:
        "= omezená funkcionalita účtu.<newline/>Pro využívání {{appName}} naplno je třeba dokončit registraci.",
      ManualEntry: {
        Title: "Zaplatit",
        NfcTitle: "Přiložte telefon k platebnímu bodu",
        NfcSubtitle: "Bezkontaktní platba přes NFC.",
        ManualTitle: "Zadejte ID transakce",
        ManualTitleWithNfc: "Nebo zadejte ID transakce ručně",
        ManualSubtitle: "Najdete ho u protistrany.",
        InputPlaceholder: "Např. A5DH8Q",
        InputLabel: "ID transakce",
        SubmitButton: "Pokračovat",
        InvalidId: "Zadejte prosím platné ID transakce",
        TransactionIdNotProvided: "Nebylo zadáno ID transakce.",
      },
    },
  },
  BankAccounts: {
    List: {
      Description:
        'Tyto bankovní účty jsou připojeny k Vašemu účtu. Pokud chcete přidat další bankovní účet, klikněte na tlačítko "Připojit bankovní účet."',
      NoAccounts: "Nemáte žádné připojené bankovní účty.",
      SaveOrder: "Uložit pořadí",
      EditOrder: "Upravit pořadí",
      AddAccount: "Připojit bankovní účet",
    },
    VerificationStatus: {
      Inactive: "Neaktivní",
      AwaitingVerification: "Čeká na ověření",
      Rejected: "Zamítnuto",
      Active: "Aktivní",
      Restricted: "Lite účet",
      PreApproved: "Předschváleno",
    },
    VerificationStatusDescription: {
      Active: "Účet je plně ověřený a lze jej použít pro všechny transakce.",
      AwaitingVerification:
        "Účet ověřujeme a bude buď aktivován, nebo zamítnut. Do té doby jej lze používat s omezenou funkcionalitou.",
      Restricted:
        "Účet lze použít s omezenou funkcionalitou. Pro plnou aktivaci je třeba dokončit registraci.",
      Inactive: "Účet je neaktivní a nelze jej použít pro transakce.",
      Rejected: "Ověření účtu bylo zamítnuto. Účet nelze použít.",
      PreApproved:
        "Účet je předschválen. Můžete přijímat platby z účtu na účet do omezené výše, dokud nebude účet plně ověřen.",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Mikroplatba",
    },
  },
  Form: {
    PersonalData: {
      Sex: {
        Female: "Žena",
        Male: "Muž",
        NotSet: "Neuvedeno",
      },
    },
    PartyType: {
      NaturalPerson: "Fyzická osoba",
      LegalEntity: "Právnická osoba",
      SelfEmployed: "Podnikající fyzická osoba (OSVČ)",
    },
    BusinessActivity: {
      RetailAndGoodsSales: "Maloobchod a prodej zboží",
      FoodServicesAndGastronomy: "Stravovací služby a gastronomie",
      AccommodationAndTourism: "Ubytování a cestovní ruch",
      BeautyHealthAndWellness: "Krása, zdraví a wellness",
      ConstructionCraftsAndMaintenance: "Stavebnictví, řemesla a údržba",
      TransportAutoAndLogistics: "Doprava, auto-moto a logistika",
      FinancialLegalAndConsulting: "Finanční, právní a poradenské služby",
      EducationSportsAndLeisure: "Vzdělávání, sport a volný čas",
      TechnologyITAndOnline: "Technologie, IT a online služby",
      IndustryManufacturingAndWholesale: "Průmysl, výroba a velkoobchod",
      OtherAndPublicServices: "Ostatní a veřejné služby",
      RetailAndCommerce: "Maloobchod a obchod",
      FoodAndBeverageServices: "Stravovací služby",
      AccommodationAndHospitality: "Ubytování a pohostinství",
      BeautyAndPersonalCare: "Krása a osobní péče",
      HealthcareAndPersonalCare: "Zdravotnictví a osobní péče",
      ConstructionAndMaintenance: "Stavebnictví a údržba",
      TransportationAndLogistics: "Doprava a logistika",
      FinancialServicesAndInsurance: "Finanční služby a pojišťovnictví",
      RealEstateAndPropertyServices: "Nemovitosti a správa majetku",
      LegalAndConsultingServices: "Právní a poradenské služby",
      EducationAndTraining: "Vzdělávání a školení",
      ArtsCultureAndEntertainment: "Umění, kultura a zábava",
      SportsAndRecreation: "Sport a rekreace",
      TechnologyAndITServices: "Technologie a IT služby",
      ECommerceAndOnlineServices: "E-commerce a online služby",
      IndustrialProductionAndProcessing: "Průmyslová výroba a zpracování",
      Other: "Jiné",
      PersonalServices: "Osobní služby",
    },
    SourceOfIncome: {
      GoodsSalesRevenue: "Tržby z prodeje zboží",
      ServiceAndCraftIncome: "Příjmy z poskytování služeb a řemesel",
      HospitalityAndAccommodation: "Provoz pohostinství a ubytování",
      CommissionsAndLicensing: "Provize, zprostředkování a licenční poplatky",
      PropertyAndInvestmentIncome: "Výnosy z majetku, pronájmu a investic",
      PublicBudgetsAndGrants: "Veřejné rozpočty, dotace a dary",
      OtherBusinessIncome: "Jiné podnikatelské příjmy",
      Employment: "Zaměstnání",
      SelfEmployment: "Podnikání",
      Other: "Jiné",
    },
    SourceOfIncomeHint: {
      GoodsSalesRevenue:
        "Maloobchod, velkoobchod, stánky, digitální produkty, e-commerce.",
      ServiceAndCraftIncome:
        "Veškeré služby od kadeřnice přes instalatéra až po IT, konzultace a marketing.",
      HospitalityAndAccommodation:
        "Restaurace, bary, kavárny, hotely, penziony a krátkodobé pronájmy.",
      CommissionsAndLicensing:
        "Realitní makléře, poradce, affiliate partnery, autorská práva a patenty.",
      PropertyAndInvestmentIncome:
        "Dlouhodobý pronájem nemovitostí, dividendy, podíly v zisku a holdingovou činnost.",
      PublicBudgetsAndGrants:
        "Příjmy neziskovek, státní příspěvky, církve a nadační sbírky.",
      OtherBusinessIncome:
        "Specifické případy, které nespadají do výše uvedených kategorií.",
    },
    ExpectedMonthlyRevenue: {
      LessThan100K: "Méně než 100 000 Kč",
      From100KTo500K: "100 000 až 500 000 Kč",
      From500KTo1M: "500 000 až 1 000 000 Kč",
      Over1M: "Více než 1 000 000 Kč",
    },
    AverageTransactionValue: {
      LessThan1K: "Méně než 1 000 Kč",
      From1KTo10K: "1 000 až 10 000 Kč",
      From10KTo50K: "10 000 až 50 000 Kč",
      Over50K: "Více než 50 000 Kč",
    },
    RelationType: {
      BeneficialOwner: "Skutečný majitel",
      ProxyHolder: "Prokurista",
      HuntersHunter: "Lovcův lovec",
      BranchManager: "Vedoucí odštěpného závodu",
      Mayor: "Starosta",
      Governor: "Hejtman",
      CityMayor: "Primátor",
      ContactPerson: "Kontaktní osoba",
      HuntersMerchant: "Lovcův obchodník",
      MerchantsEmployee: "Zaměstnanec obchodníka",
      HuntersCustomer: "Lovcův uživatel",
      CustomersCustomer: "Uživatelův uživatel",
      MerchantsCustomer: "Obchodníkův uživatel",
      StatutoryBody: "Statutární orgán",
      InsolvencyAdministrator: "Insolvenční správce",
      Liquidator: "Likvidátor",
      ForcedAdministrator: "Nucený správce",
      BranchOfficeManager: "Vedoucí organizační složky",
      ManagingDirector: "Jednatel",
      BoardChairman: "Předseda představenstva",
      BoardMember: "Člen představenstva",
      SupervisoryBoardChairman: "Předseda dozorčí rady",
      SupervisoryBoardMember: "Člen dozorčí rady",
      Partner: "Společník",
      GeneralPartner: "Komplementář",
      Chairman: "Předseda",
      CommitteeMember: "Člen výboru",
      TrustManager: "Správce svěřenského fondu",
    },
    RoleCategory: {
      StatutoryBody: "Statutární orgán",
      StatutoryBodyHint:
        "Členem statutárního orgánu je zejména jednatel, člen/předseda představenstva, člen/předseda správní rady",
      ProxyHolder: "Prokurista",
      Other: "Jiné",
      SpecificRole: "Upřesnění pozice",
    },
    BankVerification: {
      NotVerified: "Neověřeno",
      Verified: "Ověřeno",
      InProgress: "Probíhá ověřování",
    },
    BankVerificationSource: {
      AIS: "AIS",
      QR: "Mikroplatba",
    },

    IdentityVerification: {
      NotVerified: "Neověřeno",
      Verified: "Ověřeno",
      Processing: "Probíhá ověřování",
      ToVerify: "K ověření",
      Expired: "Expirováno",
    },
    AdditionalInfo: {
      NotVerified: "Neověřeno",
      Verified: "Ověřeno",
      NeedsInvestigation: "Vyžaduje kontrolu",
    },
    UserStatus: {
      Unknown: "Neznámý",
      InvitedWaitingForConfirmation: "Pozvánka odeslána",
      Active: "Aktivní",
      WaitingForEmailConfirmation: "Čeká na potvrzení e-mailu",
      Deactivated: "Deaktivovaný",
      BlockedFinances: "Blokovaný",
      Anonymous: "Anonymní",
      Onboarding: "Onboarding",
      EmailConfirmed: "Potvrzen e-mail",
      RoleSelection: "SSO výběr role",
    },
    IdentityUserStatus: {
      Active: "Aktivní",
      Pending: "Čeká na přijetí",
      Suspended: "Pozastavená",
      Deactivated: "Zrušená",
      Onboarding: "Onboarding",
    },
    AddressType: {
      Permanent: "Trvalé bydliště",
      Mail: "Korespondenční",
      Headquarters: "Sídlo",
    },
    Version: {
      MooneLite: "{{appName}} Lite",
      FullMoone: "Full {{appName}}",
    },
  },
  FormSelectors: {
    BusinessForm: {
      Title: "Forma podnikání",
    },
  },
  User: {
    AccessRole: {
      Admin: "Administrátor",
      Customer: "Uživatel",
      Employee: "Zaměstnanec",
      Merchant: "Obchodník",
      Hunter: "Hunter",
      Aml: "AML",
      HunterPlus: "Hunter+",
      CustomerOnboarding: "Customer Onboarding",
      AdminLite: "Admin (jen čtení)",
      Disponent: "Disponent",
      Child: "Dítě",
    },
    RoleFilter: {
      CustomerOnly: "Uživatel (bez dalších rolí)",
    },
  },
  Hunter: {
    Dashboard: {
      UnderConstruction:
        "Zde pro Vás připravujeme leaderboards hunterů, akademii a další...",
      MissingLicenseHolderBankAccount:
        "Pro výplatu odměn připojte bankovní účet vedený na vlastníka franšízové licence.",
      HunterPortalBanner: {
        Title: "Hunter Portál",
        Description:
          "Terminály, akvizice, akce, akademie a další na jednom místě.",
      },
      Prerequisites: {
        Title: "Hunter první kroky",
        Description:
          "Staň se prodejním odborníkem na Mo.one v několika krocích a osvoj si prodejní praktiky.",
        Completed: "Dokončeno",
        GreatWork: "Skvělá práce!",
        InfoMessage:
          "Pro získání plného přístupu k Hunter funkcím je potřeba se prvně seznámit se základy Mo.one, splňte seznam úkolů a odemkněte si Full Hunter!",
        CompletedMessage:
          "Vše hotovo! Nyní můžete začít posílat pozvánky obchodníkům.",
        Items: {
          RegisterAsMerchant:
            "Zaregistruj se jako Obchodník a projdi si aplikaci",
          InviteUserViaAffiliate: "Pozvi nového uživatele skrze Díky Tobě!",
          BanksAndPayments: "Připoj si alespoň 3 banky a proveď 30 plateb",
          OfflineTraining: "Navštiv",
          OfflineTrainingLink: "offline školení Mo.one",
          OfflineTrainingUrl: "https://events.legi.one",
          BringMerchantsWithHunter:
            "Přiveď 3 Obchodníky v kooperaci se zkušeným Hunterem",
        },
      },
    },
    LicensePaymentPending: {
      Title: "Vaše licence zatím není aktivní",
      ProcessingInfo:
        "Momentálně nemáte žádnou aktivní licenci. Pokud jste již platbu odeslali, vyčkejte prosím na její zpracování a aktivaci licence — bankovní převod může trvat 1–2 pracovní dny.",
      NotPaidYetLink: "Ještě jste platbu neodeslali?",
      NotPaidYetSubtitle: "Zobrazit platební údaje",
      PaymentDetailsTitle: "Platební údaje",
      NoLicenseTitle: "Nemáte žádnou licenci",
      NoLicenseInfo:
        "Momentálně nemáte žádnou aktivní licenci. Pro vstup do {{appName}} Hunter sekce si nejprve objednejte licenci.",
      OrderLicense: "Objednat licenci",
      OrderAnotherLicense: "Objednat další licenci",
      SelectedLicenseLabel: "Objednaná licence",
      BackToMoone: "Zpět do {{appName}}",
    },
    Merchants: {
      Title: "Obchodníci",
      NewRegistration: {
        Title: "Nový obchodník",
        StartRegistrationButton: "Zahájit registraci",
        StartRegistrationError: "Chyba při zahájení registrace",
        StartRegistrationSuccess: "Registrace zahájena",
        CreateMerchantError: "Chyba při vytvoření obchodníka",
        Form: {
          Legend: {
            License: "Výběr licence",
            CommissionSharing: "Rozdělení provize",
          },
          Fields: {
            License: "Licence",
            Country: "Země",
            Region: "Země",
            CompanyNumber: "IČO",
            ConfirmationLabel:
              "Potvrzuji, že jsem osobně mluvil(a) s vlastníkem firmy nebo zodpovědnou osobou za platební služby v dané společnosti.",

            RemoveHunter: "Odebrat huntera",
            CommissionSettings: "Nastavení provize",
            ShareCommissionWithHunters: "Sdílet provizi s dalšími Huntery",
            ShareCommissionWithHuntersButton: " + Sdílet s dalším hunterem",
          },
          NoLicenseForRegion:
            "Pro tento trh nemáte aktivní licenci. Vyberte jinou zemi, nebo si nejprve pořiďte licenci.",
          StatusIndicator: {
            Loading: "Kontrola dostupnosti",
            EnterCompanyNumber: "Zadejte IČO pro kontrolu dostupnosti",
            CompanyAvailable:
              "Výborně! {{company}} ještě {{appName}} nepoužívá.",
            CompanyNotAvailable:
              "Je nám líto, {{company}} již {{appName}} používá, nebo jej evidujeme v procesu registrace.",
            CompanyNotFound: "Zadané IČO jsme v registru firem nenalezli",
          },
        },
      },
      AddNew: "Přidat obchodníka",
      OpenRegistrations: {
        Table: {
          Title: "Potenciální obchodníci",
          Columns: {
            CompanyName: "Název společnosti",
            CompanyNumber: "IČO",
            Phone: "Telefon",
            Email: "E-mail",
          },
        },
        Title: "Otevřené registrace",
        LoadingError: "Chyba - Nepodařilo se načíst stav registrace",
        RegisterNewMerchant: "Registrace nového obchodníka",
      },
      ListPage: {
        LoadingError: "Chyba - Nepodařilo se načíst seznam obchodníků",
        LicenseError: "Chyba - Nepodařilo se načíst údaje o Vaší licenci",
        LicenseNotActive:
          "Vaše licence ještě není aktivní. Jakmile dojde k její aktivaci, uvidíte zde seznam obchodníků.",
        ShowLicenses: "Zobrazit licence",
        MerchantsTitle: "Obchodníci",
        SharedMerchantsTitle: "Obchodníci se sdílenou provizí",
        Table: {
          Columns: {
            MerchantStatus: "Stav obchodníka",
            ContactPerson: "Kontaktní osoba",
            Party: {
              CompanyName: "Název firmy",
              Phone: "Telefon",
              Email: "E-mail",
              SettlementStatus: "Vyúčtování",
            },
            LicenseNumber: "Licence",
            SharePercentage: "Podíl %",
            TransactionsCount: "Počet transakcí",
            DaysRegistered: "Dny v obchodníkovi",
          },
        },
        SharedMerchantsError:
          "Chyba - Nepodařilo se načíst seznam obchodníků se sdílenou provizí",
      },
      CompleteRegistration: {
        MerchantCompany: {
          LoadingError: "Chyba - Nepodařilo se načíst údaje obchodníka",
        },
        ContactPerson: {
          Title: "Kontaktní osoba",
          OptionalTitle: "Volitelné kontaktní osoby",
          OptionalNoItems: "Nejsou přidány žádné kontaktní osoby",
        },
        Facilities: {
          RequiredInfo: "Vyplňte prosím údaje o provozovnách",
          ContinueWithoutFacility: "Pokračovat bez provozovny",
        },
        SendAccess: {
          SendAccessError: "Přístup se nepodařilo odeslat.",
          SendAccessSuccess:
            "Instrukce pro registraci obchodníka byly odeslány",
          Title: "Shrnutí",
          MandatoryStepsTitle:
            "Před odesláním přístupu je nutné splnit všechny následující body:",
          Login: "Login obchodníka",
          LoginDescription:
            "Tento e-mail bude obchodník používat pro přihlášení do {{appName}}.",
          SendAccessButton: "Poslat přístup",
          BackOfficeTarget:
            "Tato e-mailová adresa patří internímu účtu {{appName}} (Admin, AML, onboarding) a nelze ji pozvat. Použijte jinou e-mailovou adresu.",
          MerchantAlreadyExists:
            "Obchodník s tímto e-mailem již v {{appName}} existuje.",
          MerchantAlreadyHasAccessToThisCompany:
            "Tento uživatel už má přístup k této firmě jako obchodník.",
          ExistingIdentityHint:
            "Tento e-mail je již v {{appName}}. Pozvánka se zobrazí v aplikaci uživatele — e-mail neposíláme.",
          NewIdentityHint:
            "Pošleme aktivační e-mail s odkazem pro nastavení hesla.",
          CompanyNumberAlreadyRegistered:
            "Obchodník s IČO {{companyNumber}} je již v {{appName}} zaregistrován.",
          TestMerchantBannerTitle: "Zkušební registrace",
          TestMerchantBanner:
            "Před dokončením všech prvních kroků máte k dispozici jednu zkušební registraci obchodníka, abyste si mohli vyzkoušet aplikaci také z jeho pohledu.",
          Todos: {
            BasicInfo: "Vyplnění základních údajů obchodníka",
            BeneficialOwners: "Přidání skutečných vlastníků společnosti",
            ContactPerson: "Přidání kontaktní osoby pro zúčtování",
            Facilities: "Přidání provozovny",
            Pricing: "Nastavení ceníků u všech vybraných produktů",
            HunterPrerequisites: 'Splnění všech bodů z "Hunter první kroky"',
          },
        },
        GeneralTitle: "Registrace obchodníka",
        Title: "Registrace {{company}} ",
        MerchantError: "Chyba - Obchodník není vybrán nebo neexistuje",
        LoadingError: "Chyba - Nepodařilo se načíst stav registrace",
        Steps: {
          party: "Obchodník",
          notes: "Poznámky",
          facilities: "Provozovny",
          company: "Společnost",
          products: "Produkty",
          fees: "Poplatky",
          completion: "Dokončení",
        },
        NextStep: "Pokračovat",
        PreviousStep: "Zpět",
        SaveMerchantPartyError: "Chyba při ukládání údajů obchodníka",
        SaveMerchantPartySuccess: "Údaje obchodníka byly uloženy",
        Notes: {
          Title: "Poznámky",
          Label: "Vaše poznámky k obchodníkovi",
          SaveSuccess: "Poznámky byly uloženy",
          SaveError: "Chyba při ukládání poznámek",
          NoNotes: "Žádné poznámky...",
        },
      },
      Detail: {
        ActivateButton: "Aktivovat obchodníka",
        ActivateSuccess: "Obchodník byl aktivován.",
        ActivateError: "Aktivace obchodníka se nezdařila.",
        ResendAccessButton: "Znovu odeslat pozvánku",
        ResendAccessSuccess: "Přístupový e-mail byl úspěšně odeslán",
        ResendAccessSuccessWithUser:
          "Pozvánka byla znovu odeslána na <bold>{{userLogin}}</bold>",
        ResendAccessError: "Chyba při odesílání přístupového emailu",
        CancelAccessButton: "Zrušit pozvánku",
        CancelAccessConfirmTitle: "Zrušit pozvánku?",
        CancelAccessConfirmBody:
          "Tímto se zruší čekající pozvánka pro {{userLogin}}. Novou pozvánku můžete odeslat později.",
        CancelAccessSuccess: "Pozvánka byla zrušena",
        CancelAccessError: "Chyba při rušení pozvánky",
        CancelAccessForbidden:
          "Pozvánku může zrušit jen hunter, který ji odeslal, nebo administrátor.",
        Tabs: {
          Merchant: "Obchodník",
          Products: "Produkty",
          TerminalContracts: "Podklady",
          Paypoints: "Paypointy",
          Settlements: "Vyúčtování",
        },
      },
    },
    AllMerchants: {
      LoadingError: "Chyba - Nepodařilo se načíst seznam obchodníků",
      OwnedByMe: "Můj obchodník",
      TableHeaders: {
        Status: "Stav obchodníka",
        CompanyNumber: "IČO",
        CompanyName: "Název firmy",
        LicenseOwner: "Vlastník licence",
        LicenseType: "Typ licence",
        DateCreated: "Datum vytvoření",
        TransactionsCount: "Počet transakcí",
      },
    },
    UnassignedMerchants: {
      Description:
        "Obchodníci, kteří se zaregistrovali sami a nemají přiřazeného huntera. Klikněte na řádek pro přiřazení huntera a nastavení provize.",
      LoadingError:
        "Chyba - Nepodařilo se načíst seznam obchodníků bez huntera",
      EmptyState:
        "Žádní obchodníci bez huntera. Všichni obchodníci mají přiřazeného huntera.",
      OpenDetailLabel: "Otevřít detail obchodníka",
      TableHeaders: {
        Status: "Stav obchodníka",
        CompanyNumber: "IČO",
        CompanyName: "Název firmy",
        DateCreated: "Datum vytvoření",
        Detail: "Detail",
      },
      AssignDialog: {
        Title: "Přiřadit huntera pro",
        Subtitle: "{{companyName}} (IČO: {{companyNumber}})",
        PrimaryLicenseLabel: "Hlavní licence",
        MainCommission: "Hlavní provize",
        ShareLegend: "Sdílet provizi s dalšími licencemi",
        ShareCommissionWithHuntersButton: "Sdílet provizi s huntery",
        AssignButton: "Závazně přiřadit",
        AssignWarning: "Po přiřazení již nelze huntery ani provize upravovat",
        CancelButton: "Zrušit",
        AssignSuccess: "Hunter byl úspěšně přiřazen.",
        AlreadyHasHunterError: "Tento obchodník má již přiřazeného huntera.",
        GenericError: "Přiřazení huntera se nezdařilo.",
        Validation: {
          PrimaryRequired: "Hlavní licence je povinná.",
          ShareOutOfRange:
            "Sdílená provize musí být větší než 0 % a menší než 100 %.",
          PrimaryUnderMin:
            "Hlavnímu hunterovi musí zůstat alespoň 1 % provize.",
        },
      },
    },
    HuntersOverview: {
      LoadingError: "Chyba - Nepodařilo se načíst seznam hunterů",
      Detail: {
        UserInfo: "Informace o uživateli",
        PartyInfo: "Informace o subjektu",
        ContactInfo: "Kontaktní údaje",
        Login: "Přihlašovací jméno",
        Status: "Stav",
        FirstName: "Jméno",
        LastName: "Příjmení",
        BirthDate: "Datum narození",
        CompanyName: "Název společnosti",
        CompanyNumber: "IČO",
        TaxNumber: "DIČ",
        Email: "E-mail",
        Phone: "Telefon",
        Licenses: "Licence",
        NoLicensesFound: "Žádné licence nenalezeny",
        AffiliatedTo: "Affiliate",
        EditUser: "Upravit",
        DateCreated: "Datum vytvoření",
        PartyType: "Typ osoby",
      },
      TableHeaders: {
        Login: "Přihlašovací jméno",
        FirstName: "Jméno",
        LastName: "Příjmení",
        CompanyName: "Název společnosti",
        DateCreated: "Datum vytvoření",
        Status: "Stav",
        AffiliatedTo: "Affiliate",
        Prerequisites: "První kroky",
      },
    },
  },
  ApiStatuses: {
    UnknownError: "Nastala neočekávaná chyba při zpracování požadavku",
    UploadIdentificationCommandResultStatus: {
      [UploadIdentificationCommandResultStatus.Success]: "Úspěšně nahráno",
      [UploadIdentificationCommandResultStatus.MissingFiles]:
        "Prosím, nahrajte všechny soubory",
    },
    UploadIdentificationCommandResultStatus2: {
      [UploadIdentificationCommandResultStatus2.Success]: "Úspěšně nahráno",
      [UploadIdentificationCommandResultStatus2.MissingFiles]:
        "Prosím, nahrajte všechny soubory",
      [UploadIdentificationCommandResultStatus2.VerificationAttemptsExhausted]:
        "Automatickou kontrolu dokladu už nelze opakovat, obraťte se prosím na podporu.",
    },
  },
  System: {
    Addresses: "Adresy",
    BlockchainFee: "Poplatek za blockchain",
    MempoolFeeLevel: "Úroveň poplatku v mempoolu",
    Exchange: "Burza",
    Trades: "Obchody",
    Moone: "{{appName}}",
    HotWallet: "+ Na Hot Wallet",
    ColdWallet: "+ Na Cold Wallet",
    ExchangeWithdrawal: " + K výběru z burzy ",
    UserAccounts: "- Na účtech uživatelů",
    ControlSum: "Kontrolní suma",
    ExchangeWithdrawalFee: "Poplatek za výběr z burzy",
    TradingVolume: "Obchodovaný objem",
    PerMonth: "Za měsíc",
    PerWeek: "Za týden",
    Per24h: "Za 24h",
    PurchasedBTC: "Nakoupené BTC",
    WithdrawnOrPending: "Vybráno nebo k výběru",
    BTCLedgerSum: "Suma účetní knihy BTC",
    CZKLedgerSum: "Suma účetní knihy CZK",
  },
  Error: {
    Page403: "Error403",
    Page404: "Error404",
    Unexpected: "Došlo k neočekávané chybě",
    NoAccess: "K této stránce nemáte přístup.",
    OpenRegistrationsFailed: "Otevřené registrace se nepodařilo načíst.",
    MerchantNotSelected: "Chyba - Obchodník není vybrán nebo neexistuje",
    LicenseInfoFailed: "Nepodařilo se načíst informace o Vaší licenci.",
    InvalidPaypointId: "Neplatné nebo chybějící paypoint ID",
    SomethingWentWrong: "Něco se pokazilo, zkuste to prosím znovu později.",
    InvalidUserRole: "Chyba, neplatná uživatelská role nebo obchodník",
    GoogleLoginFailed: "Chyba při přihlášení přes Google",
    Error: "Chyba",
    ProgrammerHint: "Jste programátor? Koukněte v čem byla chyba.",
    AccountsFailed: "Chyba - Nepodařilo se načíst Vaše účty",
    UserDataFailed: "Chyba, nepodařilo se načíst údaje o uživateli",
    VerificationDataFailed: "Chyba, nepodařilo se načíst verifikační data",
    DocumentsFailed: "Chyba, nepodařilo se načíst dokumenty",
    PersonDataFailed: "Data osoby se nepodařilo načíst.",
    IncomeDataFailed: "Data se nepodařilo načíst.",
    FormPreparationFailed: "Při přípravě formuláře se vyskytla chyba",
    RelatedPartyDataFailed: "Chyba při načítání dat související osoby.",
    MerchantFacilitiesFailed: "Údaje o provozovnách se nepodařilo načíst.",
    UserFailed: "Chyba, uživatele se nepodařilo načíst",
    ActingPersonFailed:
      "Data jednající osoby se nepodařilo načíst nebo neexistuje.",
    DocumentsFailedToLoad: "Chyba, doklady se nepodařilo načíst",
    AffiliateCodeFailed: "Váš affiliate kód se nepodařilo získat.",
    NoInvitationsSent: "Zatím jste neodeslali žádné pozvánky.",
    QRPaymentFailed:
      "Omlouváme se, ale něco se pokazilo, zkuste to prosím znovu později.",
  },
  Dashboard: {
    EmptyForRole: "Vaše role nemá přiřazenou stránku s přehledem.",
    NoAccess: "K této stránce nemáte přístup.",
    NoAccessRetry:
      "Zkuste se znovu <signInLink>přihlásit</signInLink>. Pokud Vaše problémy přetrvávají, kontaktujte prosím naši podporu.",
    AlreadyHaveAccount: "Již máte {{appName}} účet?",
    IncomeTypeQuestion: "Jaký je Váš typ příjmů?",
    Back: "ZPĚT",
    Loading: "Loading...",
  },
  Auth: {
    Redirecting: "Přesměrování",
    Error: "Chyba",
    StateSync: {
      LoggedInFromAnotherTab: "Byli jste přihlášeni z jiné karty.",
      LoggedOutFromAnotherTab: "Byli jste odhlášeni z jiné karty.",
    },
    AuthPageLayout: {
      DividerText: "nebo",
      SignInLinkText: "Přihlaste se",
      SignUpLinkText: "Zaregistrujte se",
      SignInPrompt: "Už máte účet?",
      SignUpPrompt: "Ještě nemáte svůj účet?",
    },
    SSO: {
      CompleteSSORegistration: {
        Welcome: "Vítejte v {{appName}}!",
        Title: "Dokončení registrace",
        Description:
          "Protože se jedná o Vaše první přihlášení, potřebujeme zjistit, jestli se k nám registrujete jako Uživatel, Obchodník nebo Hunter.",
        SignUpAs: "Registrovat jako",
        RoleDescription: {
          Merchant:
            "Jako obchodník můžete přijímat platby od svých zákazníků s nižšími poplatky a využívat bezkontaktní paypointy.",
          Customer:
            "Jako uživatel můžete posílat přímé platby, platit za své nákupy a sbírat Stardust body.",
          Hunter:
            "Jako hunter můžete získat Legione licenci, spravovat své obchodníky, a získat provize z jejich transakcí",
        },
        RoleLabel: {
          Merchant: "Obchodník",
          Customer: "Uživatel",
          Hunter: "Hunter",
        },
      },
      Google: {
        ButtonLabel: "Přihlásit se přes Google",
      },
      Apple: {
        ButtonLabel: "Pokračovat s Apple",
        SignInFailed:
          "Přihlášení přes Apple se nezdařilo. Zkuste to prosím znovu.",
        NotSupportedInApp:
          "Přihlášení přes Apple není v aplikaci podporováno. Použijte prosím webový prohlížeč.",
      },
      BankID: {
        ButtonLabel: "Pokračovat s BankID",
      },
    },
    Migration: {
      Title: "Propojení účtu",
      Welcome: "Propojte svůj účet s Identitou",
      Description:
        "Váš účet je třeba propojit s hlavní Identitou, aby odpovídal novému modelu účtů. Stačí jeden z následujících kroků.",
      RoleHint: "Váš aktuální účet má roli: {{role}}",
      LinkToCustomerOption: "Mám již účet Customer — propojit",
      CreateIdentityOption: "Vytvořit novou Identitu z tohoto účtu",
      CreateIdentityDeferred:
        "Pro tento typ účtu zatím není vytvoření nové Identity podporováno — propojte účet s existující Identitou.",
      LinkToCustomerTitle: "Propojit s existujícím Customer účtem",
      LinkToCustomerDescription:
        "Zadejte přihlašovací údaje svého stávajícího Customer účtu. Vaše aktuální role bude přidána k této Identitě.",
      LoginLabel: "E-mail Customer účtu",
      PasswordLabel: "Heslo Customer účtu",
      LinkButton: "Propojit účet",
      BackButton: "Zpět",
      LinkError: "Propojení se nezdařilo. Zkontrolujte přihlašovací údaje.",
      LinkSsoDivider: "nebo",
      LinkSsoDescription:
        "Přihlaste se účtem Google nebo Apple, který používáte pro svůj Customer účet.",
      LinkSsoNoAccount:
        "Pod tímto Google/Apple e-mailem nemáme žádný Customer účet. Použijte účet se stejným e-mailem, nebo se přihlaste heslem.",
      LinkSsoError:
        "Propojení přes Google/Apple se nezdařilo. Zkuste to prosím znovu.",
      CreateError: "Vytvoření Identity se nezdařilo. Zkuste to prosím znovu.",
      AccountNotReady:
        "Tento účet není připraven k použití — registrace nebyla dokončena. Kontaktujte prosím podporu nebo svého obchodního zástupce a požádejte o nové založení účtu.",
      EmployeeNotSupported:
        "Zaměstnanecké účty zatím nelze propojit s Identitou. Obraťte se prosím na svého obchodníka nebo na podporu.",
      BackOfficeNotSupported:
        "Interní účty (Admin, AML, onboarding) se nepropojují ani nezakládají svépomocí — připraví je administrátor. Obraťte se prosím na administrátora.",
      SignOut: "Odhlásit se",
      MerchantCreateIdentity: {
        Title: "Vytvořit novou Identitu — statutární zástupce",
        Description:
          "Identita společnosti musí vycházet z jejího statutárního orgánu. Vyberte prosím, kdo ze statutárních zástupců jste, případně zadejte své údaje ručně.",
        CompanyLabel: "Společnost",
        CompanyNumber: "(IČO: {{number}})",
        UnknownCompany: "(neznámá)",
        PickPersonTitle: "Statutární zástupci společnosti",
        AlreadyLinkedHint: "již má vlastní Identitu",
        UnnamedPerson: "(beze jména)",
        StatutoryDeclaration:
          "Prohlašuji, že jsem statutárním orgánem nebo členem statutárního orgánu společnosti {{company}}.",
        CreateAsButton: "Vytvořit Identitu jako {{name}}",
        CreateAsButtonNoSelection: "Vytvořit Identitu",
        ManualEntryToggle: "Nejsem v seznamu — zadat své údaje",
        ManualEntryToggleEmpty: "Zadat údaje ručně",
        ManualTitle: "Vaše osobní údaje (statutární zástupce)",
        FirstNameLabel: "Jméno",
        LastNameLabel: "Příjmení",
        BirthDateLabel: "Datum narození",
        PhoneLabel: "Telefon",
        SubmitManualButton: "Vytvořit Identitu",
        SubmitError: "Vytvoření Identity se nezdařilo. Zkuste to prosím znovu.",
        LoadError: "Nepodařilo se načíst zástupce společnosti.",
        RelationTypes: {
          BeneficialOwner: "Skutečný majitel",
          ProxyHolder: "Prokurista",
          BranchManager: "Vedoucí odštěpného závodu",
          BranchOfficeManager: "Vedoucí organizační složky",
          ContactPerson: "Kontaktní osoba",
          StatutoryBody: "Statutární orgán",
          Mayor: "Starosta",
          Governor: "Hejtman",
          CityMayor: "Primátor",
          InsolvencyAdministrator: "Insolvenční správce",
          Liquidator: "Likvidátor",
          ForcedAdministrator: "Nucený správce",
        },
      },
    },
    Invitations: {
      PageTitle: "Pozvánky",
      PageDescription:
        "Čekající pozvánky k převzetí dalších rolí v {{appName}}. Přijetím přidáte roli ke svému účtu, odmítnutím pozvánku zahodíte.",
      EmptyState: "Nemáte žádné čekající pozvánky.",
      MerchantInviteTitle:
        "Byl(a) jste pozván(a) provozovat {{companyName}} jako obchodník.",
      MerchantInviteUnnamedCompany:
        "Byl(a) jste pozván(a) provozovat obchodnický účet.",
      EmployeeInviteTitle:
        "Byl(a) jste pozván(a) pracovat pro {{companyName}} jako zaměstnanec.",
      EmployeeBellTitle: "Nová pozvánka do firmy",
      EmployeeBellMessage:
        "Společnost {{company}} vás zve jako zaměstnance. Pozvánku potvrdíte v sekci Pozvánky.",
      MerchantBellTitle: "Nová pozvánka ke společnosti",
      MerchantBellMessage:
        "Byl(a) jste pozván(a) ke správě společnosti {{company}}. Pozvánku potvrdíte v sekci Pozvánky.",
      InvitedBy: "Pozval(a): {{inviter}}",
      ExpiresAt: "Platí do {{date}}",
      AcceptButton: "Přijmout",
      DeclineButton: "Odmítnout",
      KycRequired:
        "Před přijetím dokončete ověření identity na svém zákaznickém účtu.",
      AcceptError: "Pozvánku se nepodařilo přijmout. Zkuste to prosím znovu.",
      AcceptedButSwitchFailed:
        "Pozvánka byla přijata — ale nepodařilo se na ni přepnout. Obnovte stránku nebo přepněte kontext v účtu.",
      DeclineError: "Pozvánku se nepodařilo odmítnout. Zkuste to prosím znovu.",
      LoadError: "Nepodařilo se načíst vaše pozvánky.",
    },
    ContextSwitcher: {
      Title: "Přepnout roli",
      AddRole: "Vytvořit roli",
      Switching: "Přepínám…",
      PersonalAccountHint: "Osobní účet",
      Roles: {
        Customer: "Zákazník",
        Hunter: "Hunter",
        HunterPlus: "Hunter Plus",
        Merchant: "Obchodník",
        Disponent: "Disponent",
        Employee: "Zaměstnanec",
        Admin: "Administrátor",
        Aml: "AML",
        CustomerOnboarding: "Customer onboarding",
        AdminLite: "Admin lite",
        Child: "Dítě",
      },
    },
    ForgottenPassword: {
      Title: "Zapomenuté heslo",
      Email: "E-mail",
      ResetPasswordButton: "Resetovat heslo",
      SuccessMessage:
        "Pokud uživatel s daným e-mailem existuje, odeslali jsme na něj pokyny k obnovení hesla.",
    },
    EmailVerification: {
      EmailSentTo: "Na Vaši e-mailovou adresu",
      Redirecting: "Přesměrování",
      EmailVerification: "Ověření e-mailu",
      EmailSent: "E-mail byl odeslán",
      ResendEmail: "Odeslat e-mail znovu",
      EmailInstructions:
        "byl odeslán e-mail s aktivačním odkazem. Před pokračováním je nutné účet aktivovat kliknutím na odkaz v tomto e-mailu.",
      ResendEmailLabel: "Žádný e-mail nedorazil?",
      ResendEmailText:
        "Zkuste zkontrolovat složku SPAM nebo Hromadné. Případně si nechte poslat e-mail znovu.",
    },
  },
  Account: {
    ThankYouFriendInvited: "Děkujeme. Váš přítel byl úspěšně pozván.",
  },
  Components: {
    PasswordInput: {
      ShowPassword: "Zobrazit heslo",
      HidePassword: "Skrýt heslo",
    },
    ShareButton: {
      AccessibilityLabel: "Sdílet",
      Error: "Sdílení se nezdařilo",
    },
    EmployeeAutocomplete: {
      Placeholder: "Vyberte zaměstnance",
      SelectAll: "Vybrat všechny",
    },
    CategoryAutocomplete: {
      Placeholder: "Vyberte kategorie",
    },
    LanguageSwitcher: {
      ComingSoon: "Připravujeme",
    },
    CountrySelector: {
      LoadingError: "Omlouváme se, něco se pokazilo. Zkuste to prosím později.",
      Label: "Vyberte zem, ve které si chcete licenci koupit",
      ComingSoon: "připravujeme",
      SlovakLicensesComingSoon:
        "Slovenské licence již brzy. Nyní připravujeme.",
    },
    RegionRequiredModal: {
      Title: "Vyber svůj trh",
      Description:
        "Trh určuje měnu a settlement, ve kterém působíš. Volbu nelze později změnit.",
      LoadingError: "Seznam trhů není dostupný",
      Error: "Nastavení regionu se nezdařilo. Zkuste to prosím znovu.",
      Confirm: "Potvrdit",
    },
    LicenseOrder: {
      CreateError: "Objednávku licence se nepodařilo vytvořit",
      CreateSuccess: "Objednávka licence byla vytvořena",
      LoadingError: "Omlouváme se, něco se pokazilo. Zkuste to prosím později.",
      Coupon: {
        Title: "Slevový kupón",
        CheckboxLabel: "Mám slevový kupón",
        Label: "Kód kupónu",
        Placeholder: "Zadejte kód kupónu",
        Validate: "Ověřit",
        Applied: "Kupón uplatněn",
        Remove: "Odebrat kupón",
        OriginalPrice: "Původní cena",
        Discount: "Sleva",
        FinalPrice: "Cena po slevě",
        Error: {
          CouponNotFound: "Kupón nebyl nalezen",
          CouponExpired: "Kupón již vypršel",
          CouponOutOfStock: "Kupón byl již vyčerpán",
          CouponInvalidType: "Kupón nelze použít pro tento typ licence",
          CouponRegionMismatch: "Kupón neplatí pro vybranou zemi",
          Unavailable: "Kupón již nelze použít",
        },
      },
    },
    LicensePayment: {
      PendingActivationInfo:
        "Licence bude aktivována po připsání platby. Pokud máte již zaplaceno, vyčkejte na připsání peněz.",
    },
    Invoice: {
      PaymentData: "Platební údaje",
      AccountNumber: "Číslo účtu",
      VariableSymbol: "Variabilní symbol",
      SpecificSymbol: "Specifický symbol",
      IBAN: "IBAN",
      Reference: "Reference platby",
      Amount: "Částka",
      Note: "Poznámka",
      MandatoryNoteDescription:
        "Poznámku je nutné uvést! Bez poznámky nebude platba spárována",
      EmployerGuidelineButton: "Stáhnout pokyn pro zaměstnavatele",
      BulkDownload: {
        Download: "Stáhnout faktury",
        Success: "Faktury byly úspěšně staženy",
        Error: "Nepodařilo se stáhnout faktury",
      },
    },
    RevalidateBankingAuthModal: {
      Title: "U některých z Vašich bank brzy vyprší ověření",
      Description:
        "Abyste mohli používat {{appName}} jak jste zvyklí i nadále, prosíme Vás o jejich opětovné ověření.",
      InvalidTitle: "U některých z Vašich bank vypršelo ověření",
      InvalidDescription:
        "Pro obnovení funkcionality prosíme ověřte přístup k následujícím bankám.",
      InvalidPispDescription:
        "Pro obnovení plateb přes následující banky prosíme ověřte přístup.",
      ExpiringPispTitle: "Platební oprávnění brzy vyprší",
      ExpiringPispDescription:
        "Abyste mohli nadále platit přes následující banky, prosíme o jejich opětovné ověření.",
    },
    UnpaidSettlementPopup: {
      PayMonthlySettlement: "Zaplatit měsíční vyúčtování ve výši {{amount}}.",
      PayMonthlySettlements: "Zaplatit měsíční vyúčtování",
      NoSettlementTransactionError:
        "Chyba, vyúčtování nemá přiřazenou transakci k zaplacení",
    },
    LicensePicker: {
      LoadingError:
        "Omlouváme se, ale něco se pokazilo. Zkuste to prosím později.",
      LicenseDescription: {
        [LicenseCode.Gold]:
          "Licence Huntera v Legi.one s velkým fyzickým obrazem.",
        [LicenseCode.Silver]:
          "Licence Huntera v Legi.one se středním fyzickým obrazem.",
        [LicenseCode.Bronze]:
          "Licence Huntera v Legi.one s malým fyzickým obrazem.",
        [LicenseCode.Standard]:
          "Licence Huntera v Legi.one s digitálním obrazem.",
      },
      Perks: {
        Terminals: "terminálů",
        Terminals_one: "terminál",
        Terminals_few: "terminály",
        Terminals_other: "terminálů",
        SubAccounts: "podúčtů",
        SubAccounts_one: "podúčet",
        SubAccounts_few: "podúčty",
        SubAccounts_other: "podúčtů",
        NoSubAccounts: "Bez podúčtů",
      },
    },
    BanksList: {
      DataLoadingError: "Omlouváme se, nabídku bank se nepodařilo načíst.",
      ShowAll: "Ukázat vše ({{count}})",
      HideAll: "Skrýt",
    },
    LimitedAccountPopup: {
      Title: "Omezený účet",
      Message:
        "Vámi zadané informace je nutné ověřit naším pracovníkem. Jakmile bude vše ověřeno, budeme Vás informovat.",
    },
    DocumentExpirationWarning: {
      UploadNewDocument: "Nahrát nový doklad",
      UploadSuccess: "Doklad byl úspěšně nahrán. Čeká na ověření.",
      AdminWarningTitle: "Platnost dokladu uživatele brzy vyprší",
      AdminWarningMessage:
        "Platnost dokladu totožnosti tohoto uživatele vyprší {{date}}.",
      AdminExpiredTitle: "Platnost dokladu uživatele vypršela",
      AdminExpiredMessage:
        "Platnost dokladu totožnosti tohoto uživatele vypršela. Uživatel má omezený přístup.",
      WarningPrimaryTitle: "Platnost dokladu totožnosti brzy vyprší",
      WarningPrimaryMessage:
        "Platnost vašeho dokladu totožnosti vyprší {{date}}.",
      ExpiredPrimaryTitle: "Platnost dokladu totožnosti vypršela",
      ExpiredPrimaryMessage: "Platnost vašeho dokladu totožnosti vypršela.",
      WarningSecondaryTitle: "Platnost druhého dokladu brzy vyprší",
      WarningSecondaryMessage:
        "Platnost vašeho druhého dokladu vyprší {{date}}.",
      ExpiredSecondaryTitle: "Platnost druhého dokladu vypršela",
      ExpiredSecondaryMessage: "Platnost vašeho druhého dokladu vypršela.",
      AdminWarningSecondaryTitle:
        "Platnost druhého dokladu uživatele brzy vyprší",
      AdminWarningSecondaryMessage:
        "Platnost druhého dokladu tohoto uživatele vyprší {{date}}.",
      AdminExpiredSecondaryTitle: "Platnost druhého dokladu uživatele vypršela",
      AdminExpiredSecondaryMessage:
        "Platnost druhého dokladu tohoto uživatele vypršela.",
      SecondDocumentValidTo: "Platnost druhého dokladu do",
      AdminNotificationExpiredTitle: "Uživateli vypršel doklad",
      AdminNotificationExpiredMessage:
        "Platnost dokladu totožnosti uživatele {{user}} vypršela.",
    },
    RelatedPartyDocumentExpiration: {
      Title: "Doklady souvisejících osob vyžadují pozornost",
      WarningMessage:
        "{{name}} ({{relation}}) — doklad totožnosti vyprší {{date}}.",
      ExpiredMessage: "{{name}} ({{relation}}) — doklad totožnosti vypršel.",
      UpdateDocuments: "Aktualizovat doklady",
    },
    MooneLitePopup: {
      Title: "Lite účet",
      Message:
        "Váš účet funguje v omezeném režimu Lite. Abyste mohli využívat {{appName}} naplno, je nutné mít připojen alespoň jeden bankovní účet a dokončit registraci doplněním Vašich osobních údajů a ověřením Vašeho dokladu totožnosti.",
      BankVerificationMessage:
        "Vaše osobní údaje a doklad totožnosti už máme. Abyste mohli využívat {{appName}} naplno, zbývá připojit a ověřit Váš bankovní účet.",
      CompleteRegistrationButton: "Dokončit registraci",
      ConnectBankAccountButton: "Připojit bankovní účet",
      LimitExceeded:
        "Vyčerpali jste limit pro používání {{appName}} Lite. Pokud chcete pokračovat v používání {{appName}}, je nutné dokončit registraci doplněním Vašich osobních údajů a ověřením Vašeho dokladu totožnosti.",
      RestrictionList: {
        NoPeerToPeerPayments: "Odesílat platby lze pouze obchodníkům",
        NoBalance: "Nevidíte zůstatky na účtech",
        NoIncomingPayments: "Nemůžete přijímat platby",
        NoLoyaltyPoints: "Nezískáváte bonusové body Stardust",
        MaxPaymentLimit:
          "Maximální výše odchozí platby je 1000 EUR (nebo ekvivalent v Kč)",
        MaxTransactionsLimit:
          "Při překročení stanoveného limitu transakcí dojde k automatickému pozastavení služeb.",
      },
    },
    SetupChecklist: {
      Title: "Dokončení registrace",
      Subtitle: "Dokončete následující kroky a využívejte {{appName}} naplno.",
      LiteSubtitle:
        "Používáte {{appName}} Lite — dokončete následující kroky, získejte Full {{appName}} a využívejte aplikaci naplno.",
      MerchantTitle: "Dokončení nastavení",
      MerchantSubtitle:
        "Dokončete následující kroky a přijímejte platby s {{appName}}.",
      StepsCompleted: "Dokončeno {{completed}} z {{total}} kroků",
      Start: "Začít",
      InReview: "Ověřuje se",
      Steps: {
        ConnectBank: {
          Title: "Připojte bankovní účet",
          Description:
            "Přidejte svůj bankovní účet, abyste mohli odesílat platby.",
          Action: "Připojit účet",
        },
        SetPrimaryAccount: {
          Title: "Nastavte hlavní bankovní účet",
          Description: "Pro odchozí platby, rychlé platby a příjem plateb.",
          Action: "Zvolit hlavní účet",
          BlockedDescription:
            "Hlavní účet budete moci zvolit, jakmile bude vaše totožnost ověřena.",
        },
        VerifyIdentity: {
          Title: "Ověřte svou totožnost",
          Description: "Odemkne zůstatky, příchozí platby a Stardust",
          Action: "Ověřit totožnost",
        },
      },
    },
    Bitcoin: "Bitcoin",
    IBAN: "IBAN",
    Maximum: "maximum",
    SAT: "SAT",
    Or: "nebo",
    RateConfirmation: "Rate confirmation",

    Account: {
      DeactivateUser: {
        Title: "Tímto krokem deaktivujete svůj {{appName}} účet",
        Description:
          "Váš účet bude deaktivován a již se nebudete moci do účtu dále přihlásit.",
        Confirmation:
          "Opravdu chcete účet deaktivovat? Deaktivací přijdete o přístupu k vašemu {{appName}} účtu.",
        DeactivateButton: "Deaktivovat účet",
        SuccessMessage: "Účet byl úspěšně deaktivován.",
        InfoSection: {
          Title: "Co znamená deaktivace účtu?",
          Paragraph1:
            "Deaktivací účtu okamžitě ztratíte přístup do aplikace {{appName}} (přihlášení, platby, licence, správa účtů) a zastaví se všechny probíhající procesy, včetně vyplácení cashbacku, settlementů a affiliate provizí.",
          Paragraph2:
            "Vaše data a historie transakcí ale v systému zůstávají. Podle pravidel ČNB a zákona proti praní špinavých peněz (AML) máme povinnost tyto údaje archivovat po dobu 10 let od ukončení spolupráce pro účely případné kontroly úřadů.",
        },
      },
      AccountTab: "Nastavení",
      PublicInformationTab: "Profil",
      Products: "Produkty",
      Facilities: "Provozovny",
      ContactPersons: "Kontaktní osoby",
      NoRoleAssignedError:
        "Nastala chyba - uživatel nemám přiřazenou žádnou roli.",
      Primary: "Primární",
      VerificationAccount: "Ověřující účet",
      AccountOwner: "Majitel účtu",
      ConnectionDate: "Datum připojení",
      ManualVerificationRequired: "Tento účet je nutné ověřit manuálně",
      ActivateAccount: "Aktivovat",
      RejectAccount: "Zamítnout",
      AccountActivationConfirm:
        "Opravdu chcete tento účet aktivovat?\n\nTato akce je nevratná.",
      AccountRejectionConfirm:
        "Opravdu chcete tento účet zamítnout?\n\nTato akce je nevratná.",
      TerminalDocuments: "Podklady pro terminál",
      TerminalDocumentsFailed:
        "Údaje o podkladech pro terminál se nepodařilo načíst.",
      MerchantFacilitiesFailed: "Údaje o provozovnách se nepodařilo načíst.",
      RelatedParties: "Související osoby",
      RelatedPartySaved: "Uložení údajů související osoby proběhlo úspěšně",
      RelatedPartyError:
        "Při ukládání údajů související osoby se vyskytla chyba",
      NoDocumentsForPerson: "Pro tuto osobu neevidujeme žádné nahrané doklady.",
      VerificationSaved: "Uložení údajů ověření proběhlo úspěšně",
      VerificationError: "Při ukládání údajů ověření se vyskytla chyba",
      GeneralInformation: "Obecné údaje",
      Verification: "Ověření",
      Company: "Společnost",
      Declaration: "Prohlášení",
      PersonalInformation: "Informace o Vás",
      CompanyName: "Název společnosti",
      TaxNumber: "DIČ",
      TaxResidence: "Daňová rezidence",
      BusinessSubject: "Předmět podnikání",
      SpecifyBusinessSubject: "Upřesněte předmět podnikání",
      IncomeSource: "Zdroj příjmů",
      LegacyIncomeSource: "Předchozí zdroj příjmů",
      SpecifyIncomeSource: "Upřesněte zdroj příjmů",
      ExpectedMonthlyVolume: "Očekávaný měsíční objem",
      AverageTransactionValue: "Průměrná hodnota jedné transakce",
      PoliticallyExposed: "Politicky exponovaná osoba",
      NonEUPermanentResidence:
        "Mám aktuálně (ke dni registrace) bydliště mimo EU po dobu delší než 12 měsíců",
      NonEUNationality: "Jsem státním příslušníkem jiné země mimo EU",
      StreetNumber: "Číslo popisné",
      OrientationNumber: "Číslo orientační",
      PostalCode: "PSČ",
      DocumentNumber: "Číslo dokladu",
      BankAccount: "Bankovní účet",
      PartyError: "Při ukládání údajů osoby se vyskytla chyba",
      VatRegistration: "Registrace k DPH",
      VatNumberRestoredByRegistry:
        "Registr DPH potvrdil IČ DPH {{vatNumber}}, proto zůstává uložené — registr je zdrojem pravdy.",
      VatStatusNotVerifiedHint:
        "Stav v registru DPH zatím není ověřený. IČ DPH můžete doplnit kdykoli.",
      PersonalDataChangeNotification:
        "V případě potřeby změny osobních údajů zašlete prosím nové údaje na info@mo.one.",
      SecondDocumentUploadError: "Nepodařilo se nahrát druhý doklad",
      SecondDocumentUploadSuccess:
        "Druhý doklad byl úspěšně nahrán a zpracován",
      FirstDocumentUploadError: "Nepodařilo se nahrát doklad",
      FirstDocumentUploadSuccess: "Doklad byl úspěšně nahrán a zpracován",
      FirstDocumentUpload: {
        UploadButton: "Nahrát doklad",
        FileDescription: "Klikněte zde pro nahrání nebo vyfocení",
      },
      SecondDocumentUpload: {
        Title: "Druhý doklad",
        Description:
          "Druhým dokladem může být řidičský průkaz nebo cestovní pas.",
        UploadButton: "Nahrát druhý doklad",
        FileLabel: "Přední strana druhého dokladu",
        FileDescription: "Klikněte zde pro nahrání nebo vyfocení",
      },
    },
    Forms: {
      Validation: {
        InvalidEmail: "E-mail není validní",
        PasswordMinLength: "Heslo musí mít alespoň 8 znaků",
        PasswordLowercase: "Heslo musí obsahovat alespoň jedno malé písmeno",
        PasswordUppercase: "Heslo musí obsahovat alespoň jedno velké písmeno",
        PasswordNumber: "Heslo musí obsahovat alespoň jedno číslo",
        TermsAgreement: "Musíte souhlasit s obch. podmínkami",
        UserAlreadyExists: "Uživatel již {{appName}} používá.",
        InvitationAlreadySent: "Na tento e-mail jste již poslal pozvánku.",
        InvitationError: "Při pozvání se vyskytla chyba.",
      },
    },
    Merchant: {
      Logo: {
        FacilityTitle: "Logo provozovny",
        Hint: "Podporované formáty: PNG, JPEG, WebP, SVG (max. 2 MB). Doporučujeme tmavé logo na bílém nebo průhledném pozadí.",
        FileTooLarge: "Soubor je příliš velký (max. 2 MB)",
        InvalidFileType: "Nepodporovaný typ souboru",
        UploadSuccess: "Logo bylo nahráno",
        UploadError: "Nahrání loga se nezdařilo",
        DeleteSuccess: "Logo bylo smazáno",
        DeleteError: "Smazání loga se nezdařilo",
      },
      Avatar: {
        Title: "Avatar obchodníka",
        Hint: "Podporované formáty: PNG, JPEG, WebP (max. 2 MB). Avatar se zobrazuje jako obrázek obchodníka i v chatu.",
        RemoveConfirm: "Odebrat avatar obchodníka?",
        LockedAfterOnboardingHint:
          "Avatar obchodníka můžete měnit pouze během jeho onboardingu. Obchodník si ho může kdykoli změnit ve svém účtu.",
        UploadSuccess: "Avatar obchodníka byl uložen",
        UploadError: "Nahrání avataru obchodníka se nezdařilo",
        DeleteSuccess: "Avatar obchodníka byl odebrán",
        DeleteError: "Odebrání avataru obchodníka se nezdařilo",
      },
      Pricings: {
        PricingSettingError: "Chyba - Nepodařilo se nastavit ceník",
        PricingChangeError: "Chyba - Nepodařilo se změnit ceník",
        LoadingError: "Ceníky poplatků se nepodařilo načíst.",
        DirectPaymentError:
          "Poplatek přímé platby se nepodařilo načíst, kontaktujte prosím administrátora.",
        SelectPricingLabel: "Vyberte ceník",
        FeeWithFee: "{{totalFee}}%",
        FeeWithCategoryAndFee: "{{categoryName}} {{totalFee}}%",
        FeeWithFeeAndAssignedCount:
          "{{totalFee}}% - {{assignedCount}}× přiřazeno",
        FeeWithCategoryFeeAndAssignedCount:
          "{{categoryName}} {{totalFee}}% - {{assignedCount}}× přiřazeno",
        CategoryNames: {
          Partner: "Partner",
          Prime: "Prime",
          Standard: "Standard",
          Individual: "Individuální",
        },
      },
      BeneficialOwners: {
        BeneficialOwnerDetail: "Detail skutečného vlastníka",
        AddBeneficialOwner: "+ Přidat skutečného vlastníka",
        NewBeneficialOwner: "Nový skutečný vlastník",
        Title: "Skuteční vlastníci",
        LoadingError:
          "Chyba - Nepodařilo se načíst údaje o skutečných vlastnících",
        NoBeneficialOwners: "Není přidán žádný skutečný vlastník",
        Form: {
          DeleteConfirmation:
            "Opravdu chcete odstranit skutečného vlastníka {{name}}?",
          AddSuccess: "Vlastník byl úspěšně přidán",
          AddError: "Chyba - Nepodařilo se přidat vlastníka",
          UpdateSuccess: "Vlastník byl úspěšně upraven",
          UpdateError: "Chyba - Nepodařilo se upravit vlastníka",
          Legend: "Skutečný vlastník",
        },
      },
      LoadingError: "Chyba - Nepodařilo se načíst údaje o obchodníkovi",
      PaymentFailed: "Údaje se nepodařilo načíst.",
      AccountLoadingError: "Chyba - Nepodařilo se načíst Vaše účty",
      PayPoints: {
        NoBankAccountConnectedWarning: {
          title: "Není připojen bankovní účet",
          linkPretext: "Platby na paypoint lze vystavit až po",
          linkText: "připojení bankovního účtu.",
        },
        NoProductAssigned: "Nemáte přiřazen žádný produkt.",
        NoPaypointProduct:
          "Nemáte přiřazen žádný produkt umožňující vytvoření paypointu.",
      },
      ContactPersons: {
        Title: "Kontaktní osoby",
        LoadingError: "Chyba - Nepodařilo se načíst kontaktní osoby",
        DeleteSuccess: "Kontaktní osoba byla úspěšně odstraněna",
        DeleteError: "Chyba - Nepodařilo se odstranit kontaktní osobu",
        DeleteConfirmation:
          "Opravdu chcete odstranit kontaktní osobu {{name}}?",
        AddContactPerson: "+ Přidat kontaktní osobu",
        NewContactPerson: "Nová kontaktní osoba",
        ContactPersonDetail: "Detail kontaktní osoby",
        NoContactPersons: "Není přidána žádná kontaktní osoba.",
        Form: {
          AddSuccess: "Kontaktní osoba byla úspěšně přidána",
          AddError: "Chyba - Nepodařilo se přidat kontaktní osobu",
          UpdateSuccess: "Kontaktní osoba byla úspěšně upravena",
          UpdateError: "Chyba - Nepodařilo se upravit kontaktní osobu",
          Legend: "Kontaktní osoba",
        },
      },
      Facilities: {
        Title: "Provozovny",
        LoadingError: "Údaje o provozovnách se nepodařilo načíst.",
        DeleteSuccess: "Provozovna byla úspěšně odstraněna",
        DeleteError: "Chyba - Nepodařilo se odstranit provozovnu",
        DeleteConfirmation: "Opravdu chcete odstranit provozovnu {{name}}?",
        AddFacility: "+ Přidat provozovnu",
        NewFacility: "Nová provozovna",
        EditFacility: "Upravit provozovnu",
        FacilityDetail: "Detail provozovny",
        NoFacilities: "Není přidána žádná provozovna.",
        NoAddress: "Žádná adresa",
        Incomplete: "Nekompletní",
        NoPhotos: "Provozovna nemá nahrané žádné fotografie.",
        PhotosLoadingError: "Fotografie provozovny se nepodařilo načíst.",
        Form: {
          AddSuccess: "Provozovna byla úspěšně přidána",
          AddError: "Chyba - Nepodařilo se přidat provozovnu",
          UpdateSuccess: "Provozovna byla úspěšně upravena",
          UpdateError: "Chyba - Nepodařilo se upravit provozovnu",
          PhotoUploadSuccess: "Fotografie byly úspěšně nahrány",
          PhotoUploadError: "Chyba - Nepodařilo se nahrát fotografie",
          PhotoTooLarge: "Fotografie je příliš velká (max. {{maxSizeMb}} MB).",
          PhotoInvalidType:
            "Nepodporovaný typ souboru. Použijte JPEG, PNG nebo WebP.",
          PhotosNotSaved:
            "Provozovna byla uložena, ale fotografie se nenahrály. Opravte označenou fotografii a uložte znovu.",
          PhotosDescription:
            "Nahrajte fotografie vaší provozovny. Tyto fotografie budou viditelné pro zákazníky. JPEG, PNG nebo WebP, max. {{maxSizeMb}} MB na fotografii.",
          UploadPhotos: "Nahrát fotografie",
          PhotoSelected: "Vybrán soubor: {{name}}",
          PhotoUploadButton: "Nahrát",
          PhotoChangeButton: "Změnit",
          PhotoDeleteButton: "Smazat",
          Legend: {
            BasicInformation: "Základní informace",
            Contact: "Kontakt",
            OpeningHours: "Otevírací doba",
            Address: "Adresa",
            Turnover: "Obrat",
            Terminals: "Terminály",
            PublicFacilityInfo: "Informace o veřejné provozovně",
            DetailedOpeningHours: "Detailní otevírací doba",
            Photos: "Fotografie provozovny",
          },
          RequiredSection: "Povinné údaje",
          OptionalSection: "Nepovinné údaje",
          OptionalSectionDescription:
            "Obchodník tyto údaje doplní při své registraci. Pokud máte tyto informace k dispozici můžete je předvyplnit.",
          PublicFacilityDescription:
            "Veřejné provozovny vyžadují další informace. Vyplňte je prosím níže.",
          IsPublicHelpText:
            'Toto umožní zákazníkům vidět vaši provozovnu v seznamu "kde platit".',
          UseRegisteredAddress: "Shodná s adresou sídla",
          PrefillContact: "Předvyplnit kontakt z",
          NoName: "Bez jména",
          Validation: {
            CategoryRequiredWhenPublic:
              "Pro veřejnou provozovnu je vyžadována alespoň jedna kategorie",
          },
          Fields: {
            Name: "Název",
            ProvidedServices: "Poskytované služby",
            ResponsiblePerson: "Odpovědná osoba",
            Phone: "Telefon",
            Email: "E-mail",
            IsPublic: "Chci aby tato provozovna byla veřejná",
            Category: "Kategorie",
            OpeningHoursFrom: "Od",
            OpeningHoursTo: "Do",
            Address: {
              Street: "Ulice",
              StreetNumber: "Číslo popisné",
              OrientationNumber: "Číslo orientační",
              PostalCode: "PSČ",
              Municipality: "Obec",
              District: "Kraj",
            },
            WeekDays: {
              Monday: "Pondělí",
              Tuesday: "Úterý",
              Wednesday: "Středa",
              Thursday: "Čtvrtek",
              Friday: "Pátek",
              Saturday: "Sobota",
              Sunday: "Neděle",
            },
            YearlyTurnover: "Celkový obrat za poslední rok",
            RealCardTurnover:
              "Skutečný obrat prostřednictvím platebních karet za poslední rok",
            AverageTransactionValue: "Průměrná výše jedné transakce",
            EstimatedTurnover: "Předpokládaný celkový obrat",
            EstimatedTurnoverHelperText:
              "Prosím vyplňte toto pole pouze v případě, že se jedná o novou společnost",
            TerminalCount: "Počet fyzických terminálů",
            TerminalCountHelperText: "Fyzické terminály nezahrnují SoftPOS.",
            SoftPosCount: "Počet SoftPOS",
            SoftPosCountHelperText:
              "Platební aplikace v telefonu. Nerezervuje se žádný fyzický terminál.",
            Description: "O nás",
            PhotoOutside: "Fotografie exteriéru",
            PhotoInside: "Fotografie interiéru",
          },
          OpeningHours: {
            Title: "Otevírací doba",
            ClosedAllDay: "Zavřeno celý den",
            OpenAllDay: "Otevřeno 24 hodin",
            AddTimeRange: "Přidat časový rozsah",
            DeleteTimeRange: "Smazat časový rozsah",
            From: "Od",
            To: "Do",
            BulkEdit: "Upravit všechny",
            ExitBulkEdit: "Ukončit hromadnou úpravu",
            ApplyToSelected: "Uložit pro vybrané dny",
            SelectDays: "Vyberte dny",
            QuickSelectTitle: "Rychlý výběr",
            Cancel: "Zrušit",
            Save: "Uložit",
            TimeRange: "Od - Do",
            CurrentHours: "Aktuální otevírací doba",
            ShowDetailedEdit: "Upravit jednotlivé dny",
            HideDetailedEdit: "Skrýt úpravu jednotlivých dnů",
            QuickSelect: {
              Weekdays: "Po-Pá",
              AllWeek: "Po-Ne",
              Weekend: "Víkend",
            },
            Validation: {
              CannotBeBothOpenAndClosed:
                "Nemůže být současně otevřeno i zavřeno celý den",
              InvalidTimeFormat: "Neplatný formát času. Očekává se HH:MM:SS",
              OpeningTimeBeforeClosingTime:
                "Čas zavření musí být později než čas otevření",
            },
          },
        },
      },
      OrbitL: {
        Title: "Platební terminály",
        StatusLabel: "Stav objednávky",
        RefreshTooltip: "Aktualizovat stav",
        Tariff: {
          Label: "Ceník",
          Pos1Cz: "Ceník 1 — 0,49 % MIF++",
          Pos2Cz: "Ceník 2 — 0,41 % MIF++",
          Pos3Cz: "Ceník 3 — 0,35 % MIF++",
          Pos4Cz: "Ceník 4 — 0,29 % MIF++",
        },
        Financing: {
          Label: "Financování terminálu",
          Legione: "Terminál financován Legi.one",
          Hunter: "Terminál financován Hunterem",
        },
        HunterCapacity: {
          AvailableHelper: "Hunter má k dispozici {{count}} terminálů",
          ExceedsError:
            "Počet terminálů ({{requested}}) překračuje dostupnou kapacitu huntera ({{available}}).",
        },
        Progress: {
          Steps: {
            Completion: "Doplnění údajů",
            Signing: "Podpis dokumentů",
            Processing: "Zpracování",
            Dispatch: "Expedice terminálů",
            DispatchSoftPos: "Aktivace SoftPOS",
            Done: "Dokončeno",
          },
        },
        Checklist: {
          Heading: "Kontrolní seznam požadavků",
          CompletionSuccess:
            "Všechny požadavky jsou splněny. Můžete pokračovat k stažení smlouvy.",
          ToCompleteSection: "K doplnění",
          GoToSettingsLink: "Přejít do nastavení",
          Items: {
            BasicInfo: "Základní údaje obchodníka",
            FacilityInfo: "Informace o provozovně",
            BankAccountInfo: "Bankovní účet pro výplatu",
            ExecutiveInfo: "Údaje statutárního zástupce",
            ExecutiveInfoSelfEmployed: "Vaše osobní údaje",
            ExecutiveDocuments: "Doklady totožnosti zástupce",
            ExecutiveDocumentsSelfEmployed: "Vaše doklady totožnosti",
            TerminalAssignment: "Přiřazení terminálů k provozovnám",
          },
          Validation: {
            BasicInfo: "Doplňte prosím základní údaje obchodníka",
            FacilityInfo: "Doplňte prosím informace o provozovně",
            BankAccountInfo: "Přidejte nebo ověřte bankovní účet pro výplatu",
            ExecutiveInfo: "Doplňte prosím údaje statutárního zástupce",
            ExecutiveInfoSelfEmployed: "Doplňte prosím vaše osobní údaje",
            ExecutiveDocuments: "Nahrajte prosím doklady totožnosti zástupce",
            ExecutiveDocumentsSelfEmployed:
              "Nahrajte prosím vaše doklady totožnosti",
            TerminalAssignment:
              "Terminály nejsou plně přiřazeny ke všem provozovnám",
          },
          BankReconnect: {
            Explanation:
              "Bankovní účet máte přidaný, ale chybí ověření jeho vlastnictví. Obnovte prosím připojení k bance – přihlásíte se do internetového bankovnictví a vrátíte se zpět.",
            Button: "Obnovit připojení banky",
          },
          MissingFields: {
            MissingExecutive: "není evidován žádný statutární zástupce",
            PrimaryBankAccount:
              "není nastaven primární bankovní účet pro výplatu",
            BankVerificationAudit: "chybí ověření vlastnictví bankovního účtu",
            BirthDate: "datum narození",
            Email: "e-mail",
            Phone: "telefon",
            PermanentAddress: "místo bydliště",
            PermanentAddressStreet: "ulice nebo číslo domu",
            PermanentAddressMunicipality: "obec bydliště",
            PermanentAddressPostalCode: "PSČ bydliště",
            Documents: "doklady totožnosti",
            FirstDocumentNumber: "číslo prvního dokladu",
            FirstDocumentValidity: "platnost prvního dokladu",
            FirstDocumentPhotos: "fotografie prvního dokladu",
            SecondDocumentNumber: "číslo druhého dokladu",
            SecondDocumentValidity: "platnost druhého dokladu",
            SecondDocumentPhotos: "fotografie druhého dokladu",
          },
        },
        Rejection: {
          Title: "Zpracovatel vrátil doklady k opravě",
          Intro:
            "U níže uvedených dokladů je potřeba provést opravu. Doplňte je v nastavení a my objednávku odešleme znovu.",
          ContractGroup: "Smlouva a firemní údaje",
          DocumentLabel: "{{type}} č. {{number}}",
          DocumentTypes: {
            IdCard: "Občanský průkaz",
            Passport: "Pas",
            DriverLicense: "Řidičský průkaz",
            OtherDocument: "Ostatní dokument",
          },
        },
        Phase: {
          RequiresCompletion: "Vyžaduje doplnění",
          ReadyToDownloadContract: "Připraveno ke stažení",
          ContractDownloaded: "Smlouva stažena",
          SubmittedToComgate: "Odesláno ke zpracování",
          ProcessingByComgate: "Zpracováváme",
          TerminalDispatched: "Terminály vyexpedovány",
          Completed: "Dokončeno",
        },
        FinancingModel: {
          Hunter: "Hunter",
          Legione: "LEGI.ONE",
        },
        Messages: {
          LoadStatusError: "Nepodařilo se načíst stav objednávky Orbit L",
          Processing:
            "Vaše objednávka se zpracovává. O dalším postupu vás budeme informovat emailem.",
          CompletedSuccess:
            "Objednávka je dokončena. Terminály byly předány a jsou aktivní.",
        },
        Contract: {
          DocumentsHeading: "Smluvní dokumenty",
          LoanTitle: "Smlouva o výpůjčce terminálu",
          LoanFileName: "Smlouva_o_vypujcce_terminalu",
          PaymentServicesTitle: "Smlouva o platebních službách",
          PaymentServicesFileName: "Smlouva_o_platebnich_sluzbach",
          DownloadedAt: "Smlouva byla stažena dne {{date}}",
          DownloadButton: "Stáhnout smlouvu",
          DownloadAgainButton: "Stáhnout smlouvu znovu",
          AcceptanceLabel:
            'Potvrzuji, že jsem si přečetl/a obě smlouvy a souhlasím s jejich podmínkami. Kliknutím na tlačítko "Závazně objednat" smlouvy elektronicky podepisuji.',
          SubmitButton: "Závazně objednat karetní služby",
          SubmittingButton: "Odesílám...",
          SubmitNote:
            "Po odeslání objednávky zpracujeme vaši žádost. O dalším postupu vás budeme informovat emailem.",
          DownloadSuccess: "Smlouva byla úspěšně stažena",
          DownloadError: "Stažení smlouvy selhalo",
          SubmitSuccess: "Objednávka byla úspěšně odeslána ke zpracování.",
          SubmitError: "Odeslání objednávky Orbit L selhalo: {{error}}",
          SubmitErrorGeneric: "Odeslání objednávky selhalo",
        },
        Handover: {
          DispatchedNoData:
            "Terminály byly vyexpedovány. Informace o terminálech budou doplněny automaticky po aktualizaci stavu.",
          Title: "Předání terminálů",
          DispatchedReady:
            "Vaše terminály byly vyexpedovány a jsou připraveny k aktivaci.",
          TableTID: "TID (Terminal ID)",
          TableSerialNumber: "Sériové číslo",
          TableModel: "Model",
          Note: "Po potvrzení předání budou terminály automaticky aktivovány jako platební místa (PayPoints) ve vašem účtu.",
          ConfirmButton: "Potvrdit přijetí terminálů",
          ConfirmingButton: "Potvrzuji...",
          ConfirmSuccess: "Předání terminálů bylo úspěšně potvrzeno",
          ConfirmError: "Potvrzení předání terminálů selhalo: {{error}}",
          ConfirmErrorGeneric: "Potvrzení předání selhalo",
        },
        TerminalSelection: {
          Title: "Výběr terminálů",
          SelectionCount: "{{selected}} z {{required}} terminálů vybráno",
          NoTerminalsAvailable:
            "Nemáte k dispozici žádné terminály pro přiřazení",
          StockExceeded:
            "Celkový počet terminálů ({{total}}) přesahuje dostupný sklad ({{available}})",
          SerialNumber: "SN",
          HardwareModel: "Model",
        },
        FacilityTerminals: {
          Title: "Přiřazení terminálů k provozovnám",
          TerminalCountLabel: "Počet fyzických terminálů",
          TerminalCountHelperText: "Fyzické terminály nezahrnují SoftPOS.",
          SoftPosCountLabel: "Počet SoftPOS",
          SoftPosCountHelperText:
            "Platební aplikace v telefonu, bez fyzického terminálu.",
          SoftPosRequestHelperText:
            "SoftPOS zatím nemáte. Zadejte počet a odešlete žádost, po potvrzení podporou se SoftPOS aktivuje.",
          SoftPosStatus: "SoftPOS: {{count}}",
          TerminalStatus: "{{assigned}}/{{total}} přiřazeno",
          NoTerminalsConfigured: "Terminály nenastaveny",
          NoAddress: "Žádná adresa",
          FullyReserved: "Všechny terminály jsou přiřazeny",
          SaveButton: "Uložit terminály",
          Saving: "Ukládám...",
          SaveSuccess: "Terminály byly úspěšně přiřazeny",
          SaveError: "Přiřazení terminálů selhalo",
          InsufficientStock:
            "Nedostatečný počet terminálů na skladě. Kontaktujte podporu.",
          CountsLocked:
            "Počty terminálů už nelze měnit přímo, objednávka je u Comgate. Pošlete žádost o změnu počtu, kterou vyřídí podpora.",
          LoadError: "Nepodařilo se načíst data o terminálech",
          AssignedTerminals: "Přiřazené terminály",
        },
        TerminalCountChange: {
          NotificationTitle: "Žádost o změnu počtu terminálů",
          NotificationMessage:
            "{{company}} žádá o změnu počtu terminálů z {{from}} na {{to}}.",
          LockedHint:
            "Objednávka už je u Comgate, počet terminálů proto nelze změnit přímo. Pošlete žádost podpoře.",
          RequestButton: "Požádat o změnu",
          ModalTitle: "Žádost o změnu počtu terminálů",
          ModalDescription:
            "Po odeslání objednávky do Comgate už počet terminálů nelze změnit automaticky. Odesláním vytvoříte žádost pro naši podporu, která změnu domluví s Comgate a ozve se vám.",
          ModalSummaryHeading: "Souhrn změny",
          ModalFacilityChange: "{{facility}}: {{from}} → {{to}}",
          ModalTotal: "Celkem: {{from}} → {{to}}",
          ModalFacilitySoftPosChange:
            "{{facility}} (SoftPOS): {{from}} → {{to}}",
          ModalSoftPosTotal: "SoftPOS celkem: {{from}} → {{to}}",
          ModalNoteLabel: "Poznámka pro podporu (nepovinné)",
          ModalNotePlaceholder: "Např. otevíráme novou pobočku 1. 9.",
          ModalConfirm: "Odeslat žádost",
          ModalCancel: "Zrušit",
          PendingTitle: "Žádost o změnu počtu terminálů byla odeslána",
          PendingMessage:
            "Žádost o změnu počtu terminálů z {{from}} na {{to}} byla odeslána podpoře. Ozveme se vám, jakmile změnu s Comgate domluvíme.",
          PendingNote: "Vaše poznámka: {{note}}",
          PendingSoftPosMessage: "SoftPOS licence: {{from}} → {{to}}.",
          RequestSuccess: "Žádost byla odeslána podpoře",
          RequestError: "Žádost se nepodařilo odeslat",
          RequestConflictError:
            "Už máte otevřenou žádost o změnu počtu terminálů. Vyčkejte na její vyřízení.",
        },
      },
      TerminalContracts: {
        Title: "Podklady pro terminál",
        LoadingError: "Údaje o podkladech pro terminál se nepodařilo načíst.",
        NoTerminalContracts: "Není přidán žádný podklad pro terminál.",
        AddSuccess: "Podklady pro terminál byly úspěšně přidány",
        AddError: "Chyba - Nepodařilo se přidat podklady pro terminál",
        UpdateSuccess: "Podklady pro terminál byly úspěšně upraveny",
        UpdateError: "Chyba - Nepodařilo se upravit podklady pro terminál",
        DeleteSuccess: "Podklady pro terminál byly úspěšně odstraněny",
        DeleteError: "Chyba - Nepodařilo se odstranit podklady pro terminál",
        DeleteConfirmation:
          "Opravdu chcete odstranit podklad pro smlouvu {{type}}?",
        AddButtonText: "+ Vytvořit nový podklad pro smlouvu k terminálu",
        NewContractDialogTitle: "Nový podklad pro smlouvu k terminálu",
        EditContractDialogTitle: "Upravit podklad pro smlouvu k terminálu",
        ViewContractDialogTitle: "Detail podkladu pro smlouvu k terminálu",
        ProductType: {
          UCB: "Orbit M - Fyzický terminál bez tiskárny (Android)",
          COMGATE: "Orbit L - Fyzický terminál s tiskárnou (Android)",
          ELCOM: "Orbit ELCOM - Terminál ELCOM",
        },
        Form: {
          Fields: {
            Type: "Typ",
            GprsCount: "Počet GPRS terminálů",
            TerminalCount: "Počet fyzických terminálů",
            TerminalCountHelperText: "Fyzické terminály nezahrnují SoftPOS.",
            SoftPosCount: "Počet SoftPOS",
            CountsFromFacilitiesHint:
              "Součet za provozovny; upravuje se ve formuláři provozovny.",
            Currencies: "Měny",
            Tariff: "Tarif",
            PayoutIBAN: "IBAN pro výplaty",
            PayoutBIC: "BIC pro výplaty",
            PayoutCurrency: "Měna výplat",
            PayoutAccountNumber: "Číslo účtu pro výplaty",
          },
        },
        Comgate: {
          SubmitButton: "Odeslat do Comgate",
          Submitting: "Odesílání...",
          SubmitConfirmation:
            "Tato akce vygeneruje smlouvu o půjčce, automaticky ji přijme a odešle data obchodníka do Comgate. Pokračovat?",
          SubmitSuccess: "Úspěšně odesláno do Comgate. MID: {{mid}}",
          SubmitError:
            "Nepodařilo se odeslat do Comgate. Zkuste to prosím znovu.",
          SubmitViaOrbitL:
            "Pro odeslání smlouvy do Comgate použijte Orbit L onboarding.",
          StatusLabel: "Stav Comgate",
          Statuses: {
            REQUESTED: "Požadováno",
            PROCESSING: "Zpracovává se",
            WAITING_FOR_DOCUMENTS: "Čeká se na dokumenty",
            WAITING_FOR_AUTHORIZATION_PAYMENT: "Čeká se na autorizační platbu",
            ERRORS_IN_DOCUMENTS: "Chyby v dokumentech",
            ERROR_ACTION_PENDING: "Chyba – čeká se na akci",
            REJECTED: "Zamítnuto",
            ASSOCIATION_REGISTERING: "Registrace u asociace",
            READY: "Připraveno",
          },
        },
      },
      AppProducts: {
        Title: "Produkty",
        LoadingError: "Produkty se nepodařilo načíst.",
        NoProducts: "Není přidán žádný produkt.",
        Form: {
          AddError: "Chyba - Nepodařilo se přidat produkt",
          AddErrorCountsLocked:
            "Objednávka už je u Comgate, produkt proto nelze přidat přímo. Pošlete žádost o změnu počtu terminálů, kterou vyřídí podpora.",
          RemoveError: "Chyba - Nepodařilo se odebrat produkt",
          Prerequisites: {
            Title: "Podmínky pro aktivaci produktu",
            FacilityAdded: "Vyplněná provozovna",
            FacilityPhotos: "Fotografie provozovny (exteriér + interiér)",
          },
        },
        UnknownProduct: "Neznámý produkt",
        Products: {
          OrbitS: "Orbit S",
          OrbitM: "Orbit M",
          OrbitL: "Orbit L",
          SoftPos: "SoftPOS",
        },
        ProductDescriptions: {
          OrbitS: "Žádný fyzický terminál, 3 NFC kartičky",
          OrbitM: "Orbit M - Fyzický terminál bez tiskárny (Android)",
          OrbitL: "Orbit L - Fyzický terminál s tiskárnou (Android)",
          SoftPos:
            "SoftPOS - Platební aplikace v telefonu, bez fyzického terminálu",
        },
        ProductAccordion: {
          Active: "Aktivní",
          Activate: "Aktivovat produkt",
          Deactivate: "Deaktivovat",
          Preview: "Připravujeme",
          Default: "Výchozí",
          ProductNotActivated: "Tento produkt nebyl aktivován",
          SoftPosViaChangeRequest:
            "Objednávka terminálů už je u Comgate. SoftPOS přidáte na kartě Orbit L: u provozovny zadejte počet SoftPOS a odešlete žádost o změnu počtu. Po potvrzení podporou se SoftPOS aktivuje.",
          SoftPosContactSupport:
            "Objednávka terminálů už je u Comgate. Pro přidání SoftPOS kontaktujte podporu.",
          FeeWithPricing: "Poplatek: {{totalFee}}% | {{productName}}",
          FeeWithCategoryAndPricing:
            "{{categoryName}} | Poplatek: {{totalFee}}% | {{productName}}",
          IndividualPricing: "Individuální ceník",
        },
      },
    },
    ProfilePhoto: {
      ChangeAction: "Změnit fotku",
      RemoveAction: "Odebrat fotku",
      CropDialogTitle: "Ořízněte fotku",
      ZoomLabel: "Přiblížení",
      CropSave: "Uložit",
      CropCancel: "Zrušit",
      FileTooLarge: "Soubor je příliš velký (max. 2 MB)",
      InvalidFileType:
        "Nepodporovaný typ souboru. Použijte PNG, JPEG nebo WebP.",
    },
    UserAccount: {
      ProfilePhoto: {
        Hint: "Podporované formáty: PNG, JPEG, WebP (max. 2 MB)",
        RemoveConfirm: "Opravdu odebrat profilovou fotku?",
        UploadSuccess: "Profilová fotka byla uložena",
        UploadError: "Nahrání profilové fotky se nezdařilo",
        DeleteSuccess: "Profilová fotka byla odebrána",
        DeleteError: "Odebrání profilové fotky se nezdařilo",
      },
      ChangePassword: {
        SectionTitle: "Heslo",
        OpenAction: "Změnit heslo",
        DialogTitle: "Změna hesla",
        OldPasswordLabel: "Současné heslo",
        NewPasswordLabel: "Nové heslo",
        NewPasswordConfirmLabel: "Potvrzení nového hesla",
        Submit: "Změnit heslo",
        Cancel: "Zrušit",
        Success: "Heslo bylo změněno. Přihlaste se prosím znovu novým heslem.",
        NewMustDiffer: "Nové heslo se musí lišit od současného.",
        WrongOldPassword: "Současné heslo není správné.",
        GenericError: "Změna hesla se nezdařila. Zkuste to prosím znovu.",
        RateLimitError:
          "Příliš mnoho pokusů. Počkejte chvíli a zkuste to znovu.",
      },
    },
    Onboarding: {
      LogoutButtonLabel: "Opustit registraci",
      LicensePaymentReceived: "Platba přijata",
      LicensePaymentProcessing: "Platbu zpracováváme",
      SSO: {
        MerchantDescription:
          "Jako obchodník můžete přijímat platby od svých zákazníků s nižšími poplatky a využívat bezkontaktní paypointy.",
        CustomerDescription:
          "Jako uživatel můžete posílat přímé platby, platit za své nákupy a sbírat Stardust body.",
        HunterDescription:
          "Jako hunter můžete získat Legione licenci, spravovat své obchodníky, a získat provize z jejich transakcí",
        Merchant: "Obchodník",
        Customer: "Uživatel",
        FirstLogin:
          "Protože se jedná o Vaše první přihlášení, potřebujeme zjistit, jestli se k nám registrujete jako Uživatel, Obchodník nebo Hunter.",
      },
    },
    Shared: {
      Filters: {
        Title: "Filtry",
        TimePeriod: "Období",
        TimePeriodLabels: {
          day: "Dnes",
          week: "Tento týden",
          month: "Tento měsíc",
          custom: "Vlastní",
        },
        Unlimited: "Neomezeno",
        DateFrom: "Od",
        DateTo: "Do",
        DateRange: "Zadejte vlastní období",
        PayPoint: "PayPoint",
        AllPayPoints: "Všechny PayPointy",
        Employee: "Zaměstnanec",
        AllEmployees: "Všichni zaměstnanci",
        Status: "Stav",
        AllStatuses: "Všechny stavy",
        Apply: "Použít",
        Reset: "Zrušit filtry",
        RefundOrCancellation: "Refund nebo storno",
        ShowOnlyRefundsAndCancellations: "Pouze refundace a storna",
      },
      NotificationTypeSelect: {
        SelectNotificationType: "Vyberte typ notifikace",
      },
      CodeListAutocomplete: {
        Placeholder: "Vybrat možnosti",
        SelectAll: "Vybrat všechny",
      },
      Carousel: {
        ScrollLeft: "Předchozí",
        ScrollRight: "Další",
      },
      Dropdown: {
        NoOptions: "Žádné dostupné položky",
      },
      PoliticallyExposedDescription: `Politicky exponovaná osoba (PEP) je osoba, která zastává nebo v nedávné minulosti zastával významnou veřejnou funkci, jako například prezident, premiér, ministr, velvyslanec, soudce nejvyššího soudu, vyšší armádní důstojník nebo člen parlamentu. K politicky exponovaným osobám se mohou řadit také jejich blízcí rodinní příslušníci nebo blízcí spolupracovníci.
      Zákonnou definici PEP naleznete v ust. § 4 odst. 5 zákona č. 253/2008 Sb., o některých opatřeních proti legalizaci výnosů z trestné činnosti a financování terorismu.`,
      DownloadPartyIdentificationsButtonLabel: "Stáhnout doklady",
      Payments: {
        Amount: "Částka",
        VariableSymbol: "Variabilní symbol",
        Note: "Poznámka",
      },
      SettlementPeriodSelector: {
        Placeholder: "Vyberte období",
        NoSettlementPeriods:
          "V tuto chvíli není dostupná žádná uzávěrka ke stažení.",
      },
      BankingAccountSelector: {
        NoBankAccounts: "Nemáte připojený žádný bankovní účet.",
        ConnectBankAccount: "Připojení účtu",
      },
      CardsList: {
        View: "Zobrazit",
        Edit: "Upravit",
        Delete: "Smazat",
        Download: "Stáhnout",
      },
      HunterAutocomplete: {
        SearchHunter: "Vyberte dalšího Huntera",
        SearchHunterMinLength: "Zadejte alespoň 2 znaky pro vyhledávání",
        SearchHunterNoResults: "Žádní hunteři nebyli nalezeni",
        SearchHunterPlaceholder: "Zadejte jméno nebo číslo licence",
      },
      MerchantUserAutocomplete: {
        Placeholder: "Název nebo IČO",
        MinLength: "Zadejte alespoň 2 znaky pro vyhledávání",
        NoResults: "Žádní obchodníci nebyli nalezeni",
      },
      AddressAutocomplete: {
        MinLength: "Zadejte alespoň 3 znaky pro vyhledávání",
        NoResults: "Žádná adresa nenalezena",
        Error:
          "Vyhledávání adres je momentálně nedostupné, zadejte adresu ručně",
      },
      AddressInput: {
        SearchLabel: "Adresa z evidence",
        EnterManually: "Zadat adresu ručně",
        SearchInRegistry: "Vyhledat adresu v evidenci",
        NotInRegistry:
          "Tuto adresu se nepodařilo najít v evidenci adres, zkontrolujte ji prosím.",
        HasErrors: "Adresa není úplná nebo obsahuje chyby, zkontrolujte ji.",
        UncommittedQuery:
          "Pro úpravu vyberte adresu z nabídky – samotné přepsání textu adresu nezmění.",
      },
      Progress: {
        AriaLabel: "Postup: {{progress}}%",
      },
      HunterList: {
        MainHunterCard: {
          YourCommission: "Vaše provize",
        },
      },
    },
    Transactions: {
      Tabs: {
        Transfers: "Převody",
        Cards: "Karty",
        AriaLabel: "Typ transakce",
      },
      Title: "Transakce",
      LoadMore: "Načíst další",
      Export: "Exportovat transakce",
      NoTransactions: "Zatím nebyla provedena žádná transakce.",
      PendingRefunds: "Čekající reverzní platby",
      MerchantDetailTransactionFees: {
        Title: "Náklady na transakce tento měsíc",
      },
      TransactionPaymentOptions: {
        DirectPaymentButton: "Přímá platba",
        ShowPaymentDataButton: "Zobrazit platební údaje",
      },
      Filters: {
        Direction: "Směr",
        AllDirections: "Všechny směry",
      },
      Summary: {
        Revenue: {
          day: "Denní tržba",
          week: "Týdenní tržba",
          month: "Měsíční tržba",
          custom: "Tržba za období",
        },
        UnlimitedRevenue: "Celková tržba",
        FilteredRevenue: "Tržba dle filtrů",
        FilterSuffix: "dle filtrů",
      },
      Search: {
        Placeholder: "Hledat podle ID transakce...",
      },
      ExportActions: {
        Download: "Stáhnout",
        Email: "Odeslat na e-mail",
      },
      ExportDrawer: {
        ExportSelectionPdf: "Export dle filtrů (.pdf)",
        ExportSelectionXlsx: "Export dle filtrů (.xlsx)",
        ExportSelectionCsv: "Export dle filtrů (.csv)",
        ExportTodayRevenueCsv: "Export dnešní tržby (.csv)",
        SendToEmail: "Odeslat na e-mail (PDF + XLSX)",
        EmailAddress: "E-mailová adresa",
        EnterEmailAddress: "Zadejte e-mailovou adresu",
        Send: "Odeslat",
        Cancel: "Zrušit",
        EmailSentSuccess: "Export byl odeslán na váš e-mail",
        EmailSentError: "Nepodařilo se odeslat export na e-mail",
      },
      Direction: {
        Incoming: "Příchozí platba",
        Outgoing: "Odchozí platba",
        IncomingRefund: "Příchozí vrácení",
        OutgoingRefund: "Odchozí vrácení",
      },
    },
    CardTransactions: {
      Title: "Karetní transakce",
      LoadMore: "Načíst další",
      NoCardTransactions: "Zatím žádné karetní transakce",
      Columns: {
        DateTime: "Datum a čas",
        Terminal: "Terminál",
        Operator: "Obsluha",
        Amount: "Částka",
        Status: "Stav",
        CardBrand: "Karta",
        Pan: "Číslo karty",
        Refund: "Refundace/storno",
      },
      Status: {
        Approved: "Schváleno",
        Rejected: "Zamítnuto",
        Canceled: "Zrušeno",
        Pending: "Probíhá",
        Unknown: "Neznámý",
      },
      Direction: {
        Sale: "Platba",
        Refund: "Refundace",
        Cancellation: "Storno",
        Adjustment: "Korekce",
      },
      Summary: {
        NetAmount: "Čistý obrat",
        Sales: "Tržby",
        SalesCount: "Počet plateb: {{count}}",
        Refunds: "Refundace",
        RefundsCount: "Počet refundací: {{count}}",
      },
      Export: {
        Download: "Stáhnout",
        Email: "Odeslat na e-mail",
        ExportPdf: "Export dle filtrů (.pdf)",
        ExportXlsx: "Export dle filtrů (.xlsx)",
        ExportCsv: "Export dle filtrů (.csv)",
        SendToEmail: "Odeslat na e-mail (PDF + XLSX)",
        EmailAddress: "E-mailová adresa",
        EnterEmailAddress: "Zadejte e-mailovou adresu",
        Send: "Odeslat",
        Cancel: "Zrušit",
        EmailSentSuccess: "Export byl odeslán na váš e-mail",
        EmailSentError: "Nepodařilo se odeslat export na e-mail",
        DownloadError: "Nepodařilo se stáhnout export",
      },
    },
    Sell: {
      OfferValid: "Nabídka platí ješte {{seconds}}s",
    },
    Affiliate: {
      LeadStatus: {
        AnonymousPaymentPerformed: "První platba",
        Invited: "Pozvaných",
        Registered: "Registrovaných",
        Completed: "Dokončených",
        CompletedRewardSent: "Dokončených",
        CompletedRewardApplied: "Dokončených",
        Withdrawn: "Odstoupených",
      },
      ThanksToYou: {
        Participation: {
          Title: "Účast v programu Díky Tobě!",
          OptedInStatus:
            "Účastníte se programu Díky Tobě! a získáváte odměny za doporučení.",
          OptOutButton: "Odhlásit se z programu",
          OptOutDialogTitle: "Odhlásit se z programu Díky Tobě!",
          OptOutDialogIrreversible:
            "Odhlášení je nevratné. Do programu se už nebudete moci vrátit.",
          OptOutDialogLoseTitle: "Přijdete o",
          OptOutDialogLoseReferrals:
            "Všechna dosavadní doporučení a odměny z nich",
          OptOutDialogLoseInviter: "Vazbu na toho, kdo vás pozval",
          OptOutDialogKeepTitle: "Zůstane vám",
          OptOutDialogKeepRewards: "Odměny, které vám už vznikly",
          OptOutDialogKeepAccount: "Účet a všechny ostatní funkce {{appName}}",
          OptOutDialogEmailNote:
            "Pošleme vám e-mail na {{email}}, odhlášení dokončíte kliknutím na odkaz v něm.",
          OptOutDialogConfirm: "Poslat potvrzovací e-mail",
          EmailSent:
            "Poslali jsme potvrzovací e-mail na {{email}}. Odhlášení dokončíte kliknutím na odkaz v e-mailu, platí do {{expiresAt}}. Dokud na odkaz nekliknete, zůstáváte v programu.",
          ResendButton: "Poslat e-mail znovu",
          EmailSentToast: "Potvrzovací e-mail je na cestě.",
          EmailSendError:
            "Potvrzovací e-mail se nepodařilo odeslat. Zkuste to prosím za chvíli znovu.",
          EmailCooldownError:
            "Potvrzovací e-mail jsme vám poslali před chvílí. Zkuste to znovu za minutu.",
        },
        Join: {
          Title: "Programu Díky Tobě! se neúčastníte",
          Text: "Při registraci jste účast v programu odmítli. Po přihlášení můžete zvát přátele a získávat odměny z jejich plateb. Dřívější pozvánky a doporučení se neobnoví.",
          Button: "Přihlásit se do programu",
          JoinedToast: "Přihlásili jste se do programu Díky Tobě!",
        },
        Withdrawn: {
          Title: "Program Díky Tobě!",
          Text: "Z programu Díky Tobě! jste trvale odstoupili. Odměny, které vám už vznikly, vám zůstávají. Znovu se do programu přihlásit nelze.",
          PayoutBalance: "Zbývá k výplatě: {{amount}}",
        },
        WithdrawalPage: {
          Title: "Odhlášení z programu Díky Tobě!",
          Prompt:
            "Kliknutím potvrdíte trvalé odhlášení z programu Díky Tobě!. Přijdete o všechna doporučení i vazbu na toho, kdo vás pozval; odměny, které vám už vznikly, vám zůstávají.",
          ConfirmButton: "Potvrdit odhlášení",
          Success: {
            Title: "Odhlášení dokončeno",
            Text: "Z programu Díky Tobě! jste se trvale odhlásili. Odměny, které vám už vznikly, vám zůstávají.",
          },
          AlreadyWithdrawn: {
            Title: "Už jste odhlášeni",
            Text: "Odhlášení z programu Díky Tobě! už proběhlo. Nemusíte nic dalšího dělat.",
          },
          Expired: {
            Title: "Odkaz už neplatí",
            Text: "Platnost odkazu vypršela, nebo jsme vám mezitím poslali novější. Pokud se chcete odhlásit, vyžádejte si v sekci Díky Tobě! nový e-mail.",
          },
          Error: {
            Title: "Odhlášení se nepodařilo",
            Text: "Odhlášení se nepodařilo dokončit. Zkuste odkaz otevřít znovu, nebo si v sekci Díky Tobě! vyžádejte nový e-mail.",
          },
          ContinueButton: "Pokračovat do aplikace",
          OpenSectionButton: "Otevřít sekci Díky Tobě!",
        },
      },
      AffiliateStats: {
        Invited: "Pozvaní uživatelé",
        Registered: "Registrovaní uživatelé",
        WithActiveLicense: "S aktivní licencí",
        AnonymousPayment: "První platba s {{appName}}",
      },
      AffiliateLink: {
        Title: "Váš affiliate odkaz",
        LoadingError: "Váš affiliate kód se nepodařilo získat.",
        CopyLink: "Kopírovat odkaz",
        LinkCopied: "Zkopírováno!",
        ShareButton: {
          Title: "{{appName}}",
          Text: "Pozvánka do {{appName}}",
        },
      },
      AffiliateLinkWithActions: {
        InviteFriend: "Pozvat přítele",
        ShareButton: "Sdílet",
        EmailButton: "Poslat na e-mail",
        QrButton: "Zobrazit QR",
        QrCodeFileName: "Affiliate QR kód",
        QrInstructions:
          "Tento QR kód ukažte příteli, kterého chcete pozvat do {{appName}}",
        LinkTypeToggle: {
          Title: "Vyberte cíl odkazu",
          Registration: "Přímá registrace",
          MooneInfo: "Přes {{appName}} web",
        },
      },
      CodeField: {
        SectionTitle: "Doporučení",
        Label: "Affiliate kód",
        Placeholder: "Vyplňte, pokud vás někdo doporučil",
        Verified: "Kód je platný.",
        RecommendedBy: "Doporučil(a) vás: {{name}}",
        Locked: "Affiliate je již aktivní a nejde ho změnit.",
        LockedBy:
          "Affiliate je již aktivní a nejde ho změnit. Doporučil(a) vás: {{name}}",
        ApplyFailed:
          "Affiliate kód se nepodařilo uložit, registrace pokračuje bez něj.",
        Error: {
          AffiliateCodeNotFound: "Tento kód neexistuje.",
          AffiliateCodeOwn: "Vlastní kód použít nejde.",
          AffiliateCodeNotApplicable:
            "Tento kód pro tuto registraci použít nejde.",
          AffiliateReferrerAlreadySet: "Affiliate je již aktivní.",
          AffiliateReferrerTooLate: "Affiliate kód už nejde přidat.",
          TooManyRequests: "Příliš mnoho pokusů, zkuste to prosím za chvíli.",
          Unavailable: "Kód se nepodařilo ověřit, zkuste to prosím znovu.",
          Unverified: "Kód ověřte, nebo ho smažte.",
        },
      },
      LeadInvitation: {
        NewInvitation: "Nová pozvánka",
        FriendInvited: "Děkujeme. Váš přítel byl úspěšně pozván.",
        UserAlreadyExists: "Uživatel s tímto e-mailem již {{appName}} používá.",
        InvitationAlreadySent: "Pozvánka již byla na tento e-mail odeslána.",
        GeneralError: "Při odesílání pozvánky se vyskytla chyba.",
        SendInvitation: {
          Hunter: "Odeslat pozvánku huntera",
          Customer: "Odeslat pozvánku",
          Merchant: "Odeslat pozvánku obchodníka",
        },
      },
      UserAffiliate: {
        MooneLiteWarning:
          "Pro vyplácení odměn z programu Díky\u00A0Tobě! je nutné dokončit registraci a počkat na ověření Vašeho účtu.",
        Title: "Díky Tobě!",
        Subtitle: "Platby, které Ti vydělávají.",
        Description:
          "Sdílej svůj kód, přiveď přátele a získej procenta z jejich plateb u obchodníků. Čím více lidí pozveš, tím vyšší budou tvé odměny. Vydělávej z plateb dlouhodobě jako banky a karetní společnosti.",
        HowItWorksTitle: "Jak to funguje:",
        HowItWorks:
          "• Ověř svůj účet v {{appName}}.<newline/>• Sdílej svůj affiliate kód s přáteli.<newline/>• Získávej odměny - pokaždé, když Tví doporučení zaplatí u obchodníků, získáváš podíl z jejich útraty.",
        Rewards:
          "💡 Odměny se připisují automaticky, Ty jen sleduješ, jak roste Tvůj pasivní příjem.",
        TermsLinkPretext: "📄 Více informací najdeš v Podmínkách programu",
        TermsLink: "„Díky Tobě!“",
        YourAffiliateLink: "Váš affiliate odkaz",
        TermsLinkUrl:
          "{{apiUrl}}/content/terms/individual/Moone-thanks-to-you.pdf",
        Tabs: {
          Customer: "Uživatelé",
          Campaigns: "Kampaně",
        },
      },
      HunterAffiliate: {
        Title: "Staň se legendou & vydělávej dlouhodobě! 🚀",
        Description:
          "Pozvi své známé do Legi.one a získej 10% provizi za každého nového huntera! Ale tím to nekončí – pokud budou úspěšní, získáš dlouhodobé provize z jejich jednoho obchodu a o druhý se s tebou podělí o 50 %. Tobě se zároveň navýší provize z části Tvých obchodů.",
        InviteNow:
          "Sdílej svůj affiliate kód teď a aktivně si buduj pasivní příjem!",
        YourAffiliateLink: "Váš affiliate odkaz",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        TermsLinkPretext: "Potřebuješ více informací? Podívej se na kompletní",
        TermsLink: "Podmínky affiliate programu",
        Tabs: {
          Hunter: "Hunter",
          Customer: "Uživatel",
          Merchant: "Obchodník",
          Campaigns: "Kampaně",
        },
        MerchantLicenseSelector: {
          Label: "Výchozí licence pro obchodníka",
        },
        InviteExistingUser: {
          Title: "Zveš stávajícího uživatele Mo.one?",
          Description:
            "Pokud chceš pozvat někoho, kdo už Mo.one účet má, použij registraci nového obchodníka. Když na konci zadáš jeho e-mail, formulář rozpozná stávající účet a pošle pozvánku rovnou do jeho schránky v aplikaci — místo aby ho znovu hnal celou registrací.",
          ButtonLabel: "Pozvat stávajícího uživatele jako obchodníka",
        },
      },
      MerchantAffiliate: {
        Title: "Pozvi obchodníka & získej odměny! 🚀",
        Description:
          "Pozvi své přátele do {{appName}} a získej odměny za každého nového uživatele! Sdílej výhody naší platformy a buduj svou síť při vydělávání.",
        InviteNow: "Sdílej svůj affiliate kód teď a začni vydělávat odměny!",
        YourAffiliateLink: "Váš affiliate odkaz",
        TermsLinkUrl:
          "https://legi.one/assets/cesta/Affiliate_Hunters_Rulers_11-2024.pdf",
        TermsLinkPretext: "Potřebuješ více informací? Podívej se na kompletní",
        TermsLink: "Podmínky affiliate programu obchodníků",
        Tabs: {
          Customer: "Uživatelé",
          Campaigns: "Kampaně",
        },
      },
      Earnings: {
        Title: "Vaše výdělky",
        TotalRegisteredUsers: "Registrovaní uživatelé",
        TierBreakdown: "T1: {{t1}}, T2: {{t2}}, T3: {{t3}}",
        CurrentPayout: "K výplatě",
        TotalEarned: "Celkem vyděláno",
        RegisteredUsersHint:
          "Celkový počet uživatelů, kteří se registrovali do {{appName}} přes váš affiliate odkaz.<newline/><newline/><bold>Rozložení dle úrovní:</bold><newline/>T1 (0,03%): {{t1}} uživatelů<newline/>T2 (0,02%): {{t2}} uživatelů<newline/>T3 (0,01%): {{t3}} uživatelů",
        PayoutHint:
          "Částka, která je aktuálně k dispozici pro výplatu z vašich affiliate odměn.",
        TotalEarnedHint:
          "Celková suma všech affiliate odměn, které jste získali z transakcí pozvaných uživatelů.",
        CombinedPayoutHint:
          "Součet odměn k výplatě ze Stardust programu a affiliate programu Díky Tobě.",
        CombinedTotalEarnedHint:
          "Součet všech odměn ze Stardust programu a affiliate programu Díky Tobě.",
        CombinedValorPayoutHint:
          "Součet odměn k výplatě z Valor programu a affiliate programu Díky Tobě.",
        CombinedValorTotalEarnedHint:
          "Součet všech odměn z Valor programu a affiliate programu Díky Tobě.",
      },
      Campaigns: {
        SelectCampaign: "Vyberte kampaň",
        SelectCampaignPlaceholder: "Vyberte kampaň z nabídky",
        SelectCampaignDescription:
          "Vyberte kampaň pro zobrazení detailů a affiliate odkazu.",
        Validity: "Platnost:",
      },
      AnonymousPayer: "Platba anonymního zákazníka",
    },
    Coinback: {
      Commission: "až {{commission}}",
    },
    Settlements: {
      SettlementStatus: {
        Paid: "Zaplacené",
        Unpaid: "Čeká na zaplacení",
        Overdue: "Po splatnosti",
      },
      TotalEarnings: "Celkem výdělek za transakce",
      CardEarnings: "Provize z karetních transakcí za období",
      TransactionCosts: "Náklady na transakce",
      SettlementCount: "Vyúčtování {{count}} z {{total}}",
      NoSettlementsFound: "Žádná vyúčtování nebyla nalezena.",
      LoadingError: "Při načítání vyúčtování se vyskytla chyba.",
      SettlementControls: {
        Filter: {
          Title: "Filtr",
          All: "Všechna ({{total}})",
          Paid: "Zaplacená ({{paid}})",
          Unpaid: "Nezaplacená ({{unpaid}})",
          Overdue: "Po splatnosti ({{overdue}})",
        },
        Sort: {
          Title: "Řadit podle",
          DateDesc: "Datum (nejnovější)",
          DateAsc: "Datum (nejstarší)",
          AmountDesc: "Částka (nejvyšší)",
          AmountAsc: "Částka (nejnižší)",
        },
      },
      SettlementList: {
        UpdateStatusSuccess: "Vyúčtování bylo označeno jako zaplacené",
        UpdateStatusError:
          "Při označení vyúčtování jako zaplacené se vyskytla chyba",
        DownloadReportError: "Při stahování vyúčtování se vyskytla chyba",
        DownloadReportFilePrefix: "vyuctovani_poplatku_",
        SettlementPeriod: "Období",
        SettlementDate: "Datum vyúčtování",
        DueDate: "Datum splatnosti",
        Amount: "Částka",
        Status: "Stav",
        Actions: "Akce",
        DownloadReport: "Stáhnout vyúčtování",
        MarkAsPaid: "Označit jako zaplacené",
        Pay: "Zaplatit",
        SettlementStatusTooltip:
          "Stav zaplacení vyúčtování kontrolujeme každé 2 hodiny mezi 8:00 a 22:00.",
        SettlementTypeHunterCommissionFunding: "Financování hunter provizí",
        SettlementTypeDefault: "Vyúčtování",
        DownloadInvoice: "Stáhnout fakturu",
        DownloadInvoiceError: "Při stahování faktury se vyskytla chyba",
        InvoiceFilePrefix: "faktura_",
        RegenerateInvoice: "Přegenerovat fakturu",
        RegenerateInvoiceSuccess: "Faktura byla přegenerována",
        RegenerateInvoiceError: "Při přegenerování faktury se vyskytla chyba",
      },
      SettlementDownloadButton: {
        Title: "Vyúčtování",
        Downloading: "Stahování...",
        Download: "Stáhnout",
        RegionPlaceholder: "Vyberte trh",
        Regions: {
          CZ: "Česko (CZK)",
          SK: "Slovensko (EUR)",
        },
      },
    },
    NoPrimaryAccountPopup: {
      Message:
        "Prosíme, zvolte si z Vašich připojených bankovních účtů primární účet, který bude sloužit jako výchozí účet pro Vaše transakce.",
      Accounts: "Spravovat připojené účty",
    },
  },
  Coinback: {
    NoEshopsFound: "Žádné eshopy nebyly nalezeny",
    Eshops: "Eshopy",
  },
  FormLabels: {
    AccountType: "Typ účtu pro převod",
    TransferAccountType: "Typ účtu pro převod",
    RecipientIBAN: "IBAN příjemce",
    Amount: "Částka",
  },
  AML: {
    BasicInfo: "Základní informace",
    CompanyName: "Název subjektu",
    FirstName: "Jméno",
    LastName: "Příjmení",
    CompanyNumber: "IČO",
    TaxNumber: "DIČ",
    PersonalNumber: "Rodné číslo",
    BirthDate: "Datum narození",
    BirthPlace: "Místo narození",
    Nationality: "Národnost",
    Gender: "Pohlaví",
    Phone: "Telefon",
    Email: "E-mail",
    Unknown: "Neznámé",
    Documents: "Doklady",
    DocumentNumber: "Číslo dokladu",
    DocumentIssuer: "Doklad vydal",
    DocumentValidity: "Platnost dokladu",
    DocumentType: "Typ dokladu",
    NoDocuments: "Pro tuto osobu neevidujeme žádné nahrané doklady.",
    IdentificationImageType: {
      FirstIDCardFrontSide: "Přední strana průkazu totožnosti",
      FirstIDCardBackSide: "Zadní strana průkazu totožnosti",
      SecondIDCardFrontSide: "Přední strana druhého průkazu totožnosti",
      SecondIDCardBackSide: "Zadní strana druhého průkazu totožnosti",
    },
    PdfUploaded: "Uživatel nahrál PDF soubor.",
    OpenPdf: "Otevřít PDF",
    ActingPerson: "Jednající osoba",
    BeneficialOwners: "Skuteční vlastníci",
    UboUnknownAlert: "Obchodník označil skutečné vlastníky jako neznámé",
    Loading: "Načítaní...",
  },
  PersonalInfo: {
    ConfirmDataRequest: "Jsou přečtené údaje výše správné?",
    FillMissingData: "Doplňte chybějící, nebo opravte nesprávné údaje",
    DataConfirmationMessage:
      "Prosíme potvrďte také správnost údajů o průkazu totožnosti.",
  },
  TableHeaders: {
    Verification: "Ověření",
    Login: "Login",
    Role: "Role",
    Status: "Status",
    FirstName: "Jméno",
    LastName: "Příjmení",
    Company: "Společnost",
    ClientIdentifier: "ID",
    DateCreated: "Datum vytvoření",
    PaymentReference: "Var. s. platby licence",
    Version: "Verze {{appName}}",
    Settlement: "Vyúčtování",
    Admin: "Admin",
  },
  Nfc: {
    NfcCard: "NFC karta",
    InvalidNfcCardNoFormat: "Formát identifikátoru není správný!",
    NfcCardNo: "Identifikátor NFC karty:",
    CopyNfcCardNo: "Kopírovat identifikátor karty",
    CopyNfcCardNoSuccess: "Identifikátor karty byl zkopírován",
    CardNotAssigned: "Tato NFC karta aktuálně není k ničemu přiřazena.",
    AssignToPaypoint: "Přiřadit k paypointu",
    SelectPaypoint: "Vyberte paypoint, kterému chcete kartu přiřadit",
    CardOverwriteConfirmation:
      "Paypoint {{name}} již má přiřazenou jinou NFC kartu. Chcete ji nahradit za tuto?",
    CardAssignedSuccessfully: "NFC karta byla úspěšně přiřazena",
    CardAssignmentFailed: "Chyba - NFC kartu se nepodařilo přiřadit",
    CardAssignmentFailedFormatError:
      "Chyba - Identifikátor NFC karty je ve špatném formátu",
    Redirecting: "Probíhá automatické přesměrování.",
    RedirectFallbackHint:
      "Pokud nebudete přesměrováni do 10 sekund, klikněte na tlačítko níže.",
    RedirectManually: "Přesměrovat ručně",
    RedirectNotConfigured:
      "Tento NFC štítek zatím nemá nastavenou adresu. Obraťte se prosím na obsluhu.",
    SelectMerchant: "Vyberte obchodníka, kterému chcete kartu přiřadit",
  },
  ExternalIntegrations: {
    Title: "Externí integrace",
    Description:
      "Přijímejte platby přes {{appName}} ve svém e-shopu. Stáhněte si plugin pro svou platformu a postupujte podle přiložené dokumentace.",
    DownloadPlugin: "Stáhnout ZIP",
    DownloadDocumentation: "Stáhnout dokumentaci (PDF)",
    WooCommerce: {
      Name: "WooCommerce",
      Description: "Platební plugin pro WordPress / WooCommerce.",
      PluginUrl: "/content/integrations/moone-payments-for-woocommerce.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-WooCommerce-CS.pdf",
    },
    PrestaShop: {
      Name: "PrestaShop",
      Description: "Platební modul pro PrestaShop.",
      PluginUrl: "/content/integrations/moonepayments-for-prestashop.zip",
      DocumentationUrl:
        "/content/integrations/Mo.one-Payments-PrestaShop-CS.pdf",
    },
    PaymentGateway: {
      Name: "Platební brána",
      Description:
        "Uživatelský návod k platební bráně: založení brány, přístupové údaje a vracení plateb.",
      DocumentationUrl: "/content/integrations/Mo.one-Payment-Gateway-CS.pdf",
    },
  },
  Paypoint: {
    Paypoint: "Paypoint",
    NoPaypoint: "Žádný paypoint",
    UnnamedPaypoint: "Nepojmenovaný paypoint",
    NoPaypointPlaceholder: "Žádný paypoint",
    AddPaypointButton: "Přidat nový paypoint",
    DownloadQRCode: "Stáhnout QR",
    Individual: "Individuální",
    SeeOptions: "Zobrazit možnosti",
    IndividualUnderConstruction: "Individuální paypointy připravujeme...",
    NewPaypoint: "Nový PayPoint",
    UpdatePaypoint: "Upravit PayPoint",
    IdlePaypointInfo: "Na tomto Paypointu není žádná aktivní transakce.",
    BackToDashboard: "Zpět na dashboard",
    LoadingError: "Chyba při načítání Paypointu",
    UnknownOwner: "Neznámý vlastník",
    Form: {
      Name: "Název",
      Description: "Popisek",
      Legend: {
        GeneralInfo: "Základní informace",
        NFC: "NFC Karta",
        PaypointSettings: "Nastavení Paypointu",
        Device: "Platební zařízení",
        PaypointType: "Nastavení paypointu",
      },
      PaymentTypeLabel: "Způsob platby",
      PaymentType: {
        Standard: {
          label: "Standardní platba",
          tooltip: "Platbu vytvoříte pokaždé vy na pokladně.",
        },
        FixedPrice: {
          label: "Platba s fixní částkou",
          tooltip:
            "Částka platby je předem nastavena a zákazník ji nemůže změnit.",
        },
        EditablePrice: {
          label: "Platba s volitelnou částkou",
          tooltip:
            "Zákazník si může zvolit z nabídky částek nebo zadat vlastní.",
        },
        NfcLink: {
          label: "NFC odkaz",
          tooltip:
            "Po přiložení telefonu k NFC štítku se otevře zadaná adresa místo platby.",
        },
        NfcTableService: {
          label: "NFC obsluha u stolu",
          tooltip:
            "Po přiložení telefonu se otevře stránka stolu. Adresu nastavuje Mo.one Hub, zde ji nelze upravit.",
        },
      },
      FixedAmountLabel: "Fixní částka",
      CurrencyLabel: "Měna",
      FixedAmountRequired: "Zadejte fixní částku větší než nula",
      CurrencyRequired: "Vyberte měnu platebního místa",
      TipsLabel: "Spropitné",
      TipsCheckbox: "Nabídnout zákazníkovi spropitné",
      GatewaySettingsHint:
        "U e-commerce brány řídí částku i spropitné e-shop u každé platby, proto zde tato nastavení nejsou dostupná.",
      RedirectUrlLabel: "Adresa (URL)",
      RedirectUrlInvalid: "Zadejte platnou adresu začínající https://",
      TableServiceUrlMissing:
        "Mo.one Hub zatím adresu stolu nenastavil. Dokud ji nenastaví, telefon po přiložení nikam nepřesměruje.",
      AssignNfcCardNoConflict:
        "Chyba - Tato NFC karta je již přiřazena k jinému paypointu",
      NfcCardNo: "Identifikátor NFC karty",
      NfcCardNoHelperText:
        "Identifikátor NFC karty je 14 místný alfanumerický kód, který je vytištěn na {{appName}} NFC kartě. Pokud kartu ještě nemáte u sebe můžete využívat paypoint virtuálně přes QR kód a připojit kartu později.",
      Create: "Vytvořit",
      NfcCardNoFormatError:
        "Identifikátor NFC karty musí být ve formátu XX-XX-XX-XX-XX-XX-XX",
      NameMaxLengthError: "Název nesmí překročit {{max}} znaků",
      BankAccountNotAccessible:
        "Nastavení bankovního účtu pro Vás není dostupné.",
      EmployeesNotAccessible:
        " Nastavení zaměstnanců s přístupem pro Vás není dostupné.",
      Employees: "Zaměstnanci s přístupem",
      PaypointAccount: "Bankovní účet",
      Facility: "Provozovna",
      Type: "Typ",
      TypeNFC: "NFC",
      TypeTerminal: "Terminál",
      TypeGateway: "Platební brána",
      TypeGatewayShort: "Brána",
      Device: {
        NoActiveDevice: "Zatím není připojené žádné zařízení",
        LinkDevice: "Připojit zařízení",
        LinkDeviceTitle: "Připojit nové zařízení",
        ActiveDevice: "Připojené zařízení",
      },
      Activation: {
        Legend: "Aktivace SoftPOS",
        Code: "Aktivační kód",
        HelperText:
          "Kód zadejte v aplikaci SoftPOS na zařízení. Platí pro jedno zařízení. Při přechodu na jiné zařízení deaktivujte aplikaci na starém, nebo požádejte podporu o uvolnění kódu.",
        Copy: "Kopírovat kód",
        Copied: "Zkopírováno",
      },
    },
  },
  MobileApp: {
    InstallBanner: {
      Title: "Stáhněte si aplikaci {{appName}}",
      Description: "Rychlejší přístup přímo z plochy vašeho telefonu.",
      AppStoreBadgeAlt: "Stáhnout v App Store",
      PlayStoreBadgeAlt: "Získat na Google Play",
    },
  },
  Language: {
    Czech: "Čeština",
    Settings: "Nastavení jazyka",
    Language: "Jazyk",
  },
  Roles: {
    AddRole: {
      Banner: {
        Hunter: "Máte pozvánku stát se hunterem — dokončete registraci role.",
        Merchant:
          "Máte pozvánku stát se obchodníkem — dokončete registraci role.",
        SignUpIntent: {
          Hunter:
            "Dokončete registraci huntera, kterou jste zvolili při založení účtu.",
          Merchant:
            "Dokončete registraci obchodníka, kterou jste zvolili při založení účtu.",
        },
        Button: "Dokončit",
      },
      Completion: {
        Submit: "Dokončit registraci role",
        Success: "Role je aktivní.",
        Error: "Roli se nepodařilo dokončit.",
      },
      PickerTitle: "Vyberte roli, kterou chcete ke svému účtu přidat.",
      MigrationRequired:
        "Přidání role je dostupné až po dokončení migrace účtu.",
      KycRequired:
        "Nejdřív prosím dokončete registraci svého zákaznického účtu (ověření totožnosti). Roli Hunter nebo Merchant lze přidat až poté.",
      BankVerificationRequired:
        "Nejdřív prosím připojte a ověřte svůj bankovní účet. Roli Hunter nebo Merchant lze přidat až poté.",
      BackOfficeAccount:
        "Interní účet (Admin, AML, onboarding) má vždy jen jednu roli — další roli k němu přidat nelze. Pro soukromé používání Mo.one si založte samostatný účet s jinou e-mailovou adresou.",
      HunterCard: {
        Title: "Hunter",
        Description: "Registrujte obchodníky a získávejte provize.",
        AlreadyHeld: "Roli huntera už máte.",
      },
      MerchantCard: {
        Title: "Obchodník",
        Description: "Přijímejte platby od zákazníků ve svém podniku.",
      },
      HunterForm: {
        Description:
          "Zadejte IČO živnosti nebo firmy, pod kterou budete jako hunter působit.",
      },
      MerchantForm: {
        Description:
          "Vyberte trh a zadejte IČO firmy, za kterou budete přijímat platby.",
      },
      BankStep: {
        Connected: "Banka je připojená — můžete pokračovat.",
      },
      Form: {
        CompanyNumber: "IČO",
        Region: "Trh",
        Submit: "Přidat roli",
        Success: "Role byla přidána, přepínáme kontext…",
        Error: "Roli se nepodařilo přidat.",
      },
    },
  },
  Social: {
    Handle: {
      Label: "Přezdívka",
      Placeholder: "např. jan.novak",
      ValidationError:
        "Přezdívka musí mít 3–30 znaků: malá písmena a–z, číslice, tečku nebo podtržítko, a alespoň jedno písmeno.",
      Reserved: "Tuto přezdívku nelze použít",
      Available: "Přezdívka je volná",
      Taken: "Tuto přezdívku už někdo používá",
      SaveError: "Přezdívku se nepodařilo uložit. Zkuste to prosím znovu.",
      StepTitle: "Zvolte si veřejnou přezdívku",
      StepDescription:
        "Přezdívka (@handle) je vaše veřejné jméno v {{appName}}. Ostatní vás podle ní najdou.",
      StepBenefitSearch:
        "Přátelé vás snadno najdou ve vyhledávání podle <strong>{{handle}}</strong> a Váš profil bude dostupný na adrese <strong>app.mo.one/@{{bareHandle}}</strong>",
      StepBenefitSearchHandleFallback: "@přezdívky",
      StepBenefitSearchUrlFallback: "přezdívka",
      StepBenefitFollows:
        "Ostatní vás můžou sledovat a posílat vám žádosti o sledování",
      StepBenefitChat: "Můžete si psát zprávy s přáteli i obchodníky",
      StepBenefitLeaderboard:
        "V žebříčcích Stardust a Valor se zobrazí místo vašeho jména",
      StepMissingWarning:
        "Bez přezdívky vás ostatní nenajdou a komunitní funkce pro vás budou nedostupné. Doplnit si ji můžete i kdykoli v profilu.",
      ContinueWithoutHandle: "Doplním později",
      ChangeNote:
        "Změnou přezdívky se původní uvolní a změní se i adresa vašeho veřejného profilu.",
      MissingBannerText:
        "Nemáte nastavenou přezdívku (@handle) — ostatní vás zatím nemohou najít.",
      MissingBannerAction: "Nastavit",
    },
    Terms: {
      CheckboxLabel:
        "Přijímám <terms>obchodní podmínky</terms>, <chatTerms>podmínky Chatu</chatTerms> a <communityRules>pravidla komunity</communityRules>",
      Note: "Chat je zdarma a poskytuje ho Mo.one Digital Services s.r.o. Vypovědět ho můžete kdykoli v Aplikaci, jako spotřebitel také do 14 dnů odstoupit e-mailem. Jak pracujeme s vašimi údaji, popisují <privacy>Zásady ochrany osobních údajů</privacy>. <summary>Shrnutí smlouvy</summary> a dokumenty si stáhněte a uložte, budou se vám hodit i později.",
      ShowSummary: "Shrnutí a dokumenty",
      HideSummary: "Skrýt shrnutí",
      AcceptAndContinue: "Přijmout a pokračovat",
      Required:
        "Musíte přijmout obchodní podmínky, podmínky Chatu a pravidla komunity",
      Documents: {
        ContractSummary: {
          Title: "Shrnutí smlouvy",
          Url: {
            Customer: "/content/terms/Moone-chat-contract-summary-customer.pdf",
            Merchant: "/content/terms/Moone-chat-contract-summary-business.pdf",
            Hunter: "/content/terms/Moone-chat-contract-summary-business.pdf",
          },
        },
        Terms: {
          Title: "Všeobecné obchodní podmínky",
          Url: {
            Customer: "/content/terms/Moone-chat-business-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-business-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-business-terms-business.pdf",
          },
        },
        ChatTerms: {
          Title: "Produktové podmínky Chatu",
          Url: {
            Customer: "/content/terms/Moone-chat-terms-customer.pdf",
            Merchant: "/content/terms/Moone-chat-terms-business.pdf",
            Hunter: "/content/terms/Moone-chat-terms-business.pdf",
          },
        },
        CommunityRules: {
          Title: "Pravidla komunity",
          Url: {
            Customer: "/content/terms/Moone-chat-community-rules.pdf",
            Merchant: "/content/terms/Moone-chat-community-rules.pdf",
            Hunter: "/content/terms/Moone-chat-community-rules.pdf",
          },
        },
        ComplaintRules: {
          Title: "Reklamační řád",
          Url: {
            Customer: "/content/terms/Moone-chat-complaint-rules-customer.pdf",
            Merchant: "/content/terms/Moone-chat-complaint-rules-business.pdf",
            Hunter: "/content/terms/Moone-chat-complaint-rules-business.pdf",
          },
        },
        TechnicalTerms: {
          Title: "Technické podmínky",
          Url: {
            Customer: "/content/terms/Moone-chat-technical-terms.pdf",
            Merchant: "/content/terms/Moone-chat-technical-terms.pdf",
            Hunter: "/content/terms/Moone-chat-technical-terms.pdf",
          },
        },
        PrivacyPolicy: {
          Title: "Zásady ochrany osobních údajů",
          Url: {
            Customer: "/content/terms/Moone-chat-privacy-policy.pdf",
            Merchant: "/content/terms/Moone-chat-privacy-policy.pdf",
            Hunter: "/content/terms/Moone-chat-privacy-policy.pdf",
          },
        },
        ListLabel: "Dokumenty",
      },
      Terminate: {
        Title: "Ukončit Chat a komunitní funkce",
        Description:
          "Ukončením smlouvy o Chatu přijdete o přezdívku a všechny komunitní funkce — chat, veřejný profil, vyhledávání a sledování. Vaše zprávy a sledování zůstanou zachovány a znovu se zobrazí, pokud si později zvolíte novou přezdívku.",
        Action: "Ukončit Chat a komunitní funkce",
        ConfirmTitle: "Opravdu chcete ukončit Chat a komunitní funkce?",
        ConfirmText:
          "Vaše přezdívka bude uvolněna a chat, veřejný profil, vyhledávání i sledování pro vás budou nedostupné. Výpověď je účinná okamžitě. Chat můžete kdykoli znovu aktivovat zvolením nové přezdívky a přijetím podmínek.",
        Success: "Chat a komunitní funkce byly ukončeny.",
      },
      Summary: {
        Service: {
          Label: "Služba",
          Value: "Posílání zpráv, skupiny a sdílení v aplikaci {{appName}}",
        },
        Provider: {
          Label: "Poskytovatel",
          Value:
            "Mo.one Digital Services s.r.o., IČO 245 32 819, Palackého třída 3048/124, 612 00 Brno, info@mo.one, +420 226 633 296",
        },
        Price: { Label: "Cena", Value: "Zdarma" },
        Duration: { Label: "Trvání", Value: "Na dobu neurčitou" },
        Termination: {
          Label: "Výpověď",
          Value:
            "Kdykoli a bez udání důvodu v Aplikaci: Můj {{appName}} › Nastavení › Ukončit Chat a komunitní funkce. Účinná je, jakmile ji potvrdíte.",
        },
        Withdrawal: {
          Label: "Odstoupení",
          Value:
            "Jako spotřebitel do 14 dnů bez udání důvodu, stačí e-mail na info@mo.one",
        },
        Payments: {
          Label: "Platby",
          Value: "Poskytuje je Mo.one a.s. podle vaší smlouvy s ní",
        },
        Complaints: {
          Label: "Reklamace",
          Value:
            "Podle reklamačního řádu, mimosoudně u České obchodní inspekce",
        },
        Devices: {
          Label: "Zařízení",
          Value: "iOS 15 a novější, Android 7 a novější",
        },
        Important: {
          Label: "Důležité",
          Value:
            "Chat neslouží k tísňovým voláním. Smlouvu uzavíráte v češtině, přezdívku můžete před potvrzením opravit.",
        },
      },
    },
    PublicProfile: {
      PrivateAccount: "Soukromý účet",
      NotFound: "Tato přezdívka neexistuje.",
      Follow: "Sledovat",
      Following: "Sledujete",
      FollowBack: "Sledovat zpět",
      Requested: "Žádost odeslána",
      Mutual: "Vzájemně",
      ApproveRequest: "Schválit žádost",
      DeleteRequest: "Smazat žádost",
      MutualConfirmTitle: "Sledovat se navzájem s @{{handle}}?",
      MutualConfirmInbox:
        "Vaše zprávy si budete posílat rovnou do schránky, případná žádost o zprávu mezi vámi se přijme a budete se moci navzájem přidávat do skupin.",
      MutualConfirmName: "@{{handle}} také uvidí vaše skutečné jméno.",
      SendMessage: "Poslat zprávu",
      SendMessageError:
        "Konverzaci se nepodařilo otevřít. Zkuste to prosím znovu.",
      SendMessagePhoneRequired:
        "Pro odesílání zpráv si ověřte své telefonní číslo.",
      MoreActions: "Další akce",
      Block: "Zablokovat",
      BlockConfirmTitle: "Zablokovat uživatele",
      BlockConfirmDescription:
        "Zablokováním zrušíte vzájemné sledování i žádosti o sledování a nebudete se moci znovu najít ani spojit. Blokaci můžete kdykoli zrušit na stránce Lidé.",
      Report: "Nahlásit",
    },
    People: {
      SearchPlaceholder: "Hledat",
      SearchAllUsersPlaceholder:
        "Hledat mezi všemi uživateli podle @přezdívky nebo jména",
      SearchNoResults: "Nikdo nenalezen.",
      RequestsTitle: "Žádosti o sledování",
      OutgoingTitle: "Odeslané žádosti",
      Approve: "Schválit",
      Delete: "Smazat",
      CancelRequest: "Zrušit",
      MutualTitle: "Vzájemní sledující",
      NoMutuals:
        "Zatím nemáte žádné vzájemné sledující — objeví se tu lidé, které sledujete a kteří sledují i vás.",
      FollowingTitle: "Sledovaní",
      NoFollowing: "Zatím nikoho nesledujete.",
      FollowersTitle: "Sledující",
      Tabs: {
        Mutual: "Vzájemní",
        Following: "Sledovaní",
        Followers: "Sledující",
      },
      NoFollowers: "Zatím vás nikdo nesleduje.",
      Unfollow: "Odebrat",
      BlockedTitle: "Blokovaní uživatelé",
      NoBlocked: "Nikoho jste nezablokovali.",
      Unblock: "Odblokovat",
      HandleGateTitle: "Nejdřív si nastavte přezdívku",
      HandleGateText:
        "Abyste mohli sledovat ostatní, potřebujete přezdívku (@handle) — ostatní vás podle ní najdou.",
      HandleGateAction: "Nastavit přezdívku",
    },
    PublicPermissions: {
      IdentityLabel: "Identita",
      IdentityVerifiedTooltip: "Identita ověřena",
      IdentityVerificationPendingTooltip: "Ověření identity probíhá",
      PublicProfileLabel: "Veřejný profil",
      PhoneVerifiedTooltip: "Telefonní číslo ověřeno",
      PhoneVerificationPendingTooltip: "Ověření telefonního čísla probíhá",
      PhoneUnverifiedTooltip: "Telefonní číslo není ověřeno",
      VerifyAction: "Ověřit",
      BioLabel: "Bio",
      BioTooLong: "Bio může mít nejvýše 160 znaků",
      BioSaveError: "Bio se nepodařilo uložit. Zkuste to prosím znovu.",
      SectionDescription:
        "S veřejným profilem ostatní uvidí vaše skutečné jméno a budou vás podle něj moct najít.",
      GoPublicConfirmTitle: "Zveřejnit profil?",
      GoPublicConfirmRequests:
        "Všechny čekající žádosti o sledování ({{count}}) budou schváleny.",
      GoPublicConfirmMutual:
        "{{count}} z nich už sledujete, takže se budete sledovat navzájem: jejich zprávy vám budou chodit rovnou do schránky a budou vás moci přímo přidávat do skupin.",
      GoPublicConfirmAction: "Zveřejnit",
      GoPublicSummaryUnavailable:
        "Čekající žádosti o sledování se nepodařilo načíst, profil zatím nelze zveřejnit.",
    },
    Stats: {
      Mutual: "Vzájemní",
      Followers: "Sledující",
      Following: "Sledování",
    },
  },
  Pages: {
    Titles: {
      AddRole: "Přidat roli",
      Stardust: "Stardust",
      People: "Lidé",
      Followers: "Sledující",
      BlockedUsers: "Blokovaní uživatelé",
      Profile: "Profil",
      Valor: "Valor",
      Notifications: "Notifikace",
      Invitations: "Pozvánky",
      ThanksToYou: "Díky Tobě!",
      IncomingTransaction: "Příchozí platba",
      OutgoingTransaction: "Odchozí platba",
      UnknownTransaction: "Platba",
      Licenses: "Licence",
      NewPayment: "Pokladna",
      MerchantOverview: "Obchodník",
      Employees: "Zaměstnanci",
      LanguageSettings: "Nastavení jazyka",
      PayPoints: "Platební zařízení",
      BankAccountDetail: "Bankovní účet",
      SetPassword: "Nastavení hesla",
      AmlUsers: "Uživatelé",
      NotificationsManagement: "Správa notifikací",
      NewNotification: "Nová notifikace",
      EditNotification: "Upravit notifikaci",
      Settings: "Více",
      Dashboard: "Přehled",
      BankAccounts: "Bankovní účty",
      BankAccountOrder: "Pořadí účtů",
      FeeCalculator: "Kalkulačka poplatků",
      Merchants: "Obchodníci",
      Settlement: "Vyúčtování",
      Users: "Uživatelé",
      ToBeVerified: "K ověření",
      TransactionDetail: "Transakce",
      TransactionsHistory: "Transakce",
      Welcome: "Vítejte",
      User: "Uživatel",
      Withdrawal: "Výběr",
      Settlements: "Vyúčtování",
      MerchantOpenRegistrations: "Otevřené registrace",
      LicenseOrder: "Objednávka licence",
      Onboarding: "Informace o Vás",
      CompleteSSORegistration: "Dokončení registrace",
      CompleteCustomerOnboarding: "Dokončení registrace",
      LeadInvitation: "Pozvat přítele",
      MerchantInitiatePayment: "Výběr účtu",
      MerchantAcceptPayment: "Přijmout platbu",
      MerchantCompleteRegistration: "Registrace",
      MerchantNewRegistration: "Nový obchodník",
      LegalDocuments: "Dokumenty",
      Redeem: "Dárková karta",
      AnonymousDashboard: "Přehled",
      BankingAuthQr: "Ověření bankovního účtu",
      SystemReport: "Systémový report",
      SystemControl: "Nastavení systému",
      BankingAuth: "Ověření bankovního účtu",
      UserAccount: "Můj {{appName}}",
      Help: "Nápověda",
      ColdWallet: "Systémová peněženka",
      MerchantSettlements: "Vyúčtování",
      AnonymousTransactionDetail: "Transakce byla úspěšná",
      MerchantFeeCalculator: "Kalkulačka poplatků",
      RedeemPublic: "Dárková karta",
      ApplicationError: "Chyba aplikace",
      GoogleCallback: "Přesměrování",
      Campaigns: "Kampaně",
      Coupons: "Kupóny",
      Terminals: "Terminály",
      Raffle: "Slosování",
      SsoClients: "SSO aplikace",
      SsoAuthorize: "Přihlášení do aplikace",
      ConnectedApps: "Připojené aplikace",
      AdminCampaignCreate: "Vytvořit kampaň",
      AdminCampaignEdit: "Upravit kampaň",
      Chat: "Chat",
      Devices: "Platební zařízení",
      PaymentGateways: "Platební brány",
      AwaitingEmailVerification: "Ověření e-mailu",
      BankIDRedirect: "Přesměrování",
      Error403: "Přístup odepřen",
      DeactivateUser: "Smazat účet",
      CustomerAnonymousPaymentPay: "Přihlášení",
      Contact: "Kontakt",
      WhereToPay: "Kde platit",
      RolesPermissions: "Role a oprávnění",
      AllMerchants: "Všichni obchodníci",
      UnassignedMerchants: "Obchodníci bez huntera",
      Hunters: "Hunteři",
      HunterPortal: "Hunter Portál",
      Transfer: "Převést peníze",
      BatchPayments: "Hromadné platby",
      BatchPaymentDetail: "Detail hromadné platby",
    },
    Content: {
      WhereToPay: {
        Tabs: {
          Stores: "Obchody",
          EShops: "E-shopy",
          Campaigns: "Kampaně",
        },
        StoresSection: {
          CategoryLabel: "Kategorie",
          CategoryPlaceholder: "Kategorie",
          CategoryAccessibility: "Filtrovat podle kategorie",
          MunicipalityLabel: "Obec",
          MunicipalityPlaceholder: "Obec",
          MunicipalityAccessibility: "Filtrovat podle obce",
          NoStoresFound:
            "Nenalezeny žádné obchody odpovídající vybraným filtrům.",
        },
        Campaigns: {
          Title: "KAMPANĚ MO.ONE",
          Description:
            "Vyzkoušejte si platbu s Mo.one a pomůžete dobré věci. Vyberte si jednu z partnerských nadací a darujte skrze Mo.one libovolnou částku na potřebné.",
          ShareLinkText: "Sdílej odkaz s ostatními a pomáhej",
          CopyLink: "Kopírovat odkaz",
          LinkCopied: "Odkaz zkopírován",
        },
        StoreDetail: {
          NotFound: "Obchod nenalezen",
          AboutUs: {
            Title: "O NÁS",
            Address: "Adresa",
            Phone: "Telefon",
            Email: "E-mail",
          },
          OpeningHours: {
            Title: "OTEVÍRACÍ DOBA",
          },
        },
      },
      Stardust: {
        PointsLabel: {
          Points: "{{count}} Stardust",
          Points_one: "{{count}} Stardust",
          Points_few: "{{count}} Stardusty",
          Points_other: "{{count}} Stardustů",
        },
        Participation: {
          Title: "Účast v programu Stardust",
          OptedInStatus: "Jste přihlášen do programu Stardust a sbíráte body.",
          OptOutButton: "Odhlásit se z programu",
          OptOutDialogTitle: "Odhlásit se ze Stardust?",
          OptOutDialogText:
            "Po odhlášení vám nebudou přičítány nové body Stardust, ani za platby, ani za doporučení přátel. Body a odměny, které jste už získali, vám zůstávají. Znovu se můžete přihlásit kdykoliv.",
          OptOutDialogConfirm: "Odhlásit se",
          OptedOutToast:
            "Odhlásili jste se z programu Stardust. Body a odměny, které jste získali, vám zůstávají.",
        },
        Consent: {
          Title: "Věrnostní program Stardust",
          Description:
            "Za platby a aktivitu v aplikaci sbíráte body Stardust a na konci měsíce získáte podíl z balíku odměn. Účast je dobrovolná a kdykoliv ji můžete změnit v sekci Stardust.",
          TermsLink: "Podmínky programu Stardust",
          Confirm: "Souhlasím se zařazením do programu",
        },
        PilotDisclaimer:
          "Věrnostní program Stardust je od 1.12.2025 v pilotním režimu. Budeme rádi pokud si Stardust vyzkoušíte a dáte nám zpětnou vazbu pomocí tlačítka Nahlásit chybu nebo na email info@mo.one.",
        Overview: {
          Points: {
            title: "Stardust",
            explanationHint:
              "Stardust je odměnová jednotka v {{appName}} za ktero utržíte na konci každého měsíce podíl z balíku odměn. Balík odměn je tvořen setinkami procenta ze všech provedených plateb.<newline/><newline/> Naším cílem je díky Stardust vrátit část peněz zpět komunitě a dát tak možnost vydělávat díky placení přes {{appName}} podobně jak vydělávají banky a karetní instituce. <newline/><newline/><bold>Na konci každého měsíce je všechen Stardust použit na zisk podílu z balíku odměn. Na začátku nového měsíce všichni uživatelé začínají s 0 Stardust.</bold>",
          },
          Payout: {
            title: "K výplatě",
            explanationHint:
              'Na konci každého měsíce se uzavírá období věrnostního programu Stardust a získané peníze se vám připíšou do "K výplatě".<newline/><newline/> Po dosažení 50 Kč k výplatě si můžete nechat peníze poslat na svůj účet.',
          },
          Rewards: {
            title: "Odměny",
            explanationHint:
              "Celkový počet odměn z {{appName}} plateb pro věrnostní program Stardust v aktuálním měsíci.",
          },
          MyShare: {
            title: "Můj podíl",
            explanationHint:
              "Tvůj aktuální měsíční podíl na odměnách pro Stardust, jedná se o odhadovaný podíl dle celkového počtu Stardust a Odměn.<newline/><newline/> Reálný podíl na konci měsíce se může od průběžného lišit.",
          },
          Rules: {
            Title: "Věrnostní program - obecná pravidla",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          CurrentTerms: {
            Title: "Aktuálně platné podmínky Stardust",
            Link: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
        Leaderboard: {
          Title: "Stardust žebříček",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Stardust",
          },
        },
      },
      Valor: {
        PointsLabel: {
          Points: "{{count}} Valor",
          Points_one: "{{count}} Valor",
          Points_few: "{{count}} Valory",
          Points_other: "{{count}} Valorů",
        },
        Overview: {
          Points: {
            title: "Valor",
            explanationHint:
              "Valor je odměnová jednotka pro Huntery v {{appName}}. Získáváte jej plněním výzev – přivádění nových uživatelů, obchodníků a hunterů.<newline/><newline/><bold>Na konci každého měsíce je všechen Valor použit na zisk podílu z balíku odměn. Na začátku nového měsíce všichni Hunteři začínají s 0 Valor.</bold>",
          },
          Payout: {
            title: "K výplatě",
            explanationHint:
              'Na konci každého měsíce se uzavírá období věrnostního programu Valor a získané peníze se vám připíšou do "K výplatě".<newline/><newline/> Po dosažení 50 Kč k výplatě si můžete nechat peníze poslat na svůj účet.',
          },
          Rewards: {
            title: "Odměny",
            explanationHint:
              "Celkový počet odměn z {{appName}} pro věrnostní program Valor v aktuálním měsíci.",
          },
          MyShare: {
            title: "Můj podíl",
            explanationHint:
              "Tvůj aktuální měsíční podíl na odměnách pro Valor, jedná se o odhadovaný podíl dle celkového počtu Valor a Odměn.<newline/><newline/> Reálný podíl na konci měsíce se může od průběžného lišit.",
          },
          Rules: {
            Title: "Valor - obecná pravidla",
            Link: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
          },
          CurrentChallenges: {
            Title: "Valor - aktuálně platné výzvy",
            Link: "{{apiUrl}}/content/terms/legione-valor-monthly-july-2026.pdf",
          },
        },
        TeslaBanner: {
          Title: "Soutěž o Teslu!",
          Description:
            "Nejúspěšnější Hunter měsíce (s nejvíce Valory) může získat Teslu na celý měsíc!",
        },
        Leaderboard: {
          Title: "Valor žebříček",
        },
        Rewards: {
          Columns: {
            PointsLabel: "Valor",
          },
        },
      },
      SetPassword: {
        CreateNewPassword: "Vytvoření hesla",
        ResetPassword: "Reset hesla",
        Password: "Heslo",
        PasswordConfirmation: "Heslo znovu",
        SetPassword: "Nastavit heslo",
      },
      AmlUsers: {
        ExportUnderConstruction: "Funkci export stále připravujeme...",
        ExportButton: "Exportovat",
        Error:
          "Během načítání se objevil neočekávaný problém. Zkuste akci prosím opakovat později.",
        TableHeaders: {
          Verification: "Ověření",
          ClientIdentifier: "ID",
          Role: "Druh uživatele",
          FirstName: "Jméno",
          LastName: "Příjmení",
          Company: "Společnost",
          PersonalNumber: "Rodné číslo",
          PartyType: "Typ osoby",
          RiskProfile: "Rizikový profil",
          DateCreated: "Datum vytvoření",
        },
        Detail: {
          ConnectedBankAccounts: "Připojené bankovní účty",
          RiskProfileSettings: "Nastavení rizikového profilu",
          LoadingError: "Chyba, uživatele se nepodařilo načíst",
          RiskProfileUpdateError: "Chyba při aktualizaci rizikového profilu",
          RiskProfileUpdateSuccess: "Rizikový profil úspěšně aktualizován",
          ClientIdentifier: "ID klienta",
          CopyClientIdentifier: "Kopírovat ID klienta",
          CopyClientIdentifierSuccess: "ID klienta zkopírováno",
        },
      },
      LicenseDetail: {
        AwaitingPayment: "Čeká na zaplacení",
        CancelOrderConfirmation: "Opravdu chcete vybranou objednávku zrušit?",
        LoadingError:
          "Při načítání dat licence se vyskytla chyba, zkuste to prosím později.",
        Type: "Typ licence",
        LicenseNo: "Číslo licence",
        PaymentStatus: "Stav platby",
        WalletAddress: "Adresa peněženky",
        Country: "Země",
        PaymentPendingInfo:
          "Licence bude aktivována po připsání platby. Pokud máte již zaplaceno, vyčkejte na připsání peněz.",
        CancelOrder: "Zrušit objednávku",
        OrderLicense: "Objednat licenci",
        LicenseStatus: {
          Initiated: "Platba vytvořena",
          Processing: "Probíhá zpracování",
          Success: "Zaplaceno",
          Fail: "Neúspěšná",
          Cancelled: "Zrušeno",
        },
      },

      LegalDocuments: {
        previousVersions: "Předchozí verze",
        Documents: {
          Hunter: {
            digitalFranchiseContract: {
              title: "Smlouva o digitální franšíze",
              url: "{{apiUrl}}/content/terms/legione-hunters-franchise-contract.pdf",
            },
            affiliateTerms: {
              title: "Podmínky affiliate",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms.pdf",
            },
            commissionTable: {
              title: "Provizní tabulka",
              url: "{{apiUrl}}/content/terms/legione-provisions.pdf",
            },
            valorVigorPointRules: {
              title: "Pravidla pro bodové ohodnocení VALOR a VIGOR",
              url: "{{apiUrl}}/content/terms/legione-valor-vigor.pdf",
            },
            valorGeneralRules: {
              title: "Valor - obecná pravidla",
              url: "{{apiUrl}}/content/terms/legione-valor-general-rules.pdf",
            },
            nftCollectionRules: {
              title: "Pravidla pro kolekci NFT Legi.one",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection.pdf",
            },
            generalFranchiseTerms: {
              title: "Všeobecná franšízová pravidla",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms.pdf",
            },
            dataProtectionPrinciples: {
              title: "Zásady ochrany osobních údajů",
              url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
            },
            satisfactionGuarantee: {
              title: "Garance spokojenosti",
              url: "{{apiUrl}}/content/terms/satisfaction-guarantee.pdf",
            },
            previousAffiliateTerms: {
              title: "Podmínky affiliate platné do 28. 9. 2025",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-28-9-2025.pdf",
            },
            previousDataProtectionPrinciples: {
              title: "Zásady ochrany osobních údajů platné do 06. 11. 2025",
              url: "{{apiUrl}}/content/terms/legione-gdpr.pdf",
            },
            previousDataProtectionPrinciples2: {
              title: "Zásady ochrany osobních údajů platné do 01. 07. 2026",
              url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
            },
            previousAffiliateTerms2: {
              title: "Podmínky affiliate účinné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-affiliate-terms-08-02-2026.pdf",
            },
            previousGeneralFranchiseTerms: {
              title: "Všeobecná franšízová pravidla účinné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-general-franchise-terms-08-02-2026.pdf",
            },
            previousNftCollectionRules: {
              title: "Pravidla pro kolekci NFT Legi.one účinné do 08. 02. 2026",
              url: "{{apiUrl}}/content/terms/legione-NFT-collection-08-02-2026.pdf",
            },
            previousCommissionTable: {
              title: "Tabulka provizí - předchozí verze",
              url: "{{apiUrl}}/content/terms/legione-provisions-30-04-2026.pdf",
            },
          },
          mooneLiteTerms: {
            title: "Obchodní podmínky {{appName}} Lite",
            url: "{{apiUrl}}/content/terms/Moone-moone-lite.pdf",
          },
          paymentServicesContract: {
            title: "Smlouva o poskytování platebních služeb",
            url: "{{apiUrl}}/content/terms/individual/Moone-payment-services-contract.pdf",
          },
          generalBusinessTerms: {
            title: "Všeobecné obchodní podmínky",
            url: "{{apiUrl}}/content/terms/individual/Moone-general-business-terms.pdf",
          },
          merchantTerms: {
            title: "Podmínky pro Obchodníky",
            url: "{{apiUrl}}/content/terms/individual/Moone-merchant-terms.pdf",
          },
          aisPisProductTerms: {
            title: "Produktové podmínky AIS-PIS",
            url: "{{apiUrl}}/content/terms/individual/Moone-ais-pis.pdf",
          },
          settlementManual: {
            title: "Manuál pro zúčtování přímých plateb",
            url: "{{apiUrl}}/content/terms/individual/Moone-pis-settlement.pdf",
          },
          priceList: {
            Partner: {
              title: "Ceník poplatků - Partner",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-partner-251201.pdf",
            },
            Prime: {
              title: "Ceník poplatků - Prime",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-prime-251201.pdf",
            },
            Standard: {
              title: "Ceník poplatků",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-standard-251201.pdf",
            },
            Individual: {
              title: "Ceník poplatků - Speciální 0,49%",
              url: "{{apiUrl}}/content/pricelists/Moone-pricelist-discounted-individual.pdf",
            },
          },
          complaintRules: {
            title: "Reklamační řád",
            url: "{{apiUrl}}/content/terms/individual/Moone-complaint-rules.pdf",
          },
          dataProtectionMemorandum: {
            title: "Zásady ochrany osobních údajů",
            url: "{{apiUrl}}/content/terms/individual/Moone-memorandum.pdf",
          },
          previousDataProtectionMemorandum: {
            title:
              "Informační memorandum (ochrana osobních údajů) platné do 06. 11. 2025",
            url: "{{apiUrl}}/content/terms/archive/ZNPay-memorandum-06-11-2025.pdf",
          },
          previousDataProtectionMemorandum2: {
            title:
              "Informační memorandum (ochrana osobních údajů) platné do 01. 07. 2026",
            url: "{{apiUrl}}/content/terms/archive/Moone-memorandum-01-07-2026.pdf",
          },
          precontractInformation: {
            title: "Předsmluvní informace",
            url: "{{apiUrl}}/content/terms/individual/Moone-single-precontract-terms.pdf",
          },
          thanksToYou: {
            title: 'Oznámení doporučovacího programu "Díky Tobě!"',
            url: "{{apiUrl}}/content/terms/individual/Moone-thanks-to-you.pdf",
          },
          previousGeneralBusinessTerms: {
            title: "Všeobecné obchodní podmínky platné do 28. 10. 2025",
            url: "{{apiUrl}}/content/terms/individual/ZNPay-general-business-terms-28-10-2025.pdf",
          },
          stardust: {
            title: "Oznámení věrnostního programu Stardust",
            url: "{{apiUrl}}/content/terms/Moone-stardust-general.pdf",
          },
          stardustCurrentTerms: {
            title: "Pravidla - aktuálně platné výzvy (červenec 2026)",
            url: "{{apiUrl}}/content/terms/Moone-stardust-monthly-july-2026.pdf",
          },
        },
      },
      Loyalty: {
        Tabs: {
          Challenges: "Výzvy",
          Leaderboard: "Žebříček",
          Rewards: "Odměny",
        },
        Challenges: {
          FeaturedChallenges: {
            Title: "Vybrané výzvy",
            AllChallenges: "Všechny výzvy",
          },
          WeeklyChallenges: {
            Title: "Týdenní výzvy",
            TimeRemaining: "Restart: {{days}} dní a {{hours}} hodin",
          },
          MonthlyChallenges: {
            Title: "Měsíční výzvy",
            TimeRemaining: "Restart: {{days}} dní a {{hours}} hodin",
          },
          DailyChallenges: {
            Title: "Denní výzvy",
          },
          LongTermChallenges: {
            Title: "Dlouhodobé výzvy",
          },
          UnlimitedChallenges: {
            Title: "Neomezené výzvy",
          },
          AllChallenges: {
            Title: "Všechny výzvy",
          },
        },
        Rewards: {
          Title: "Díky Tobě!",
          Columns: {
            Date: "Datum",
            Activity: "Aktivita",
          },
        },
        Notification: {
          Completed: "Výzva splněna!",
        },
        Events: {
          [LoyaltyEventCode.Anniversary]: {
            title: "Výročí",
            description: "Oslav své výročí s {{appName}}",
          },
          [LoyaltyEventCode.HunterDailyAppOpen]: {
            title: "Denní otevření aplikace",
            description: "Uživatel spustí {{appName}} alespoň jednou za den",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak3]: {
            title: "Streak otevření aplikace 3 dny",
            description: "Přihlášení do aplikace 3 dny v řadě",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak5]: {
            title: "Streak otevření aplikace 5 dnů",
            description: "Přihlášení do aplikace 5 dnů v řadě",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak10]: {
            title: "Streak otevření aplikace 10 dnů",
            description: "Přihlášení do aplikace 10 dnů v řadě",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak30]: {
            title: "Streak otevření aplikace 30 dnů",
            description: "Přihlášení do aplikace 30 dnů v řadě",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak180]: {
            title: "Streak otevření aplikace 180 dnů",
            description: "Přihlášení do aplikace 180 dnů v řadě",
          },
          [LoyaltyEventCode.HunterDailyAppOpenStreak365]: {
            title: "Streak otevření aplikace 365 dnů",
            description: "Přihlášení do aplikace 365 dnů v řadě",
          },
          [LoyaltyEventCode.HunterReferUser]: {
            title: "Díky Tobě!",
            description: "Pozvání a registrace nového uživatele",
          },
          [LoyaltyEventCode.HunterRefer10]: {
            title: "Díky Tobě 10!",
            description: "Pozvání a registrace 10 uživatelů",
          },
          [LoyaltyEventCode.HunterRefer50]: {
            title: "Díky Tobě 50!",
            description: "Pozvání a registrace 50 uživatelů",
          },
          [LoyaltyEventCode.HunterRefer100]: {
            title: "Díky Tobě 100!",
            description: "Pozvání a registrace 100 uživatelů",
          },
          [LoyaltyEventCode.HunterMerchantOnboarded]: {
            title: "Nový přírůstek!",
            description: "Onboardování nového obchodníka",
          },
          [LoyaltyEventCode.HunterMerchant1]: {
            title: "Začínající Lovec",
            description: "Zaregistrování prvního obchodníka",
          },
          [LoyaltyEventCode.HunterMerchant10]: {
            title: "Zkušený Lovec",
            description: "Zaregistrování 10 obchodníků",
          },
          [LoyaltyEventCode.HunterMerchant50]: {
            title: "Expertní Lovec",
            description: "Zaregistrování 50 obchodníků",
          },
          [LoyaltyEventCode.HunterRecruitHunter]: {
            title: "Úlovek do tlupy",
            description: "Pozvání nového Huntera",
          },
          [LoyaltyEventCode.HunterRecruit3]: {
            title: "Lovec Lovců",
            description: "Pozvání 3 nových Hunterů",
          },
          [LoyaltyEventCode.HunterRecruit10]: {
            title: "Zkušený Lovec Lovců",
            description: "Pozvání 10 nových Hunterů",
          },
          [LoyaltyEventCode.HunterMerchantNetwork]: {
            title: "Rozšiřování sítí",
            description: "Tvůj obchodník doporučil nového uživatele",
          },
          [LoyaltyEventCode.HunterWeeklyMerchant]: {
            title: "Start týdenní mise",
            description: "První registrovaný aktivní obchodník v týdnu",
          },
          [LoyaltyEventCode.HunterMonthlyMerchant]: {
            title: "Start měsíční mise",
            description: "První registrovaný aktivní obchodník v měsíci",
          },
          [LoyaltyEventCode.HunterTerminalPlaced]: {
            title: "Umístění terminálu",
            description: "Umístění terminálu u obchodníka",
          },
          [LoyaltyEventCode.HunterTerminalPlaced3]: {
            title: "Umístění 3 terminálů",
            description: "Umístění 3 terminálů u obchodníků",
          },
          [LoyaltyEventCode.HunterTerminalPlaced10]: {
            title: "Umístění 10 terminálů",
            description: "Umístění 10 terminálů u obchodníků",
          },
          [LoyaltyEventCode.HunterTerminalOfTheWeek]: {
            title: "Terminál týdne",
            description: "První umístěný terminál v týdnu",
          },
          [LoyaltyEventCode.HunterTerminalOfTheMonth]: {
            title: "Terminál měsíce",
            description: "První umístěný terminál v měsíci",
          },
          [LoyaltyEventCode.HunterClosedHunter]: {
            title: "Uzavření Lovce",
            description: "Pozvaný Hunter si zakoupil licenci",
          },
          [LoyaltyEventCode.CustomerReferCustomer]: {
            title: "Díky Tobě!",
            description: "Pozvání a registrace nového uživatele",
          },
          [LoyaltyEventCode.CustomerReferCustomer10]: {
            title: "Díky Tobě 10!",
            description: "Pozvání a registrace 10 uživatelů skrze Díky Tobě!",
          },
          [LoyaltyEventCode.CustomerReferCustomer50]: {
            title: "Díky Tobě 50!",
            description: "Pozvání a registrace 50 uživatelů skrze Díky Tobě!",
          },
          [LoyaltyEventCode.CustomerReferCustomer100]: {
            title: "Díky Tobě 100!",
            description: "Pozvání a registrace 100 uživatelů skrze Díky Tobě!",
          },
          [LoyaltyEventCode.CustomerDailyAppOpen]: {
            title: "Denní otevření aplikace",
            description: "Spusť {{appName}} alespoň jednou za den",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak3]: {
            title: "Streak otevření aplikace 3 dny",
            description: "Přihlášení do aplikace 3 dny v řadě",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak5]: {
            title: "Streak otevření aplikace 5 dnů",
            description: "Přihlášení do aplikace 5 dnů v řadě",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak10]: {
            title: "Streak otevření aplikace 10 dnů",
            description: "Přihlášení do aplikace 10 dnů v řadě",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak30]: {
            title: "Streak otevření aplikace 30 dnů",
            description: "Přihlášení do aplikace 30 dnů v řadě",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak180]: {
            title: "Streak otevření aplikace 180 dnů",
            description: "Přihlášení do aplikace 180 dnů v řadě",
          },
          [LoyaltyEventCode.CustomerDailyAppOpenStreak365]: {
            title: "Streak otevření aplikace 365 dnů",
            description: "Přihlášení do aplikace 365 dnů v řadě",
          },
          [LoyaltyEventCode.CustomerCompleteRegistration]: {
            title: "Kompletní registrace",
            description: "Dokonči svou registraci uživatele",
          },
          [LoyaltyEventCode.TenPayments]: {
            title: "Desítkař",
            description: "Dosažení 10 plateb {{appName}}",
          },
          [LoyaltyEventCode.FiftyPayments]: {
            title: "Padesátkař",
            description: "Dosažení 50 plateb {{appName}}",
          },
          [LoyaltyEventCode.HundredPayments]: {
            title: "Stovkař",
            description: "Dosažení 100 plateb {{appName}}",
          },
          [LoyaltyEventCode.ThousandPayments]: {
            title: "Tisíckrát {{appName}}",
            description: "Dosažení 1 000 plateb {{appName}}",
          },
          [LoyaltyEventCode.Explorer]: {
            title: "Průzkumník",
            description: "Platba u 5 různých obchodníků",
          },
          [LoyaltyEventCode.Discoverer]: {
            title: "Objevitel",
            description: "Platba u 10 různých obchodníků",
          },
          [LoyaltyEventCode.Traveler]: {
            title: "Cestovatel",
            description: "Platba u 50 různých obchodníků",
          },
          [LoyaltyEventCode.FriendPayment]: {
            title: "Platba příteli",
            description: "První přímá platba přes {{appName}} příteli",
          },
          [LoyaltyEventCode.LargePayment]: {
            title: "Velká platba",
            description: "První platba s {{appName}} nad 1000 Kč",
          },
          [LoyaltyEventCode.BankConnection]: {
            title: "Bankovní spojení",
            description: "První připojení bankovního účtu",
          },
          [LoyaltyEventCode.FirstSpending]: {
            title: "První útrata",
            description: "První přímá platba přes {{appName}} u obchodníka",
          },
          [LoyaltyEventCode.EngineIgnition]: {
            title: "Zážeh motorů",
            description: "První platba dne (ze všech uživatelů)",
          },
          [LoyaltyEventCode.WeeklyMissionStart]: {
            title: "Týdenní start mise",
            description: "První platba týdne (ze všech uživatelů)",
          },
          [LoyaltyEventCode.RepeatedUsage]: {
            title: "Opakované použití",
            description: "Proveď 10 plateb v měsíci",
          },
          [LoyaltyEventCode.MonthlyMissionStart]: {
            title: "Měsíční start mise",
            description: "První platba měsíce (ze všech uživatelů)",
          },

          [LoyaltyEventCode.Payment]: {
            title: "Platba {{appName}}",
            description: "Transakce uskutečněná prostřednictvím {{appName}}",
          },
          [LoyaltyEventCode.PaymentStreak3]: {
            title: "Streak plateb 3 dny",
            description: "Zaplať každý den po dobu 3 dní",
          },
          [LoyaltyEventCode.PaymentStreak5]: {
            title: "Streak plateb 5 dnů",
            description: "Zaplať každý den po dobu 5 dní",
          },
          [LoyaltyEventCode.PaymentStreak10]: {
            title: "Streak plateb 10 dnů",
            description: "Zaplať každý den po dobu 10 dní",
          },
          [LoyaltyEventCode.PaymentStreak30]: {
            title: "Streak plateb 30 dnů",
            description: "Zaplať každý den po dobu 30 dní",
          },
          [LoyaltyEventCode.PaymentStreak180]: {
            title: "Streak plateb 180 dnů",
            description: "Zaplať každý den po dobu 180 dní",
          },
        },
      },
      UserDetailPageContent: {
        SaveSuccess: "Údaje uživatele byly úspěšně uloženy",
        SaveError: "Při ukládání údajů uživatele se vyskytla chyba",
        DuplicateLoginError: "Tento login používá jiný uživatel",
        AddressFields: {
          Legend: "Adresa",
          Type: "Typ adresy",
          Street: "Ulice",
          StreetNumber: "Číslo popisné",
          OrientationNumber: "Číslo orientační",
          PostalCode: "PSČ",
          Municipality: "Obec",
          Remove: {
            Button: "Odstranit adresu",
            ConfirmTitle: "Odstranit adresu",
            ConfirmContent: "Opravdu chcete tuto adresu odstranit?",
            SuccessMessage: "Adresa byla odstraněna",
            ErrorMessage: "Při odstraňování adresy došlo k chybě",
          },
        },
        Tabs: {
          User: {
            Title: "Uživatel",
            Form: {
              Login: "Login",
              Status: "Status",
              VerificationAdditionalInfoStatus: "Status doplňujících informací",
              VerificationIdentityVerificationStatus: "Status ověření identity",
              VerificationRiskProfile: "Rizikový profil",
              VerificationBankVerificationStatus: "Status bankovní verifikace",
              BankVerificationSource: "Zdroj bankovního verifikace",
              BankAccountNumber: "Číslo ověřujícího účtu",
              VerificationDailyBuyLimit: "Denní limit",
              VerificationMonthlyBuyLimit: "Měsíční limit",
              Stardust: {
                Legend: "Věrnostní program Stardust",
                NotAsked: "Nedotázán",
                OptedIn: "Přihlášen",
                OptedOut: "Odhlášen",
                Withdrawn: "Trvale odstoupil",
                ChangedAt: "Od {{date}} ({{source}})",
                Source: {
                  Registration: "registrace",
                  ConsentDialog: "dialog Stardust",
                  ProgramSection: "sekce Stardust",
                },
              },
              ThanksToYou: {
                Legend: "Program doporučení Díky Tobě!",
                NotAsked: "Přihlášen (bez odpovědi)",
                OptedIn: "Přihlášen",
                OptedOut: "Odmítl účast",
                Withdrawn: "Trvale odstoupil",
                ChangedAt: "Od {{date}} ({{source}})",
                Source: {
                  Registration: "registrace",
                  ConsentDialog: "dialog",
                  ProgramSection: "sekce Díky Tobě!",
                },
              },
              Legend: {
                Account: "Účet",
                Verification: "Verifikace",
                Bank: "Banka",
                Limits: "Limity",
              },
            },
          },
          Party: {
            Title: "Osoba",
            SetVerified: "Ověřit identitu",
            CancelVerification: "Odebrat ověření identity",
            NoDocumentsUploaded: "Tato osoba nemá nahrané žádné dokumenty",
            NoActingPersonLinked:
              "Není propojena jednající osoba — dokumenty nejsou k dispozici",
            IdentityVerificationLegend: "Ověření identity",
            IdentityVerified: "Identita uživatele byla ověřena",
            IdentityNotVerified: "Ověření identity uživatele bylo odebráno",
            Form: {
              SubmitSuccess: "Údaje osoby byly úspěšně uloženy",
              SubmitError: "Při ukládání údajů osoby se vyskytla chyba",
              Save: "Uložit",
              ClientIdentifier: "ID klienta",
              CopyClientIdentifier: "Kopírovat ID klienta",
              CopyClientIdentifierSuccess: "ID klienta zkopírováno",

              NaturalPerson: {
                Type: "Typ osoby",
                FirstName: "Jméno",
                LastName: "Příjmení",
                PersonalNumber: "Rodné číslo",
                BirthDate: "Datum narození",
                Gender: "Pohlaví",
                BirthPlace: "Místo narození",
                Nationality: "Národnost",
                Phone: "Telefon",
                VerifiedPhone: "Ověřený telefon",
                Email: "E-mail",
                Legend: {
                  PersonalData: "Osobní údaje",
                  Contact: "Kontakt",
                  Documents: "Doklady",
                },
              },
              PartyIdentification: {
                Identification: "Typ identifikace",
                IdentificationNumber: "Číslo identifikace",
                IdentificationValidFrom: "Platnost od",
                IdentificationValidTo: "Platnost do",
                IdentificationIssuer: "Vydal",
                NoIdentificationsUploaded:
                  "Pro tuto osobu neevidujeme žádné nahrané doklady.",
                IdentificationsDownloadPrefix: "doklady_",
                SecondDocumentTitle: "Druhý doklad",
                AutomatedCheck: {
                  Title: "Automatická kontrola dokladu",
                  NoChecks: "Automatická kontrola zatím neproběhla.",
                  LoadingError:
                    "Nepodařilo se načíst výsledky automatické kontroly.",
                  Document: "Doklad",
                  Documents: {
                    Primary: "Primární doklad",
                    Secondary: "Druhý doklad",
                  },
                  Verdict: "Výsledek",
                  Date: "Datum",
                  DocumentType: "Typ dle Didit",
                  RequestID: "Didit request ID",
                  Warnings: "Varování",
                  Error: "Chyba",
                },
              },
              LegalEntity: {
                Type: "Typ osoby",
                CompanyName: "Název společnosti",
                CompanyNumber: "IČO",
                TaxNumber: "DIČ",
                Phone: "Telefon",
                Email: "E-mail",
                Legend: {
                  Company: "Společnost",
                  Contact: "Kontakt",
                },
                RegistryLinks: {
                  Or: "Obchodní rejstřík",
                  Isir: "Insolvenční rejstřík",
                  Esm: "Evidence majitelů",
                },
              },
              SelfEmployed: {
                Legend: {
                  Company: "Podnikatel",
                  Contact: "Kontakt",
                  Documents: "Doklady",
                },
                Type: "Typ osoby",
                CompanyName: "Název společnosti",
                FirstName: "Jméno",
                LastName: "Příjmení",
                CompanyNumber: "IČO",
                TaxNumber: "DIČ",
                PersonalNumber: "Rodné číslo",
                BirthDate: "Datum narození",
                Gender: "Pohlaví",
                BirthPlace: "Místo narození",
                Nationality: "Národnost",
                Phone: "Telefon",
                VerifiedPhone: "Ověřený telefon",
                Email: "E-mail",
              },
            },
          },
          BankAccounts: {
            Title: "Bankovní účty",
            Subtitle: "Připojené bankovní účty",
          },
          Licenses: {
            Title: "Licence",
            Empty: "Uživatel nemá žádnou aktivní licenci.",
            Transfer: {
              Button: "Převést licenci",
              Title: "Převod licence {{licenseNo}}",
              Description:
                "Na nového huntera přejdou merchanti registrovaní na licenci, celá affiliate síť původního huntera (přivedení zákazníci i hunteři) a všechny budoucí odměny z nich. Již naběhlé a vyplacené odměny, faktura za nákup a uzavřená historie zůstávají původnímu hunterovi (uvidí je, ale už z nich neprofituje). Adresa peněženky licence zůstává beze změny.",
              TargetLabel: "Nový držitel licence",
              Submit: "Převést licenci",
              Success: "Licence byla převedena",
              Error: "Při převodu licence se vyskytla chyba",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Údaje licence byly uloženy",
                SubmitError: "Při ukládání údajů licence se vyskytla chyba",
                Save: "Uložit",
                SendInvoice: "Odeslat fakturu",
                SendingInvoice: "Odesílám fakturu...",
                SendInvoiceSuccess: "Faktura byla úspěšně odeslána",
                SendInvoiceError: "Při odesílání faktury se vyskytla chyba",
                InvoiceSent: "Faktura odeslána",
                RegenerateInvoice: "Přegenerovat fakturu",
                RegeneratingInvoice: "Přegenerovávám fakturu...",
                RegenerateInvoiceSuccess: "Faktura byla přegenerována",
                RegenerateInvoiceError:
                  "Při přegenerování faktury se vyskytla chyba",
              },
              Fields: {
                Code: "Typ licence",
                LicenseNo: "Číslo licence",
                PaymentDate: "Datum platby",
                PaymentStatus: {
                  label: "Stav platby",
                  options: {
                    Initiated: "Platba vytvořena",
                    Processing: "Probíhá zpracování",
                    Success: "Zaplaceno",
                    Fail: "Neúspěšná",
                    Cancelled: "Zrušeno",
                  },
                },
                WalletAddress: "Adresa peněženky",
              },
            },
          },
          Verification: {
            Title: "Ověření",
            Form: {
              Controls: {
                SubmitSuccess: "Údaje ověření byly uloženy",
                SubmitError: "Při ukládání údajů ověření se vyskytla chyba",
                Save: "Uložit",
              },
              Fields: {
                TaxResidencyCountryID: "Daňová rezidence",
                BusinessActivity: "Předmět podnikání",
                OtherBusinessActivityDetails: "Upřesněte předmět podnikání",
                SourceOfIncome: "Zdroj příjmů",
                OtherSourceOfIncomeDetails: "Upřesněte zdroj příjmů",
                LegacySourceOfIncome: "Předchozí zdroj příjmů",
                ExpectedMonthlyRevenue: "Očekávaný měsíční objem",
                AverageTransactionValue: "Průměrná hodnota jedné transakce",
                IsPoliticallyExposedPerson: "Politicky exponovaná osoba",
                HasNonEUResidence:
                  "Bydliště ke dni registrace mimo EU po dobu delší než 12 měsíců",
                HasNonEUNationality: "Státním příslušníkem jiné země mimo EU",
              },
            },
          },
          Settlement: {
            Title: "Vyúčtování",
          },
          HunterPrerequisites: {
            Title: "Hunter první kroky",
            SelectAll: "Vybrat všechny",
            DeselectAll: "Zrušit všechny",
            LoadingError: "Při načítání předpokladů došlo k chybě.",
            SaveSuccess: "Změny byly úspěšně uloženy.",
            SaveError: "Při ukládání změn nastala chyba.",
            Note: "Poznámka",
            NotePlaceholder: "Volitelná poznámka...",
            AutoVerified: "Automaticky ověřeno",
            Items: {
              RegisterAsMerchant:
                "Zaregistroval/a se jako Obchodník a prošel/a si aplikaci",
              InviteUserViaAffiliate:
                "Pozval/a nového uživatele skrze Díky Tobě!",
              BanksAndPayments:
                "Připojil/a si alespoň 3 banky a provedl/a 30 plateb",
              OfflineTraining: "Navštívil/a offline školení Mo.one",
              BringMerchantsWithHunter:
                "Přivedl/a 3 Obchodníky v kooperaci se zkušeným Hunterem",
            },
          },
          RelatedParties: {
            Title: "Související osoby",
            NoRelatedParties:
              "Pro tuto osobu neevidujeme žádné související osoby.",
            Add: {
              Button: "Přidat související osobu",
              Title: "Přidat související osobu",
              RelationTypeLabel: "Typ vztahu",
              BeneficialOwnerOption: "Skutečný majitel",
              Submit: "Přidat",
              AddSuccess: "Související osoba byla přidána",
              AddError: "Při přidávání související osoby došlo k chybě",
              LinkError:
                "Osoba byla vytvořena, ale nepodařilo se ji propojit s firmou. Zkuste to prosím znovu – duplicitní osoba se nevytvoří.",
              DocumentsTitle: "Doklady totožnosti",
              DocumentsIncomplete:
                "Přiložte prosím obě strany prvního dokladu a kompletní druhý doklad.",
            },
            Delete: {
              Button: "Smazat související osobu",
              ConfirmTitle: "Smazat související osobu",
              ConfirmContent:
                "Opravdu chcete smazat související osobu {{name}}? Odstraní se pouze tato role.",
              SuccessMessage: "Související osoba byla smazána",
              ErrorMessage: "Při mazání související osoby došlo k chybě",
            },
            Form: {
              Controls: {
                SubmitSuccess: "Údaje související osoby byly uloženy",
                SubmitError:
                  "Při ukládání údajů související osoby se vyskytla chyba",
                LoadingError:
                  "Při načítání údajů související osoby se vyskytla chyba",
                Save: "Uložit",
              },
              Fields: {
                RelationType: "Role",
                IsOwner: "Osoba je skutečným vlastníkem",
                BeneficialOwnerFields: {
                  Legend: {
                    PersonalData: "Osobní údaje",
                  },
                  FirstName: "Jméno",
                  LastName: "Příjmení",
                  BirthDate: "Datum narození",
                  Nationality: "Národnost",
                },
                RelatedPartyFields: {
                  Legend: {
                    PersonalData: "Osobní údaje",
                    Contact: "Kontakt",
                    Documents: "Doklady",
                    FirstDocument: "První doklad",
                  },
                  DocumentsExpiringSoon: "Platnost dokladů brzy vyprší",
                  DocumentsExpired: "Platnost dokladů vypršela",
                  DocumentsValidityMissing: "Chybí platnost dokladů",
                  FirstName: "Jméno",
                  LastName: "Příjmení",
                  PersonalNumber: "Rodné číslo",
                  BirthDate: "Datum narození",
                  Gender: "Pohlaví",
                  BirthPlace: "Místo narození",
                  Nationality: "Národnost",
                  Phone: "Telefon",
                  Email: "E-mail",
                },
              },
            },
          },
        },
      },
      Contact: {
        HunterDiscord: {
          Description: "Pro rychlou komunikaci se připoj k serveru",
          Link: "Legi.one na Discordu!",
        },
        Phone: "Telefon",
        Email: "E-mail",
        PhoneDescription:
          "Telefonicky nás můžete kontaktovat v pracovní dny od 9:00 do 16:00.",
        CompanyInfo: {
          title: "Provozovatel",
          description: "Mo.one a.s.",
          CompanyNumber: "IČO: 02013517",
          TaxNumber: "DIČ: CZ02013517",
          CompanyAddress:
            "Sídlem Palackého třída 3048/124, Královo Pole, 612 00 Brno, zapsána v obchodním rejstříku u Krajského soudu v Brně, sp.zn. B 9099",
        },
        HunterCompanyInfo: {
          Title: "Provozovatel",
          CompanyName: "LEGI.ONE LTD.",
          CompanyInfoLine1:
            "registrovaná ve Velké Británii pod číslem 15846883",
          CompanyInfoLine2: "se sídlem 20 Wenlock Road, Londýn, Anglie, N1 7GU",
          CompanyInfoLine3:
            "v souvislosti a prostřednictvím svého odštěpného závodu v České republice:",
        },
        BankInfo: {
          Title: "Bankovní spojení",
          CZKAccount: {
            Customer: "Fio banka: 2103087398/2010",
            Hunter: "Bankovní účet CZK: 1741535007/2700",
            Merchant: "Fio banka: 2103087398/2010",
            Admin: "Fio banka: 2103087398/2010",
            Aml: "Fio banka: 2103087398/2010",
            Employee: "Fio banka: 2103087398/2010",
            CustomerOnboarding: "Fio banka: 2103087398/2010",
            HunterPlus: "Bankovní účet CZK: 1741535007/2700",
            AdminLite: "Fio banka: 2103087398/2010",
            Disponent: "Fio banka: 2103087398/2010",
            Child: "Fio banka: 2103087398/2010",
          },
          EURAccount: {
            Customer: "",
            Hunter: "Bankovní účet EUR: 1741535015/2700",
            Merchant: "",
            Admin: "",
            Aml: "",
            Employee: "",
            CustomerOnboarding: "",
            HunterPlus: "Bankovní účet EUR: 1741535015/2700",
            AdminLite: "",
            Disponent: "",
            Child: "",
          },
        },
      },
      BankAccounts: {
        ConnectedBankAccounts: "Všechny připojené účty",
        CurrencyGroupTitle: "Účty v měně {{currency}}",
        BankIdentityVerificationAccount: "Ověřující účet",
        InvalidTokenChip: "Vypršel přístup",
        EditOrder: "Upravit pořadí",
        AccountMenu: {
          Renew: "Obnovit přístup",
          RenewPayments: "Obnovit platby",
          Remove: "Odpojit účet",
        },
        PrimaryAccount: "Primární účet",
        PrimaryAccountDescription:
          "Primární účet nastavujete hvězdičkou pro každou měnu zvlášť — je výchozím účtem pro přijímání a odesílání plateb v dané měně. Nelze jej nastavit na účet ve stavu <limitedChip /> ani <awaitingVerificationChip />.",
        HunterPrimaryAccountDescription:
          "Primární účet nastavujete hvězdičkou pro každou měnu zvlášť — na primární účet dané měny vám budeme zasílat vaše odměny.",
        MissingLicenseHolderBankAccount:
          "Pro výplatu odměn připojte bankovní účet vedený na vlastníka franšízové licence.",
        VerificationStatusesTitle: "Stavy ověření účtu",
        QuickPayment: {
          Label: "Rychlá platba",
          Description:
            "Po načtení transakce budete automaticky přesměrováni do své banky k autorizaci platby s primárním účtem, vynecháte tak krok s detailem transakce a výběrem banky.",
        },
        EditAccountOrderDescription:
          "Pořadí účtů můžete změnit podržením a přetažením účtu na požadovanou pozici.",
        NoBankAccounts: "Nemáte žádné připojené bankovní účty.",
        Error:
          "Při načítání bankovních účtů se vyskytla neočekávaná chyba. Zkuste to prosím znovu později.",
        NoAccountSet: "Není nastaven žádný účet",
        DeleteAccount: {
          Title: "Smazat účet",
          Prompt: "Opravdu chcete smazat tento účet?",
          ReplacementPrimaryAccount: "Nový primární účet",
          PrimaryAccountWarning:
            "Chystáte se smazat Váš <bold>primární účet</bold>. Zvolte si, kterým účtem jej chcete nahradit.",
        },
        ManualBankAccountVerificationPrompt: {
          ManualVerificationNecessary: "Tento účet je nutné ověřit manuálně",
          ActivateConfirmationPrompt:
            "Opravdu chcete tento účet aktivovat? Tato akce je nevratná.",
          Activate: "Aktivovat",
          Reject: "Zamítnout",
          RejectConfirmationPrompt:
            "Opravdu chcete tento účet zamítnout? Tato akce je nevratná.",
        },
        ConnectedBankAccount: {
          Owner: "Majitel účtu",
          DateCreated: "Datum připojení",
          Status: "Stav",
          BankVerificationSource: "Zdroj bankovního verifikace",
        },
        DeletedVerificationAccount: {
          Error: "Ověřující účet se nepodařilo načíst.",
        },
        Detail: {
          IBAN: "IBAN",
          AccountOwners: "Majitel",
          DateConnected: "Připojeno",
          AccountNotFound: "Tento bankovní účet se nepodařilo najít.",
          BackToList: "Zpět na bankovní účty",
          IsPrimaryNote: "Toto je váš primární bankovní účet",
          Actions: {
            SetAsPrimary: "Nastavit jako primární",
            PrimaryAccountDescription:
              "Primární účet je výchozí pro přijímání a odesílání plateb.",
            AuthorizeAccess: "Autorizovat přístup {{bankName}}",
            AuthorizePayments: "Autorizovat platby {{bankName}}",
            AuthorizationValidUntil: "Autorizace platná do {{date}}",
          },
          IbanCopySuccess: "IBAN zkopírován",
          Alerts: {
            Rejected: {
              Title: "Účet byl zamítnut",
              Description:
                "Tento účet byl zamítnut a nelze ho v aplikaci používat.",
            },
            Inactive: {
              Title: "Účet je neaktivní",
              Description:
                "Tento účet je neaktivní. Pokud jej chcete znovu používat, kontaktujte podporu.",
            },
            Restricted: {
              Title: "Dokončete ověření identity",
              Description:
                "Pro plné využití tohoto účtu je potřeba dokončit ověření identity.",
              Action: "Dokončit ověření",
            },
            AwaitingVerification: {
              Title: "Účet čeká na manuální ověření",
              Description:
                "Informace o tomto účtu musí nejprve ověřit někdo z týmu {{appName}}. Nejčastější příčinou je, že se jméno majitele účtu nepodaří automaticky porovnat s Vaším jménem.",
            },
            PreApproved: {
              Title: "Účet je předschválen",
              Description:
                "Můžete přijímat platby z účtu na účet až do {{limit}}, než bude účet plně ověřen — zbývá {{remaining}}. Po dokončení ověření se limity automaticky zruší.",
            },
            TokenInvalidAis: {
              Title: "Přístup k účtu vypršel",
              Description:
                "Vypršelo oprávnění pro přístup k informacím o účtu. Abychom mohli načítat zůstatek a transakce, je třeba obnovit připojení ve Vašem bankovnictví.",
              Action: "Obnovit přístup",
            },
            TokenExpiringAis: {
              Title: "Přístup k účtu brzy vyprší",
              Description:
                "Přístup k informacím o účtu brzy vyprší. Obnovte ho, ať můžeme dál načítat zůstatek.",
              Action: "Obnovit přístup",
            },
            TokenInvalidPisp: {
              Title: "Autorizace plateb vypršela",
              Description:
                "Vypršela autorizace plateb z tohoto účtu. Obnovte ji, ať můžete dál odesílat platby.",
              Action: "Obnovit platby",
            },
            TokenExpiringPisp: {
              Title: "Autorizace plateb brzy vyprší",
              Description:
                "Autorizace plateb z tohoto účtu brzy vyprší. Obnovte ji, ať můžete dál odesílat platby.",
              Action: "Obnovit platby",
            },
          },
        },
      },
      MerchantFeeCalculator: {
        YearlySavingsWidget: {
          PotentialYearlySavings: "Potenciální roční úspora",
          WithLegione: "S Legi.one až:",
          WithMoone: "S {{appName}} až:",
        },
        CurrentTotalFee: "Aktuální celkový poplatek",
        ProposedTotalFee: "Navržený celkový poplatek",
        HideFeeTable: "Skrýt detailní tabulku poplatků",
        ShowFeeTable: "Zobrazit detailní tabulku poplatků",
        MonthlyTurnover: "Měsíční obrat",
        AverageTransactionValue: "Průměrná hodnota transakce",
        MooneDirectPayShare: "Podíl přímých plateb",
        Currency: "Kč",
        FeeSettings: {
          CurrentFees: "Aktuální poplatky",
          ProposedFee: "Navrhovaný poplatek",
          DirectPaymentWithMoone: "Přímá platba s {{appName}}",
          ProviderFee: "Poplatek provozovateli",
          Acquiring: "(Acquiring)",
          FixedTransactionCost: "Fixní náklad za transakci",
          MooneFee: "Poplatek {{appName}}",
        },
        CardTypeRatioSlider: {
          Title: "Rozložení platebních karet",
          ToggleButtons: {
            MostlyPersonal: "Převážně spotřebitelské",
            SomeCommercial: "Vyšší podíl podnikatelských",
            MostlyCommercial: "Převážně podnikatelské",
          },
          CardTypeRatios: {
            Personal: "Spotřebitelské",
            Commercial: "Podnikatelské",
          },
        },
        CardRatesTable: {
          Expand: "Zobrazit detailní tabulku poplatků",
          Collapse: "Skrýt detailní tabulku poplatků",
          Headers: {
            CardType: "Typ karty",
            Interchange: "Interchange",
            SchemeFee: "Scheme fee",
            CurrentTotalRate: "Aktuální celkový poplatek",
            ProposedTotalRate: "Navržený celkový poplatek",
          },
        },
        CostsChart: {
          Title: "Náklady na transakce",
          HighContrast: "Vysoký kontrast",
          AnnualTransactionCosts: "Roční náklady za transakce",
          TickLabels: {
            CurrentCosts: {
              Mobile: "Nyní",
              Full: "Aktuální náklady",
              Description: "Průměrný poplatek",
            },
            LegioneCosts: {
              Mobile: "Legi.one",
              Full: "Náklady s Legi.one",
              Description: "Průměrný poplatek",
            },
            MooneCosts: {
              Mobile: "{{appName}}",
              Full: "Náklady s {{appName}}",
              Description: "Poplatek",
            },
          },
        },
      },
      Settlements: {
        Error:
          "Při načítání vyúčtování se vyskytla neočekávaná chyba. Zkuste to prosím znovu později.",
        SettlementTrigger: "Spustit vyúčtování poplatků za aktuální období.",
        SettlementTriggerError:
          "Při spouštění vyúčtování nastala chyba. Zkuste to prosím znovu později.",
        SettlementTriggerSuccess: "Vyúčtování bylo úspěšně spuštěno.",
        SettlementTriggerLoading: "Spouštím vyúčtování...",
        SettlementTriggerButtonText: "Spustit vyúčtování",
      },
      Merchants: {
        StatusWidgets: {
          OpenRegistrations: "Otevřené registrace",
          InvitationsSent: "Odeslaných pozvánek",
          InOnboarding: "Probíhá onboarding",
          Completed: "Aktivních obchodníků",
        },
        Error:
          "Při načítání obchodníků se vyskytla neočekávaná chyba. Zkuste to prosím znovu později.",
        TableHeaders: {
          Status: "Status",
          CompanyName: "Název firmy",
          CompanyNumber: "IČO",
          LicenseType: "Typ licence",
          LicenseOwner: "Hunter (majitel licence)",
          LicenseNumber: "Číslo licence",
          DateCreated: "Datum vytvoření",
          TransactionsCount: "Počet transakcí",
        },
        OrbitLOnboarding: {
          Title: "OrbitL Onboarding",
          ActionRequiredBadge: "Vyžaduje akci",
          LoadingError: "Nepodařilo se načíst data OrbitL onboardingu",
          Table: {
            CompanyNumber: "IČO",
            CompanyName: "Název firmy",
            Hunter: "Hunter",
            ActivatedAt: "OrbitL aktivován",
            Phase: "Fáze",
            ComgateStatus: "Comgate status",
            ComgateMID: "MID",
            TimeSinceSubmit: "Čas od odeslání",
            LastStatusChange: "Poslední změna stavu",
            FinancingModel: "Financování",
            Hours: "{{count}}h",
            Days: "{{count}}d",
            TerminalCount: "Terminály",
            TerminalCountRequest: "Žádost o změnu počtu",
            OnlyOpenRequests: "Jen s otevřenou žádostí",
          },
          TerminalCountChange: {
            SectionTitle: "Počet terminálů",
            OpenRequestHeading: "Otevřená žádost o změnu",
            RequestedBy: "Požádal {{user}}",
            SystemActor: "systém",
            ContractTotal: "Sjednaný počet: {{count}}",
            ContractSoftPosTotal: "SoftPOS: {{count}}",
            ContractLevelChange: "Celkový počet",
            SoftPosChange: "SoftPOS {{from}} → {{to}}",
            SoftPosTotal: "SoftPOS: {{from}} → {{to}}",
            HistoryHeading: "Historie změn",
            NoHistory: "Zatím žádné změny počtu terminálů",
            ResolveButton: "Vyřešeno",
            DismissButton: "Zamítnout",
            ResolveHint:
              "Vyřešení žádost jen uzavře — samotný počet změňte přes úpravu provozovny.",
            DismissDialogTitle: "Zamítnout žádost",
            DismissNoteLabel: "Důvod zamítnutí",
            DismissNoteRequired: "Uveďte důvod zamítnutí",
            DismissConfirm: "Zamítnout žádost",
            Cancel: "Zrušit",
            ResolveSuccess: "Žádost byla označena jako vyřešená",
            DismissSuccess: "Žádost byla zamítnuta",
            Error: "Žádost se nepodařilo vyřídit",
            Source: {
              MerchantSelfService: "Obchodník",
              Admin: "Podpora",
              InitialOrder: "Objednávka",
            },
            Status: {
              Applied: "Provedeno",
              Pending: "Čeká na vyřízení",
              Resolved: "Vyřešeno",
              Dismissed: "Zamítnuto",
            },
          },
          Detail: {
            Title: "Detail OrbitL onboardingu",
            CloseButton: "Zavřít",
            ChecklistSection: "Kontrolní seznam",
            RejectionSection: "Chyby Comgate",
            TerminalsSection: "Přiřazení terminálů",
            CommentsSection: "Comgate komentáře",
            NoTerminals: "Žádné přiřazené terminály",
            NoComments: "Zatím žádné komentáře",
            SendNoteLabel: "Odeslat poznámku do Comgate",
            SendNoteButton: "Odeslat",
            SendNotePlaceholder: "Napište zprávu...",
            SendNoteSuccess: "Komentář byl úspěšně odeslán",
            SendNoteError: "Nepodařilo se odeslat komentář",
            ResubmitButton: "Znovu odeslat do Comgate",
            ResubmitConfirmTitle: "Potvrdit opětovné odeslání",
            ResubmitConfirmText:
              "Tímto znovu odešlete data a dokumenty obchodníka do Comgate. Ujistěte se, že všechny problémy byly vyřešeny. Status bude nastaven na REQUESTED.",
            ResubmitConfirmButton: "Znovu odeslat",
            ResubmitCancelButton: "Zrušit",
            ResubmitSuccess: "Úspěšně odesláno do Comgate",
            ResubmitError: "Nepodařilo se znovu odeslat do Comgate",
            CommentAuthor: "Autor",
            CommentDate: "Datum",
            SwapTerminal: "Vyměnit",
            SwapTerminalTitle: "Výměna terminálu",
            SwapTerminalSearch: "Hledat dle sériového čísla...",
            SwapTerminalConfirm: "Vyměnit terminál",
            SwapTerminalCancel: "Zrušit",
            SwapTerminalSuccess: "Terminál úspěšně vyměněn",
            SwapTerminalSuccessWithCode:
              "Terminál vyměněn. Aktivační kód {{code}} je opět platný pro nové zařízení",
            SwapTerminalError: "Nepodařilo se vyměnit terminál",
            SwapTerminalNoResults: "Žádné dostupné terminály",
            SwapTerminalTmsUpdateWarning:
              "Terminál je již zaregistrován ve Switchio TMS. Výměna sériového čísla bude provedena také v TMS.",
            TerminalStatusDeployed: "Registrováno v TMS",
            Tid: "TID",
            TidTypesSection: "Typy terminálů (TIDy z Comgate)",
            TidTypesHint:
              "U těchto TIDů se nepodařilo určit typ. Označte je; ostatní TIDy se registrují i bez nich. TID nad rámec objednávky nejde označit, dokud se na smlouvě nenavýší počet terminálů nebo SoftPOS.",
            TidTypePhysical: "Fyzický terminál",
            TidTypeSoftPos: "SoftPOS",
            TidTypeUnknown: "Neurčeno",
            TidTypeManual: "Ručně",
            SaveTidTypes: "Uložit typy",
            SaveTidTypesSuccess: "Typy TIDů uloženy",
            SaveTidTypesError: "Nepodařilo se uložit typy TIDů",
            SaveTidTypesExceedError:
              "Označené typy přesahují počty na smlouvě (fyzické / SoftPOS). Nejdřív navyšte počet na smlouvě.",
            RegisterTmsButton: "Spustit registraci do TMS",
            RegisterTmsSuccess:
              "Registrace do TMS: {{registered}}/{{expected}} terminálů",
            RegisterTmsError: "Registrace do TMS se nezdařila",
            ActivationCode: "Aktivační kód",
            ReactivateCodeButton: "Uvolnit kód pro nové zařízení",
            ReactivateCodeSuccess:
              "Vazba na zařízení zrušena, aktivační kód lze použít znovu",
            ReactivateCodeError: "Vazbu na zařízení se nepodařilo zrušit",
          },
          FindByTerminal: {
            Button: "Vyhledat terminál",
            Title: "Vyhledat merchanta podle terminálu",
            SearchLabel: "Hledat podle TID nebo sériového čísla...",
            NoResults: "Žádné terminály nenalezeny",
            Close: "Zavřít",
          },
        },
      },
      Users: {
        VerificationCell: {
          AdditionalInfo: "Doplňující informace",
          IdentityVerification: "Ověření identity",
          RiskProfile: "Rizikový profil",
          BankVerification: "Ověření bankovního účtu",
        },
        ExcludeAnonymous: "Nezobrazovat anonymní uživatele",
        Error:
          "Při načítání uživatelů se vyskytla neočekávaná chyba. Zkuste to prosím znovu později.",
        TableHeaders: {
          Verification: "Ověření",
          Login: "Login",
          Role: "Role",
          Status: "Status",
          FirstName: "Jméno",
          LastName: "Příjmení",
          Company: "Společnost",
          ClientIdentifier: "ID",
          DateCreated: "Datum vytvoření",
          PaymentReference: "Var. s. platby licence",
          Version: "Verze {{appName}}",
          DocumentExpiration: "Expirace dokladu",
          Settlement: "Vyúčtování",
          Admin: "Admin",
        },
        Filters: {
          ExpiringWithin30Days: "Expiruje do 30 dní",
          Expired: "Expirováno",
        },
        ConnectedBankAccounts: {
          LoadingError:
            " Chyba, nepodařilo se načíst připojené bankovní účty uživatele.",
          NoBankAccounts: "Uživatel nemá připojené žádné bankovní účty.",
          UnassignedContext: "Nepřiřazeno k roli (starší připojení)",
        },
        ToBeVerified: {
          Subtitles: {
            UserVerification: "Uživatelé k ověření",
            BankVerification: "Uživatelé s bankovními účty ke schválení",
          },
          AdditionalInfo: "Doplňující informace",
          RiskProfile: "Rizikový profil",
          BankVerification: "Ověření bankovního účtu",
          IdentityVerification: "Ověření identity",
        },
        RolesPermissions: {
          TableHeaders: {
            RoleName: "Název role",
            RoleCode: "Kód role",
            AccessRightCode: "Přístupové právo",
            CanRead: "Čtení",
            CanCreate: "Vytváření",
            CanUpdate: "Úpravy",
            CanDelete: "Mazání",
            CanExport: "Export",
          },
          NoAccessRights: "Žádná přístupová práva",
          AccessRightSingular: "přístupové právo",
          AccessRightPlural: "přístupová práva",
        },
      },
      Dashboard: {
        BankAccountsWidget: {
          Title: "Připojené účty",
          ConnectionFailed: "Připojené účty se nepodařilo načíst.",
          NoActiveAccounts: "Žádný aktivní účet k zobrazení.",
        },
        PreApprovalWidget: {
          Title: "Předschválený limit",
          Description: "Než Váš účet plně ověříme, platí následující omezení:",
          LimitPerTransaction:
            "maximální výše jedné transakce <amount>{{amount}}</amount>",
          LimitTotal: "celkový limit <amount>{{amount}}</amount>",
          Remaining: "Zbývá {{remaining}}",
        },
        TransactionFees: {
          Admin: {
            allTime: "Celkový výdělek za transakce",
            currentMonth: "Výdělek za tento měsíc",
            lastMonth: "Výdělek za předchozí měsíc",
          },
        },
      },
      Welcome: {
        RegistrationSuccess:
          "Vytvořili jsme Váš uživatelský účet. Níže si přečtěte, jak začít s příjmem výplaty v bitcoinech.",
        UnverifiedAccountLimits:
          "Jelikož je Váš účet zatím neověřený, máte nastavené nízké limity transakcí. Dodatečné ověření můžete následně provést ve svém profilu.",
        TransactionLimitsLink: "Limity transackcií",
        Complete: "Dokončit",
      },
      AnonymousDashboard: {
        RegistrationRequired:
          "Pro přístup k plné verzi aplikace se prosím registrujte",
        Register: "Registrovat se",
      },
      Redeem: {
        Step1: "1. Mincí seškrábněte krycí vrstvu",
        Step2: "2. Opište 16místný kód z karty",
        NoCardYet: "Ještě nemátu kartu? Zakoupíte ji",
      },
      RedeemPublic: {
        Step1: "1. Mincí seškrábněte krycí vrstvu",
        Step2: "2. Opište 16 místný kód z karty",
      },
      LeadInvitation: {
        Description:
          "Zadejte e-mail přítele, kterého chcete pozvat. Pokud bude Váš přítel účet aktivně využívat, dostanete za něj odměnu!",
      },
      ColdWallet: {
        WithdrawalTitle: "Výběr ze systémové peněženky:",
        DepositTitle: "Vložení na systémovou peněženku:",
        GenerateAddress: "Generovat novou systémovou adresu",
      },
      SystemReport: {
        HotWallet: "+ Na Hot Wallet",
        ColdWallet: "+ Na Cold Wallet",
        ExchangeWithdrawal: " + K výběru z burzy ",
        UserAccounts: "- Na účtech uživatelů",
        ControlSum: "Kontrolní suma",
        SystemWalletWithdrawal: "K výběru ze systémové peněženky",
        ExchangeWithdrawalFee: "Poplatek za výběr z burzy",
        BalanceOnExchange: "Zůstatek {{currencyCode}} na burze",
        TradingVolume: "Obchodovaný objem",
        PerMonth: "Za měsíc",
        PerWeek: "Za týden",
        PurchasedBTC: "Nakoupené BTC",
        WithdrawnOrPending: "Vybráno nebo k výběru",
        BTCLedgerSum: "Suma účetní knihy BTC",
        CZKLedgerSum: "Suma účetní knihy CZK",
        SystemVersion: "Verze systému: {{version}}",
      },
      BankingAuth: {
        BankListTitle: "Nabídka bank",
        BanksInPreparation: "Banky, které připravujeme",
      },
      Account: {
        ProfileError:
          "Omlouváme se, při zobrazování Vašeho profilu nastala neočekávaná chyba, zkuste to prosím znovu později.",
      },
      Help: {
        HelpInPreparation: "Podrobnou nápovědu aktuálně připravujeme.",
        ContactEmail:
          "V případě dotazů se na nás můžete obrátit písemně e-mailem na adresu:",
      },
      Error403: {
        Logout: "Odhlásit se",
      },
      CustomerAnonymousPaymentPay: {
        SignIn: "Přihlaste se.",
        ConfirmBox: {
          Title: "Účtenka již letí na Váš e-mail",
          Description:
            "Chcete příště platit jedním ťapnutím a mít všechny platby na jednom místě? Vytvořte si vlastní {{appName}} účet, bude to vcukuletu! 🚀",
          CreateAccountButton: "Vytvořit účet",
          CloseButton: "Zavřít",
        },
        TermsAgreement: {
          text: "Kliknutím na tlačítko zaplatit souhlasíte s",
          link: "{{apiUrl}}/content/terms/1-one-time-payment-docs.pdf",
          linkText: "Podmínkami AIS a PIS",
        },
        Steps: {
          detail: "Vítejte v {{appName}}",
          bank: "Připojení banky",
          account: "Platba s {{appName}}",
        },
        BankSelection: {
          InfoBox:
            'Vyberte si banku pro platbu přes {{appName}} podle našeho "Hodnocení bank".',
          WarningBox:
            "Upozornění: Kvalita připojení závisí na bankách. Pokud máte problém s přihlášením či platbou, kontaktujte svou banku.",
        },
        AccountSelection: {
          InfoBox:
            "Autorizujte platbu u vaší banky. Při problémech s autorizací kontaktujte svou banku.",
        },
      },
      NotificationsManagement: {
        NewNotification: "Nová notifikace",
        PlannedNotifications: "Plánované notifikace",
        SentNotifications: "Odeslané notifikace",
        DisabledNotifications: "Zrušené notifikace",
        NoNotifications: "Žádné notifikace",
      },
      NotificationForm: {
        Name: "Název",
        Description: "Popis",
        NotificationType: "Typ notifikace",
        Duration: {
          FromDate: "Datum zobrazení",
          FromTime: "Čas zobrazení",
          ToDate: "Datum skrytí",
          ToTime: "Čas skrytí",
        },
        DurationType: {
          Dismiss: "Dokud ji uživatel nezavře",
          Period: "Na určité časové období",
        },
        DurationPrompt: "Jak dlouho má zůstat notifikace zobrazena?",
        Filters: {
          Banks: "Pouze pro banky:",
          UserTypes: "Pouze pro uživatele:",
          BanksPlaceholder: "Žádný filtr bank",
          UserTypesPlaceholder: "Žádný filtr uživatelů",
        },
        Link: "Odkaz",
        Create: "VYTVOŘIT",
        Preview: "Náhled",
      },
    },
  },
  Sentry: {
    FormTitle: "Nahlásit chybu",
    NameLabel: "Jméno",
    EmailLabel: "E-mail",
    MessageLabel: "Popis chyby",
    MessageCharCount: "{{count}} / {{maxCount}}",
    CancelButtonLabel: "Zrušit",
    SubmitButtonLabel: "Odeslat",
    NamePlaceholder: "Vaše jméno",
    EmailPlaceholder: "Váš e-mail",
    MessagePlaceholder: "Popište chybu",
    SuccessMessageText: "Děkujeme za nahlášení chyby.",
    ErrorMessageText: "Hlášení se nepodařilo odeslat. Zkuste to prosím znovu.",
    Validation: {
      MessageRequired: "Popište prosím chybu.",
      MessageTooShort: "Popis musí mít alespoň {{minLength}} znaků.",
      EmailInvalid: "Zadejte platný e-mail.",
    },
  },
  Support: {
    ButtonLabel: "Podpora",
    Contact: {
      PhoneNumber: "+420 226 633 296",
      Email: "info@mo.one",
      HunterEmail: "info@legi.one",
    },
    Choice: {
      Title: "Napište nám",
      Description:
        "Prosím specifikujte svůj požadavek nebo problém co nejpřesněji, pomůže nám to vám odpovědět co nejdříve.",
      TechnicalProblemButton: "Technický problém",
      TechnicalProblemDescription:
        "Aplikace spadne, platba neprojde, stránka se nenačte. Míří na vývojáře.",
      TechnicalProblemUnavailable:
        "Hlášení chyb je momentálně nedostupné. Použijte prosím požadavek na podporu.",
      SupportRequestButton: "Požadavek na podporu",
      SupportRequestDescription:
        "Fakturace, účet, objednávky, jak něco funguje. Odpoví zákaznická podpora.",
      UrgentHelp: "Spěcháte?",
      CallPhone: "Volejte {{phoneNumber}}",
    },
    Request: {
      Title: "Požadavek na podporu",
      CategoryLabel: "Kategorie požadavku",
      CategoryPlaceholder: "Vyberte kategorii",
      SubjectLabel: "Název požadavku",
      DescriptionLabel: "Popis",
      DescriptionCharCount: "{{count}} / {{maxCount}}",
      AttachmentLabel: "Příloha",
      AttachmentPlaceholder: "Nahrát soubor",
      AttachmentRemove: "Odebrat přílohu",
      NameLabel: "Jméno a příjmení",
      EmailLabel: "E-mail",
      SubmitButton: "Odeslat",
      CancelButton: "Zrušit",
      Categories: {
        ClientOnboarding: "Onboarding klientů",
        CommissionsAndPayouts: "Provize a výplaty",
        ValorPoints: "Valor body",
        TechnicalIssues: "Technické potíže (přihlášení / appka)",
        StardustPoints: "Stardust body",
        PaymentIssues: "Problémy s platbou",
        AccountAndSignIn: "Přihlášení a správa účtu",
        TransactionComplaints: "Transakční reklamace",
        HardwareAndConnectivity: "Hardware a konektivita",
        FinanceAndSettlement: "Finance a vyúčtování",
        AccountAdministration: "Administrativa a správa účtu",
        Other: "Ostatní",
      },
      Validation: {
        CategoryRequired: "Vyberte kategorii požadavku.",
        SubjectRequired: "Zadejte název požadavku.",
        DescriptionRequired: "Zadejte popis požadavku.",
        DescriptionTooShort: "Popis musí mít alespoň {{minLength}} znaků.",
        NameRequired: "Zadejte jméno a příjmení.",
        EmailRequired: "Zadejte e-mail.",
        EmailInvalid: "Zadejte platný e-mail.",
        AttachmentTooLarge: "Soubor může mít nejvýše {{maxSizeMb}} MB.",
        AttachmentTypeNotSupported: "Podporované formáty jsou PNG, JPG a PDF.",
      },
      SuccessMessage: "Požadavek byl odeslán. Ozveme se vám co nejdříve.",
      ErrorMessage: "Požadavek se nepodařilo odeslat. Zkuste to prosím znovu.",
      RateLimitedMessage:
        "Odeslali jste příliš mnoho požadavků. Zkuste to prosím za chvíli.",
    },
    ContentReport: {
      Title: "Nahlásit obsah",
      PickerButton: "Nahlásit profil nebo zprávu",
      PickerDescription:
        "Profil nebo zpráva, které porušují zákon nebo naše podmínky. Posuzuje tým Mo.one podle nařízení o digitálních službách (DSA).",
      TargetProfile: "Nahlašujete profil {{user}}.",
      TargetMessage: "Nahlašujete zprávu od {{user}}.",
      HandleLabel: "Uživatelské jméno nahlašovaného profilu",
      HandlePlaceholder: "např. jan.novak",
      MessageHint:
        "Zprávu v chatu nahlásíte přímo u ní – otevřete nabídku zprávy a zvolte Nahlásit.",
      CategoryLabel: "Důvod nahlášení",
      CategoryPlaceholder: "Vyberte důvod",
      ExplanationLabel: "Odůvodnění",
      ExplanationHelper:
        "Popište co nejpřesněji, co je na obsahu špatně – co přesně obsahuje a pokud ho považujete za nezákonný, jaký zákon porušuje.",
      NameLabel: "Jméno a příjmení",
      EmailLabel: "E-mail",
      ContactOptionalNote:
        "U sexuálního zneužívání dětí můžete oznámení podat anonymně. Bez e-mailu vám ale nebudeme moci sdělit výsledek.",
      BonaFideLabel:
        "Prohlašuji, že informace a tvrzení v tomto oznámení jsou podle mého nejlepšího vědomí přesné a úplné.",
      LegalNote:
        "Potvrzení o přijetí a rozhodnutí vám zašleme e-mailem. Oznámení zpracováváme podle čl. 16 nařízení (EU) 2022/2065 (DSA).",
      SubmitButton: "Odeslat oznámení",
      CancelButton: "Zrušit",
      Categories: {
        ChildSexualAbuse: "Sexuální zneužívání dětí",
        ThreatsOrViolence: "Výhrůžky, násilí nebo terorismus",
        HateSpeech: "Nenávistné projevy",
        FraudOrScam: "Podvod nebo scam",
        Impersonation: "Vydávání se za někoho jiného",
        PersonalDataOrPrivacy: "Zneužití osobních údajů nebo soukromí",
        IntellectualProperty: "Porušení autorských práv nebo ochranné známky",
        OtherIllegal: "Jiný nezákonný obsah",
        HarassmentOrBullying: "Obtěžování nebo šikana",
        SpamOrUnwantedContact: "Spam nebo nevyžádaný kontakt",
        OtherTermsViolation: "Jiné porušení podmínek",
      },
      Validation: {
        CategoryRequired: "Vyberte důvod nahlášení.",
        HandleRequired: "Zadejte uživatelské jméno nahlašovaného profilu.",
        ExplanationRequired: "Zadejte odůvodnění.",
        ExplanationTooShort: "Odůvodnění musí mít alespoň {{minLength}} znaků.",
        NameRequired: "Zadejte jméno a příjmení.",
        EmailRequired: "Zadejte e-mail.",
        EmailInvalid: "Zadejte platný e-mail.",
        BonaFideRequired: "Bez tohoto prohlášení nelze oznámení odeslat.",
      },
      SuccessMessage:
        "Oznámení bylo přijato. Posoudíme ho bez zbytečného odkladu a o výsledku vás budeme informovat e-mailem.",
      SuccessMessageWithReference:
        "Oznámení bylo přijato pod číslem {{referenceNumber}}. Potvrzení jsme vám poslali e-mailem; o výsledku vás budeme informovat.",
      ErrorMessage: "Oznámení se nepodařilo odeslat. Zkuste to prosím znovu.",
      NotFoundMessage:
        "Tento profil jsme nenašli. Zkontrolujte uživatelské jméno.",
      SelfReportMessage: "Vlastní obsah nahlásit nelze.",
      RateLimitedMessage:
        "Odeslali jste příliš mnoho oznámení. Zkuste to prosím za chvíli.",
    },
    Result: {
      ErrorTitle: "Něco se nepovedlo",
    },
  },
  Employee: {
    EmployeeStatus: {
      Inactive: "Neaktivní",
      InvitedWaitingForConfirmation: "Pozvánka odeslána",
      Active: "Aktivní",
      Created: "Vytvořen",
    },
    Detail: {
      Title: "Detail zaměstnance",
      NoEmployeeSelectedError:
        "Chyba - Zaměstnanec není vybrán nebo neexistuje",
      EmployeeNotFoundError: "Chyba - Zaměstnanec neexistuje",
      SendAccess: "Poslat přístup",
      CancelInvitation: "Zrušit pozvánku",
      CancelInvitationConfirmText:
        "Pozvánka bude stažena a zaměstnanec ji už nebude moci přijmout. Novou pozvánku můžete poslat kdykoli.",
      RemoveEmployee: "Odebrat zaměstnance",
      RemoveEmployeeConfirmText:
        "Zaměstnanec ztratí přístup k vaší firmě a nebude se moci přepnout do zaměstnaneckého kontextu. Záznam zůstane v seznamu jako neaktivní a přístup mu můžete kdykoli poslat znovu.",
      RemovedInfo:
        "Zaměstnanec byl odebrán. Odesláním přístupu ho můžete pozvat znovu.",
      SaveError: "Při ukládání změn nastala chyba.",
      SaveSuccess: "Změny byly úspěšně uloženy.",
      AccessSent: "Přístup byl odeslán",
    },
    List: {
      LoadingError: "Seznam zaměstnanců se nepodařilo načíst.",
      AddEmployee: "Přidat zaměstnance",
      FilterLabels: {
        Created: "Vytvořen",
        InvitedWaitingForConfirmation: "Odeslán přístup",
        Active: "Aktivní",
        Inactive: "Neaktivní",
      },
    },
    Create: {
      Title: "Přidat zaměstnance",
      CreateButton: "Přidat zaměstnance",
      CreateError: "Při vytváření zaměstnance nastala chyba.",
      CreateSuccess: "Zaměstnanec byl vytvořen",
      MissingMerchantID: "Chyba - ID obchodníka není k dispozici.",
      Legend: "Nový zaměstnanec",
    },
    Dashboard: {
      Title: "Přehled",
    },
    KeypadPayment: {
      Title: "Platba na pokladně",
      ComingSoon: "Platbu připravujeme.",
    },
  },
  TransactionErrors: {
    UnknownError: "Při zpracování transakce se vyskytla neznámá chyba",
    UnknownPaymentError: "Neznámá chyba během platby",
    TransactionNotFound: "Transakce neexistuje nebo je nedostupná",
    BankTemporarilyUnavailable:
      "Banka je momentálně nedostupná, zkuste to prosím za chvíli znovu.",
    BankConnectionExpired:
      "Propojení s bankou vypršelo, propojte prosím účet znovu.",
    InsufficientBalance: "Nedostatečný zůstatek na účtu",
    BalanceVerificationFailed: "Nepodařilo se ověřit zůstatek na účtu",
    SameAccountError: "Účet odesílatele a příjemce nemůže být stejný",
    InvalidAccountCurrency: "Neplatná měna účtu",
    InvalidTransactionCurrency: "Neplatná měna transakce",
    TransactionTypeNotAllowed: "Transakce pro tento typ účtu není povolena",
    TransactionLimitExceeded: "Byl překročen limit transakcí",
    UnspecifiedError: "Nastala nespecifikovaná chyba.",
    TransactionProcessingFailed:
      "Transakci se nepodařilo zpracovat, nebo již byla uhrazena",
    UnspecifiedPaymentError: "Nastala nespecifikovaná chyba",
    BankAccount: "Není nastaven primární bankovní účet.",
    ActiveTransactionExists:
      "Na tomto paypointu již existuje aktivní transakce. Počkejte, až se dokončí, před iniciováním nové.",
    User: "{{appName}} Lite uživatelé mohou platby posílat pouze obchodníkům",
    InvalidBankAccountForReceivingPayment:
      "Vybraný bankovní účet nemůže přijímat platby",
    AuthLimitExceeded: "Překročen limit autorizací",
    InvalidJsonFormat: "Neplatný formát JSON",
    GeneralRejection: "Transakce byla zamítnuta",
    NotUniqueTransactionReference: "Neunikátní referenční číslo transakce",
    InvalidCharacterSet: "Neplatná znaková sada",
    InvalidAccountNumber: "Neplatné číslo účtu",
    FieldInvalid: "Hodnota pole je neplatná",
    FieldMissing: "Chybějící povinné pole",
    TransactionAmountForbidden: "Zakázaná výše částky transakce",
    AccountInvalid: "Účet příjemnce nebo odesílatele je neplatný",
    TransactionDecimalNumbersForbidden: "Nepovolený počet desetinných míst",
    InvalidDate: "Neplatný datum",
    TransactionInvalidIBAN: "Neplatný IBAN příjemce",
    InstantPaymentsNotAvailable: "Instantní platby nejsou dostupné",
    TransactionNotSignable: "Transakci nelze autorizovat",
    DebtorBankAccountForbidden:
      "Účet odesílatele není pro tuto transakci povolen.",
    PaymentLimitExceeded: "Platba se nezdařila – na účtu je překročen limit.",
    PaymentRejectedByBank: "Platba byla bankou zamítnuta.",
    PaymentCancelledByUser: "Platba nebyla v bance potvrzena.",
    PaymentExpired: "Platba nebyla dokončena včas a byla zrušena.",
    PaymentUnauthorized:
      "Banka platbu neautorizovala. Připojte účet znovu a zkuste to prosím ještě jednou.",
    PaymentTechnicalError:
      "Platba se nezdařila kvůli technické chybě. Zkuste to prosím znovu, případně kontaktujte podporu.",
    DebtorCreditorAccountIdentical: "Účet příjemce a plátce je totožný",
    TransactionLimits: {
      generatedTransactionLimitExceeded:
        "Generovaná platba přesahuje limit na 1 transakci.",
      oneTimeSendLimitExceeded: "Částka přesahuje limit na 1 transakci.",
      dailySendLimitExceeded: "Částka transakce přesahuje denní limit.",
      generatedDailySendLimitExceeded:
        "Částka generované transakce přesahuje denní limit.",
      monthlySendLimitExceeded:
        "Částka transakce přesahuje celkový měsíční limit.",
      generatedMonthlySendLimitExceeded:
        "Částka generované transakce přesahuje měsíční limit.",
      generatedTransactionLimitExceededIncompleteRegistration:
        "Generovaná platba přesahuje limit na 1 transakci. Prosím dokončete registraci.",
      oneTimeSendLimitExceededIncompleteRegistration:
        "Částka přesahuje limit na 1 transakci. Prosím dokončete registraci.",
      dailySendLimitExceededIncompleteRegistration:
        "Částka transakce přesahuje denní limit. Prosím dokončete registraci.",
      generatedDailySendLimitExceededIncompleteRegistration:
        "Částka generované transakce přesahuje denní limit. Prosím dokončete registraci.",
      monthlySendLimitExceededIncompleteRegistration:
        "Částka transakce přesahuje měsíční limit. Prosím dokončete registraci.",
      generatedMonthlySendLimitExceededIncompleteRegistration:
        "Částka generované transakce přesahuje měsíční limit. Prosím dokončete registraci.",
      oneTimeReceiveLimitExceededPreApproval:
        "Platba přesahuje limit na jednu platbu v rámci předschválení.",
      cumulativeReceiveLimitExceededPreApproval:
        "Platba by překročila celkový limit pro příjem v rámci předschválení. Vyšší částky budete moci přijímat, jakmile bude váš bankovní účet ověřen.",
      currencyNotSupportedPreApproval:
        "V rámci předschválení můžete přijímat platby pouze v CZK. Platby v jiných měnách budete moci přijímat, jakmile bude váš bankovní účet ověřen.",
      unspecifiedError: "Nastala nespecifikovaná chyba.",
    },
    TransactionNotFoundOrNotAccessible:
      "Transakce {{transactionPublicID}} neexistuje nebo není dostupná.",
    Status: "Transakce byla zrušena.",
    TransactionAlreadyCompleted: "Tato transakce již byla dokončena.",
    TransactionCancelled: "Tato transakce byla zrušena.",
    TransactionExpired:
      "Platnost platby vypršela. Požádejte příjemce o vystavení nové platby.",
  },
  Campaigns: {
    Campaign: {
      DefaultHeader: "Podpořte tuto kampaň",
      DefaultLearnMore: "Zjistit více",
      DonationForm: {
        AmountLabel: "Zadejte darovanou částku",
        AmountRequired: "Zadejte částku",
        AmountMin: "Částka musí být alespoň {{minAmount}} {{currencySymbol}}",
        SubmitButton: "Darovat",
        TransactionError:
          "Nepodařilo se vytvořit transakci. Zkuste to prosím znovu.",
      },
      Page: {
        Loading: "Načítání...",
        CampaignNotFound: "Kampaň nenalezena",
        CampaignNotFoundMessage:
          "Kampaň nebyla nalezena nebo již není k dispozici.",
        StatusNotStarted: "Kampaň ještě nezačala",
        StatusNotStartedWithDate:
          "Tato kampaň začne {{date}}. Vraťte se prosím později, abyste mohli darovat.",
        StatusNotStartedWithoutDate: "Tato kampaň ještě nezačala.",
        StatusFinished: "Kampaň skončila",
        StatusFinishedWithDate:
          "Tato kampaň skončila {{date}}. Děkujeme za váš zájem!",
        StatusFinishedWithoutDate:
          "Tato kampaň skončila. Děkujeme za váš zájem!",
        EndsOn: "Končí {{date}}",
        DonationsNotAvailable: "V tuto chvíli nelze poslat příspěvěk.",
      },
      CreateAccountButton: "VYTVOŘIT ÚČET NA JEDEN KLIK",
      InfoCards: {
        HelpingNeedy: {
          Title: "Pomáháme potřebným",
          Description:
            "Postupně přidáváme nadace, kterým s {{appName}} pomáháme.",
        },
        TestingPayment: {
          Title: "Testování platební metody",
          Description:
            "Pomůžete otestovat novou platební metodu české společnosti {{appName}}, která pomáhá udržet peníze v ČR.",
        },
        CreateAccountAndHelp: {
          Title: "Vytvořte si účet a pomáhejte",
          Description:
            "Vytvořte si účet, plaťte s {{appName}} a my za každou vaši platbu přispějeme na vámi vybranou organizaci.",
        },
      },
      TimelineSteps: {
        Donate: {
          Title: "Darujte libovolnou částku na vybranou organizaci",
        },
        JoinTeam: {
          Title: "Vytvoř si účet a přidej se do týmu {{campaignName}}!",
          Description:
            "Vytvořením účtu získáte možnost platit s {{appName}} a soutěžit v rámci soutěže Stardust a pomáhejte týmu {{campaignName}}.",
        },
        PayAtCafe: {
          Title: "Plaťte s {{appName}} ve vaší oblíbené Kavárně",
          Description: "ADD TEXT LATER",
        },
        AnyMethod: {
          Title: "Hotově, kartou? Jedině s {{appName}}!",
          Description: "ADD TEXT LATER",
        },
      },
    },
  },
  Raffle: {
    Notifications: {
      Title: "Slosování o ceny",
      Registration:
        "Získal/a jsi {{count}} losů do slosování za dokončení registrace.",
      Registration_one:
        "Získal/a jsi {{count}} los do slosování za dokončení registrace.",
      Registration_few:
        "Získal/a jsi {{count}} losy do slosování za dokončení registrace.",
      Registration_other:
        "Získal/a jsi {{count}} losů do slosování za dokončení registrace.",
      Referral:
        "Získal/a jsi {{count}} losů do slosování — tvůj pozvaný dokončil registraci.",
      Referral_one:
        "Získal/a jsi {{count}} los do slosování — tvůj pozvaný dokončil registraci.",
      Referral_few:
        "Získal/a jsi {{count}} losy do slosování — tvůj pozvaný dokončil registraci.",
      Referral_other:
        "Získal/a jsi {{count}} losů do slosování — tvůj pozvaný dokončil registraci.",
      Payment:
        "Získal/a jsi {{count}} losů do slosování za platbu u obchodníka.",
      Payment_one:
        "Získal/a jsi {{count}} los do slosování za platbu u obchodníka.",
      Payment_few:
        "Získal/a jsi {{count}} losy do slosování za platbu u obchodníka.",
      Payment_other:
        "Získal/a jsi {{count}} losů do slosování za platbu u obchodníka.",
    },
    Dashboard: {
      Title: "Slosování o ceny",
      TicketCount: "Tvoje losy",
      DrawDate: "Slosování",
      DateToBeAnnounced: "Datum bude upřesněno",
      ShowDetail: "Zobrazit detail",
      CompetitionsRunning: "Probíhá {{count}} soutěží",
      CompetitionsRunning_one: "Probíhá {{count}} soutěž",
      CompetitionsRunning_few: "Probíhají {{count}} soutěže",
      CompetitionsRunning_other: "Probíhá {{count}} soutěží",
    },
    Page: {
      Title: "Slosování",
      NotRunning: "Právě neprobíhá žádné slosování.",
      LoadError: "Slosování se nepodařilo načíst.",
      MainDraw: "Hlavní slosování",
      MyTickets: "Tvoje losy",
      MoveTickets: "Přesunout losy",
      DrawDate: "Datum slosování",
      Rewards: "Výhry",
      History: "Předchozí slosování",
      HistoryEmpty: "Zatím ses žádného slosování nezúčastnil/a.",
      HistoryTickets: "{{count}} losů",
      HistoryTickets_one: "{{count}} los",
      HistoryTickets_few: "{{count}} losy",
      HistoryTickets_other: "{{count}} losů",
      Drawn: "Vylosováno",
    },
    MoveDialog: {
      Title: "Přesunout losy",
      TargetLabel: "Do soutěže",
      CountLabel: "Počet losů",
      CountHelper: "Zadej počet od 1 do {{max}}",
      Submit: "Přesunout",
      MovedToast: "Přesunuto {{count}} losů",
      MovedToast_one: "Přesunut {{count}} los",
      MovedToast_few: "Přesunuty {{count}} losy",
      MovedToast_other: "Přesunuto {{count}} losů",
      MoveError: "Přesun losů se nepodařil",
      NothingMoved: "Nic se nepřesunulo — tvoje losy se mezitím změnily.",
      CompetitionsChanged:
        "Soutěže se mezitím změnily — nic se nepřesunulo. Zkontroluj aktuální stav.",
    },
  },
  Chat: {
    Title: "{{appName}} Chat",
    FindPeople: "Najít lidi",
    ReadBy: "Zobrazeno: {{count}}",
    SelectConversation: "Vyberte konverzaci",
    ClosedConversation: "Tato konverzace je uzavřená.",
    Unavailable: "Chat zatím není pro váš účet dostupný.",
    DisclosedNamesUnavailable:
      "Jména se nepodařilo načíst – někteří lidé se mohou zatím zobrazovat jen jako @handle.",
    BackToDashboard: "Zpět na {{appName}}",
    PushNotifications: {
      DeviceToggleLabel: "Upozornění na zprávy na tomto zařízení",
      DeviceToggleDescription:
        "Upozorníme vás na nové zprávy, i když je aplikace zavřená.",
      DeniedHint:
        "Oznámení pro {{appName}} jsou vypnutá. Zapnete je v nastavení systému.",
    },
    Thread: {
      Title: "Vlákno",
    },
    FindInConversation: {
      MenuItem: "Hledat v konverzaci",
      Placeholder: "Hledat v této konverzaci",
      Counter: "{{current}} z {{total}}",
      NoMatches: "Žádné shody",
      Older: "Starší shoda",
      Newer: "Novější shoda",
      Close: "Zavřít hledání",
      JumpError: "Na zprávu se nepodařilo přejít, zkuste to prosím znovu",
      SearchError: "Hledání se nezdařilo",
    },
    HandleGate: {
      Title: "Zvolte si přezdívku",
      Description: "Podle ní vás ostatní v Chatu najdou a mohou vám napsat.",
    },
    Reactions: {
      Title: "Reakce",
    },
    PhoneGate: {
      Title: "Ověření telefonního čísla",
      DescriptionVerify:
        "Pro používání chatu prosím ověřte své telefonní číslo. Pomáhá to chránit chat před spamem a falešnými účty.",
      DescriptionAdd:
        "Pro používání chatu prosím zadejte a ověřte své telefonní číslo. Pomáhá to chránit chat před spamem a falešnými účty.",
      PhoneLabel: "Telefonní číslo",
      SendCode: "Odeslat kód",
      CodeSent: "Kód odeslán na {{phone}}",
      Verify: "Ověřit",
      EditPhone: "Změnit telefonní číslo",
      ResendCode: "Odeslat znovu",
      SmsFailed: "Nepodařilo se odeslat ověřovací kód",
      TooManyAttempts: "Příliš mnoho pokusů, zkuste to prosím později",
      WrongCode: "Nesprávný kód. Vyžádejte si prosím nový.",
      VerifySuccess: "Telefonní číslo bylo úspěšně ověřeno",
    },
    Layout: {
      SearchPlaceholder: "Vyhledat...",
    },
    Categories: {
      All: "Vše",
      Mutual: "Vzájemní",
      Shopping: "Nákupy",
      Merchants: "Obchodníci",
      Groups: "Skupiny",
      Requests: "Žádosti",
    },
    NoChannels: "Zatím tu nic není",
    NoSearchResults: "Hledání neodpovídá žádná konverzace",
    NewChat: {
      Title: "Nová konverzace",
      DirectTitle: "Nový chat",
      CreateGroupWith: "Vytvořit skupinový chat s {{name}}",
      GroupTitle: "Nová skupinová konverzace",
      OpenError: "Konverzaci se nepodařilo otevřít. Zkuste to prosím znovu.",
      PrivateSenderNotice:
        "Váš profil je soukromý – osoba, které napíšete, uvidí vaše jméno.",
      RemoveMember: "Odebrat {{name}}",
      SearchPlaceholder: "Hledat podle @handle nebo jména",
      MembersLabel: "Členové",
      SuggestionsLabel: "Návrhy",
      ResultsLabel: "Výsledky hledání",
      EligibilityLabel: "Kdo se může připojit",
      EligibilityAnyone: "Kdokoli (Moone Lite i Full Moone)",
      EligibilityFullMooneOnly: "Pouze ověření uživatelé (Full Moone)",
      FullMooneOnlyBadge: "Pouze ověření uživatelé",
      CreateError: "Skupinu se nepodařilo vytvořit. Zkuste to prosím znovu.",
      CreateIneligibleMemberError:
        "Někdo z vybraných není ověřený uživatel (Full Moone) a do skupiny jen pro ověřené se nemůže připojit.",
      IneligibleSelectedWarning:
        "Zašedlí lidé nejsou ověření uživatelé (Full Moone) a do skupiny jen pro ověřené se nemohou připojit. Odeberte je, nebo povolte připojení komukoli.",
      CustomerSelectedWarning:
        "Zašedlí lidé jsou zákazníci. Obchodníci a hunteři nemohou zákazníky oslovit ani přidat do skupiny, nejdřív musí kontaktovat zákazník vás. Odeberte je, abyste mohli pokračovat.",
      GroupNameLabel: "Název skupiny",
      ChannelNamePlaceholder: "Název konverzace (volitelné)",
      NoResults: "Žádné výsledky",
      UnknownUser: "Neznámý uživatel",
      Cancel: "Zrušit",
      Create: "Vytvořit",
    },
    Members: {
      Title: "Členové",
      You: "Vy",
      AddTitle: "Přidat člena",
      Add: "Přidat",
      Cancel: "Zrušit",
      AddError: "Nepodařilo se přidat člena",
      Remove: "Odebrat",
      RemoveError: "Nepodařilo se odebrat člena",
      Owner: "Vlastník",
      AlreadyMember: "Už je členem",
      NotFullMoone: "Neověřený",
      CustomerWritesFirst: "Zákazník vás musí kontaktovat první",
      LeaveChannel: "Opustit kanál",
      LeaveConfirmTitle: "Opustit kanál?",
      LeaveConfirmMessage:
        "Opravdu chcete opustit tento kanál? Přestanete dostávat zprávy z této konverzace.",
      Leave: "Opustit",
      LeaveError: "Nepodařilo se opustit kanál",
    },
    Roles: {
      Customer: "Uživatel",
      Merchant: "Obchodník",
      Hunter: "Hunter",
      HunterPlus: "Hunter",
      Admin: "Administrátor",
      CustomerOnboarding: "Zákaznická podpora",
    },
    Rename: {
      Title: "Přejmenovat konverzaci",
      Save: "Uložit",
      Cancel: "Zrušit",
      Error: "Nepodařilo se přejmenovat konverzaci",
    },
    Requests: {
      Accept: "Přijmout",
      Reject: "Odmítnout",
      RequestMessage: "{{name}} s vámi chce chatovat",
      AcceptError: "Nepodařilo se přijmout žádost o chat",
      RejectError: "Nepodařilo se odmítnout žádost o chat",
      ShowRejected: "Odmítnuté pozvánky",
      ShowPending: "Zpět na žádosti",
      Join: "Připojit se",
      JoinError: "Nepodařilo se připojit ke kanálu",
      RejectedMessage: "Tuto pozvánku jste odmítli",
    },
    PaymentRequest: {
      Pending: "Čeká na platbu",
      Pay: "Zaplatit",
      Drawer: {
        Title: "Požadavek na platbu",
        BankAccount: "Bankovní účet",
        Amount: "Částka",
        Note: "Přidat poznámku",
        NotePlaceholder: "Text poznámky",
        Submit: "Odeslat požadavek",
        Error: "Nepodařilo se vytvořit požadavek",
        InvalidCurrency:
          "Vybraný účet je vedený v jiné měně, než ve které lze požadavek vytvořit",
        Validation: {
          SelectBankAccount: "Vyberte bankovní účet",
          EnterAmount: "Zadejte částku",
          AmountMustBePositive: "Částka musí být kladná",
        },
      },
    },
    DirectPayment: {
      Sent: "Odchozí platba",
      Received: "Příchozí platba",
      Drawer: {
        Title: "Přímá platba",
        BankAccount: "Bankovní účet",
        Amount: "Částka",
        Note: "Přidat poznámku",
        NotePlaceholder: "Text poznámky",
        Submit: "Odeslat platbu",
        Error: "Nepodařilo se odeslat platbu",
        RecipientNoPrimaryAccount:
          "Příjemce nemá aktivní primární bankovní účet",
        InvalidCurrency: "Účet příjemce je vedený v jiné měně",
        RecipientCurrencyNotSupported:
          "Příjemce zatím může přijímat platby pouze v CZK",
        RecipientLimitExceeded:
          "Příjemce by touto platbou překročil svůj limit pro přijímání plateb",
        NotChannelMember: "Platbu můžete poslat jen členovi této konverzace",
        MessageNotPosted:
          "Platba byla odeslána, ale nepodařilo se ji zveřejnit v konverzaci",
      },
    },
    MultiPayerRequest: {
      Description: "Požadavek na platbu pro všechny",
      ThreadTitle: "Skupinová platba",
      Pay: "Zaplatit",
      Close: "Uzavřít",
      CloseError: "Požadavek se nepodařilo uzavřít",
      Closed: "Uzavřeno",
      Unavailable: "Nedostupné",
      Payments: {
        Count: "{{count}} plateb",
        Count_one: "{{count}} platba",
        Count_few: "{{count}} platby",
        Count_other: "{{count}} plateb",
      },
      Drawer: {
        Title: "Požadavek na platbu",
        Amount: "Částka za osobu",
        Hint: "Každý člen skupiny může tuto částku zaplatit na váš hlavní účet, a to i opakovaně. Platby se zobrazí pod požadavkem.",
        Submit: "Odeslat požadavek",
        Error: "Požadavek se nepodařilo odeslat",
      },
    },
    PaymentMenu: {
      DirectPayment: "Odeslat platbu",
      PaymentRequest: "Zaplať mi",
      LiteRestriction:
        "Platby v chatu budou dostupné po dokončení Vaší registrace.",
      LiteBankRestriction:
        "Vaše osobní údaje a doklad totožnosti už máme. Platby v chatu budou dostupné po připojení a ověření Vašeho bankovního účtu.",
      LitePayUnavailable: "Pro zaplacení dokončete registraci",
      RecipientNotFullMoone:
        "Tento uživatel zatím nedokončil registraci, proto mu nelze poslat platbu.",
    },
    TransactionStatus: {
      Created: "Vytvořeno",
      Initiated: "Zahájeno",
      Processing: "Zpracování",
      Success: "Dokončeno",
      Fail: "Selhala",
      Cancelled: "Zrušeno",
      Unknown: "Neznámý",
    },
    Preview: {
      PaymentRequest: "Požadavek na platbu",
      DirectPayment: "Přímá platba",
    },
    PushCaption: {
      PaymentRequest: "Požadavek na platbu",
      DirectPaymentSent: "Odesláno",
    },
  },
  Admin: {
    Terminals: {
      PageTitle: "Terminály",
      Table: {
        SerialNumber: "Sériové číslo",
        Tid: "TID",
        Mid: "MID",
        HardwareModel: "Typ terminálu",
        Status: "Stav",
        Financing: "Financování",
        Hunter: "Hunter",
        Merchant: "Obchodník",
        Facility: "Provozovna",
        PurchasePrice: "Kupní cena",
        LastChangedAt: "Poslední změna",
        Ship: "Odeslat",
      },
      Status: {
        InStock: "Sklad",
        AssignedToHunter: "U Huntera",
        AssignedToMerchant: "Přiřazeno",
        Shipped: "Odesláno",
        WithMerchant: "U Obchodníka",
        Deployed: "Nasazený",
        Returned: "Vrácený",
      },
      Financing: {
        Moone: "Mo.one",
        Hunter: "Hunter",
      },
      Form: {
        SerialNumber: "Sériové číslo",
        HardwareModel: "Typ terminálu",
        PurchasePrice: "Kupní cena",
        Currency: "Měna",
        Status: "Stav",
        AddTitle: "Přidat terminál",
        Save: "Uložit",
        Cancel: "Zrušit",
        Delete: "Smazat",
      },
      AssignHunter: {
        HunterLabel: "Hunter",
        SearchHint: "Jméno, firma nebo e-mail",
        NoOptions: "Žádní hunteři nenalezeni",
      },
      Validation: {
        SerialNumberRequired: "Sériové číslo je povinné",
        HardwareModelRequired: "Typ terminálu je povinný",
      },
      Audit: {
        Title: "Historie změn",
        Empty: "Zatím žádné změny",
        When: "Kdy",
        Field: "Pole",
        Change: "Změna",
        Who: "Kdo",
      },
      Messages: {
        LoadError: "Nepodařilo se načíst terminály",
        UpdateSuccess: "Terminál byl uložen",
        CreateSuccess: "Terminál byl přidán",
        UpdateError: "Uložení terminálu se nezdařilo",
        DuplicateSerialNumber: "Terminál s tímto sériovým číslem už existuje",
        DeleteSuccess: "Terminál byl smazán",
        DeleteError: "Smazání terminálu se nezdařilo",
        DeleteConfirm:
          "Opravdu chcete smazat terminál {{serialNumber}}? Použijte jen pro záznamy, které vznikly omylem.",
        ShipSuccess: "Terminál byl označen jako odeslaný",
        ShipError: "Terminál se nepodařilo označit jako odeslaný",
      },
    },
    SsoClients: {
      PageTitle: "SSO aplikace",
      CreateButton: "Registrovat aplikaci",
      Table: {
        ClientId: "Client ID",
        DisplayName: "Název",
        Type: "Typ",
        Confidential: "S backendem",
        Public: "Veřejná (PKCE)",
        RedirectUris: "Redirect URI",
        AllowedRoles: "Smí jednat jako",
        AllowedScopes: "Oblasti API",
        Actions: "Akce",
        RotateSecret: "Vygenerovat nový secret",
        Delete: "Smazat",
      },
      Form: {
        CreateTitle: "Registrovat aplikaci",
        EditTitle: "Upravit aplikaci {{clientId}}",
        ClientId: "Client ID",
        DisplayName: "Název (zobrazí se uživateli při souhlasu)",
        IsConfidential: "Aplikace má vlastní backend (dostane client secret)",
        IsConfidentialHint:
          "Bez backendu (SPA, mobil) je aplikace veřejná: jen PKCE, bez secretu, nemůže jednat za uživatele. Typ nejde později změnit.",
        RedirectUris: "Redirect URI",
        RedirectUrisHint:
          "Přesná shoda, https (http jen pro localhost). Enter přidá další.",
        PostLogoutRedirectUris: "Redirect URI po odhlášení",
        AllowedRoles: "Role, za které smí jednat",
        AllowedRolesHint:
          "Prázdné = aplikace jen přihlašuje. S rolí dostane výměnu za kontextový token.",
        AllowedScopes: "Oblasti API (scopes)",
        AllowedScopesHint:
          "Co smí aplikace volat. Scopy „Aplikace: …“ jsou pro backend bez uživatele (client_credentials), ostatní pro jednání za přihlášeného uživatele. Prázdné = jen přihlášení a kontexty.",
        ListPlaceholder: "Napište hodnotu a stiskněte Enter",
        Submit: "Registrovat",
        Save: "Uložit",
        Cancel: "Zrušit",
      },
      Validation: {
        ClientIdInvalid: "3–64 znaků: malá písmena, číslice a pomlčky",
        DisplayNameRequired: "Název je povinný",
        RedirectUriRequired: "Alespoň jedna redirect URI je povinná",
        RedirectUriInvalid:
          "Redirect URI musí být absolutní https adresa bez fragmentu (http jen pro localhost)",
        ScopeRequiresRole:
          "Oblast API vyžaduje alespoň jednu roli, za kterou aplikace jedná",
      },
      Scopes: {
        Payments: "Platby (platební API)",
        Merchant: "Merchant (zaměstnanci, platební místa, PIN, firemní údaje)",
        Hunter: "Hunter (vlastní terminály, body, affiliate odkaz)",
        TerminalsManage: "Aplikace: sklad terminálů (čtení i zápis)",
        DirectoryRead:
          "Aplikace: seznamy uživatelů a hunterů, merchanti huntera",
        CouponsCreate: "Aplikace: vydávání kupónů",
        LoyaltyRead: "Aplikace: věrnostní program (období, žebříček)",
      },
      Secret: {
        Title: "Client secret pro {{clientId}}",
        Warning:
          "Secret se zobrazuje pouze teď. Uložte ho do trezoru hesel a předejte bezpečně; znovu ho nejde zobrazit, jen vygenerovat nový.",
        Label: "Client secret",
        Copy: "Kopírovat secret",
        Copied: "Zkopírováno!",
        Close: "Mám uloženo",
      },
      Messages: {
        LoadError: "Seznam aplikací se nepodařilo načíst",
        CreateSuccess: "Aplikace byla zaregistrována",
        CreateError: "Aplikaci se nepodařilo zaregistrovat",
        ClientIdTaken: "Toto Client ID už existuje",
        UpdateSuccess: "Aplikace byla uložena",
        UpdateError: "Aplikaci se nepodařilo uložit",
        DeleteConfirmTitle: "Smazat aplikaci",
        DeleteConfirm:
          "Opravdu smazat aplikaci {{clientId}}? Všechny její souhlasy a tokeny zaniknou, uživatelé budou z aplikace odhlášeni.",
        DeleteSuccess: "Aplikace byla smazána",
        DeleteError: "Aplikaci se nepodařilo smazat",
        RotateConfirmTitle: "Nový client secret",
        RotateConfirm:
          "Vygenerovat nový secret pro {{clientId}}? Starý přestane platit okamžitě, aplikace se bez nového nepřihlásí.",
        RotateError: "Nový secret se nepodařilo vygenerovat",
      },
    },
    Coupons: {
      PageTitle: "Slevové kupóny",
      CreateButton: "Vytvořit kupón",
      Table: {
        Code: "Kód",
        Region: "Země",
        Discount: "Sleva",
        DiscountType: "Typ slevy",
        Expiration: "Expirace",
        Usage: "Použito",
        Status: "Stav",
        Delete: "Smazat",
        CopyCode: "Kopírovat kód",
        CodeCopied: "Zkopírováno!",
      },
      Status: {
        Active: "Aktivní",
        Expired: "Vypršený",
        OutOfStock: "Vyčerpaný",
      },
      Form: {
        DialogTitle: "Vytvořit nový kupón",
        Code: "Kód kupónu",
        Region: "Země",
        AutoGenerate: "Vygenerovat kód automaticky",
        Discount: "Sleva",
        DiscountType: "Typ slevy",
        Percentage: "Procenta (%)",
        FixedAmount: "Pevná částka",
        Expiration: "Datum expirace",
        Stock: "Počet použití",
        StockHelp: "Minimum: {{min}} (již použito)",
        Submit: "Vytvořit",
        Save: "Uložit",
        Cancel: "Zrušit",
        EditTitle: "Upravit kupón",
        EditTitleWithCode: "Upravit kupón {{code}}",
      },
      Validation: {
        CodeRequired: "Kód kupónu je povinný",
        DiscountRequired: "Sleva je povinná",
        DiscountPositive: "Sleva musí být kladná",
        DiscountMax100: "Procentuální sleva nesmí překročit 100 %",
        ExpirationRequired: "Datum expirace je povinné",
        StockRequired: "Počet použití je povinný",
        StockMin: "Počet použití musí být alespoň 1",
      },
      Messages: {
        CreateSuccess: "Kupón byl vytvořen",
        CreateError: "Nepodařilo se vytvořit kupón",
        LoadError: "Chyba při načítání kupónů",
        DeleteSuccess: "Kupón byl smazán",
        DeleteError: "Nepodařilo se smazat kupón",
        DeleteConfirmTitle: "Smazat kupón",
        DeleteConfirm: "Opravdu chcete smazat kupón {{code}}?",
        UpdateSuccess: "Kupón byl upraven",
        UpdateError: "Nepodařilo se upravit kupón",
      },
    },
    Raffle: {
      PageTitle: "Slosování",
      CreateButton: "Nové kolo",
      Table: {
        Region: "Trh",
        Name: "Název",
        Type: "Typ",
        TypeDefault: "Hlavní kolo",
        TypeCompetition: "Soutěž",
        Status: "Stav",
        DrawDate: "Datum slosování",
        Tickets: "Losy",
        Participants: "Účastníci",
        Checksum: "Otisk podkladu pro losování (SHA-256)",
        ChecksumHelp:
          "Vznikl při uzavření kola z vygenerovaného seznamu čísel (bez údajů o držitelích). Stažený podklad se proti němu ověřuje a stejný otisk patří do zápisu o losování — dokazuje, že se losovalo nad souborem, který vytvořil systém.",
        ChecksumCopied: "Otisk zkopírován",
        AllocationChecksum: "Otisk přidělení čísel (SHA-256)",
        AllocationChecksumHelp:
          "Vznikl při uzavření kola a zapečeťuje, kdo drží která čísla. Patří do zápisu o losování vedle otisku podkladu. Dohledání výherce ho pokaždé ověřuje — pokud přidělení přestane otisku odpovídat, dohledání odmítne odpovědět.",
        AllocationChecksumCopied: "Otisk zkopírován",
        Empty: "Zatím žádná kola — první kolo spustí sbírání losů.",
        Unscheduled: "Bez data slosování",
      },
      Status: {
        Draft: "Rozpracované",
        Announced: "Vyhlášené",
        Closed: "Uzavřené",
        Drawn: "Vylosované",
        Cancelled: "Zrušené",
      },
      Actions: {
        Edit: "Upravit",
        View: "Zobrazit detail",
        Announce: "Vyhlásit",
        Close: "Uzavřít",
        Complete: "Označit vylosováno",
        Export: "Stáhnout podklad",
        FindHolder: "Dohledat výherce",
        Cancel: "Zrušit soutěž",
        SetDefault: "Nastavit jako hlavní kolo",
      },
      Form: {
        CreateTitle: "Nové slosovací kolo",
        EditTitle: "Upravit kolo",
        Region: "Trh",
        Name: "Název kola",
        DrawDate: "Datum slosování",
        Rewards: "Výhry",
        AddReward: "Přidat výhru",
        RewardTitle: "Název výhry",
        RewardDescription: "Popis",
        RewardQuantity: "Počet kusů",
        RemoveReward: "Odebrat",
        Submit: "Uložit",
        Cancel: "Zrušit",
        MainRoundWarning:
          "Na tomto trhu zatím neběží žádné hlavní kolo. Toto kolo se stane hlavním kolem trhu a hned do něj začnou přibývat losy. Hlavní kolo nelze zrušit.",
      },
      Validation: {
        NameRequired: "Zadejte název kola",
        RewardTitleRequired: "Zadejte název výhry",
        RegionRequired: "Vyberte trh",
        RewardQuantityInvalid: "Počet výher musí být celé nezáporné číslo",
        TicketNumberInvalid: "Zadejte kladné celé číslo losu",
        TicketNumberRange: "Zadejte číslo losu od 1 do {{max}}",
      },
      Messages: {
        LoadError: "Slosovací kola se nepodařilo načíst",
        CreateSuccess: "Kolo bylo založeno",
        CreateError: "Kolo se nepodařilo založit",
        UpdateSuccess: "Kolo bylo uloženo",
        UpdateError: "Kolo se nepodařilo uložit",
        UpdateConflict:
          "Kolo mezitím někdo vyhlásil nebo zrušil, upravit už nejde.",
        AnnounceSuccess: "Kolo bylo vyhlášeno",
        AnnounceError: "Kolo se nepodařilo vyhlásit",
        AnnounceConfirmTitle: "Vyhlásit kolo „{{name}}“ ({{region}})?",
        AnnounceConfirm:
          "Vyhlášením se datum slosování a seznam výher stávají veřejným příslibem a už je nepůjde změnit. Změny budou možné jen pro příští kolo.",
        AnnounceRequirements:
          "Před vyhlášením doplň budoucí datum slosování, alespoň jednu výhru a vlastní název kola",
        CloseSuccess: "Kolo bylo uzavřeno",
        CloseError: "Kolo se nepodařilo uzavřít",
        CloseConfirmTitle: "Uzavřít kolo „{{name}}“ ({{region}})?",
        CloseConfirm:
          "Uzavření je nevratné: losům se přidělí čísla, vytvoří se podklad pro slosování a sbírání pokračuje do dalšího kola. Losy získané po uzavření patří do dalšího kola.",
        CloseCompetitionConfirm:
          "Uzavření je nevratné: losům se přidělí čísla a vytvoří se podklad pro slosování.",
        CompleteSuccess: "Kolo je označené jako vylosované",
        CompleteError: "Kolo se nepodařilo označit",
        CompleteConfirmTitle:
          "Označit kolo „{{name}}“ ({{region}}) jako vylosované?",
        CompleteConfirm:
          "Potvrzuješ, že proběhlo slosování podle dokumentovaného procesu a výsledek je zapsaný.",
        CancelSuccess: "Soutěž byla zrušena",
        CancelError: "Soutěž se nepodařilo zrušit",
        CancelConfirmTitle: "Zrušit soutěž „{{name}}“ ({{region}})?",
        CancelConfirm:
          "Rozpracovaná soutěž bude zrušena a zůstane v evidenci jako zrušená. Vyhlášenou soutěž zrušit nelze.",
        SetDefaultSuccess: "Kolo je nyní hlavním kolem trhu",
        SetDefaultError: "Hlavní kolo se nepodařilo nastavit",
        SetDefaultConfirmTitle:
          "Nastavit kolo „{{name}}“ ({{region}}) jako hlavní?",
        SetDefaultConfirm:
          "Nové losy se od teď budou připisovat do tohoto kola. Dosavadní hlavní kolo se stane běžnou soutěží: pokud už bylo vyhlášené, losy v něm zůstávají; nevyhlášené (rozpracované) kolo své losy předá novému hlavnímu kolu.",
        ExportError: "Podklad se nepodařilo stáhnout",
        ExportIntegrityError:
          "Podklad neprošel kontrolou integrity — nelosuj z něj a kontaktuj vývoj.",
      },
      HolderLookup: {
        Title: "Dohledání výherce",
        TicketNumber: "Číslo losu",
        Search: "Dohledat",
        HolderName: "Držitel",
        Email: "E-mail",
        TicketCount: "Počet losů v kole",
        Range: "Rozsah čísel",
        NotFound: "Číslo losu se nepodařilo dohledat",
        SealMismatch:
          "Přidělení čísel neodpovídá stavu při uzavření kola — dohledání bylo odmítnuto. Kontaktuj vývoj.",
        Error: "Dohledání se nepodařilo — zkus to znovu",
      },
    },
    Campaigns: {
      PageTitle: "Administrace kampaní",
      CreatePageTitle: "Vytvořit kampaň",
      CreateButton: "Vytvořit novou kampaň",
      DraftCampaigns: "Koncepty",
      PublishedCampaigns: "Publikované kampaně",
      ArchivedCampaigns: "Archivované kampaně",

      Table: {
        CampaignName: "Název kampaně",
        Code: "Kód",
        Receiver: "Příjemce",
        Affiliate: "Affiliate",
        Status: "Stav",
        StatusOnRestore: "Stav po obnovení",
        StartDate: "Záčatek",
        EndDate: "Konec",
        Created: "Vytvořeno",
        Deleted: "Smazáno",
        Actions: "Akce",
        Unlimited: "Neomezeno",
        Enabled: "Povoleno",
        Disabled: "Zakázáno",
        NoReceiverAssigned: "Nepřiřazen příjemce",
        ViewCampaign: "Zobrazit kampaň",
        Edit: "Upravit",
        Delete: "Smazat",
        Restore: "Obnovit",
        CopyUrl: "Kopírovat URL kampaně",
        UrlCopied: "URL zkopírována",
      },

      Status: {
        Draft: "Koncept",
        DraftDescription: "Tato kampaň je v konceptu",
        Archived: "Archivováno",
        ArchivedDescription: "Tato kampaň je archivována",
        ActiveUnlimited: "Aktivní (Neomezená)",
        UnlimitedDescription: "Tato kampaň běží neomezeně",
        StartsToday: "Začíná dnes",
        StartsTomorrow: "Začíná zítra",
        StartsInDays: "Začíná za {{days}} dní",
        StartsOn: "Začíná {{date}}",
        Finished: "Ukončena",
        EndedOn: "Skončila {{date}}",
        EndsToday: "Končí dnes",
        DayLeft: "Zbývá 1 den",
        DaysLeft: "Zbývá {{days}} dní",
        EndsOn: "Končí {{date}}",
        Active: "Aktivní",
        CurrentlyRunning: "Právě běží",
        NotStarted: "Plánovaná",
      },

      Form: {
        BasicInformation: "Základní informace",
        CampaignName: "Název kampaně",
        CampaignNamePlaceholder: "např. Nadace Help Pes",
        CampaignCode: "Kód kampaně (URL cesta)",
        CampaignCodePlaceholder: "např. nadace-help-pes",
        CampaignCodeHelperCreate:
          "Používejte pouze malá písmena bez diakritiky, číslice a pomlčky.",
        CampaignCodeHelperEdit: "Kód nelze po vytvoření změnit",
        Description: "Popis",
        DescriptionPlaceholder:
          "Vyzkoušejte si platbu přes Moone a pomozte vycvičit dalšího asistenčního pejska pro osoby s nejrůznějšími druhy handicapů.",
        DescriptionCharCount: "{{count}}/500",
        EnableAffiliateProgram: "Povolit affiliate program",

        CampaignValidity: "Platnost kampaně",
        DateModeUnlimited: "Neomezená",
        DateModeUnlimitedDescription: "Kampaň nemá počáteční ani koncové datum",
        DateModeFromTo: "Od - Do",
        DateModeFromToDescription: "Kampaň běží mezi konkrétními daty",
        StartDate: "Datum začátku",
        EndDate: "Datum konce",
        UnlimitedDateInfo:
          "Tato kampaň poběží neomezeně bez počátečního či koncového data.",

        PaymentReceiver: "Příjemce platby",
        PaymentReceiverDescription:
          "Vyberte uživatele obchodníka, který bude přijímat platby z této kampaně",
        MerchantUser: "Obchodník",

        CampaignContent: "Úvodní stránka kampaně",
        HeaderTitle: "Hlavní nadpis",
        HeaderTitlePlaceholder: "např. Podpořte výcvik asistenčních psů",
        FoundationLinkName: "Název odkazu nadace",
        FoundationLinkNamePlaceholder: "např. Více informací",
        FoundationLinkNameHelper: "Text odkazu na web nadace",
        FoundationLinkUrl: "URL odkazu nadace",
        FoundationLinkUrlPlaceholder: "https://example.org",
        FoundationLinkUrlHelper: "URL na web nadace",
        SuccessfulPaymentText: "Poděkování po úspěšné platbě",
        SuccessfulPaymentTextPlaceholder: "Děkujeme za Váš příspěvek!",
        SuccessfulPaymentTextHelper:
          "Text zobrazený po úspěšné platbě ({{count}}/1000)",

        ThankYouSection: "Poděkování po úspěšné platbě",
        Color: "Barva kampaně",
        ColorHelp:
          "Primární barva kampaně (hex formát, např. #FF9400). Ponechte prázdné pro výchozí barvu motivu.",
        PaymentInstructionsText: "Pokyny k platbě",
        PaymentInstructionsTextHelper:
          "Text zobrazený v kroku časové osy 'Zaplaťte v kavárně'. Popisuje, jak platby pomáhají kampani. Max 500 znaků.",
        OnlyWithMooneText: "Text Jedině s {{appName}}",
        OnlyWithMooneTextHelper:
          "Text zobrazený v kroku časové osy 'Jedině s {{appName}}'. Propaguje používání {{appName}} pro platby. Max 500 znaků.",

        Images: "Obrázky",
        Logo: "Logo",
        LogoHelper: "Logo kampaně (PNG/SVG)",
        LandingImage: "Úvodní obrázek",
        LandingImageHelper: "Náhledový obrázek úvodní stránky (PNG/JPG)",
        Icon: "Ikona (volitelné)",
        IconHelper: "Ikona kampaně (PNG/SVG)",
        ThankYouImage: "Obrázek úspěšné platby",
        ThankYouImageHelper: "Obrázek zobrazený po úspěšné platbě",
        ImageUploadSuccess: "Obrázek byl nahrán",
        ImageUploadError: "Nahrání obrázku se nezdařilo",
        UploadError: {
          invalidFileType:
            "Nepodporovaný typ souboru. Povolené formáty: PNG, JPEG, SVG.",
          fileSizeExceeded: "Soubor je příliš velký.",
          fileContentMismatch: "Obsah souboru neodpovídá typu souboru.",
        },

        StepBasicInfo: "Základní informace",
        StepLandingPage: "Úvodní stránka",
        StepThankYouPage: "Děkovací stránka",
        StepValidity: "Platnost",
        PreviewCampaignPage: "Náhled stránky kampaně",
        PreviewThankYouPage: "Náhled děkovací stránky",
        ImageDeleteSuccess: "Obrázek byl smazán",
        ImageDeleteError: "Smazání obrázku se nezdařilo",
        CreateButton: "Vytvořit kampaň",
        UpdateButton: "Aktualizovat kampaň",
        UpdateLandingPageButton: "Aktualizovat úvodní stránku",
        UpdateThankYouPageButton: "Aktualizovat děkovací stránku",
        NextStepButton: "Další krok",
        PreviousStepButton: "Předchozí krok",
        SaveChangesButton: "Uložit změny",
        SaveButton: "Uložit",
        CloseButton: "Zavřít",
        PublishButton: "Publikovat",
        PublishRequiresReceiver:
          "Pro publikování kampaně je nutné vybrat příjemce plateb.",
        ArchiveButton: "Archivovat",
        UnpublishButton: "Vrátit do konceptu",
        CampaignIsLive: "Kampaň je publikována",
        Validation: {
          NameRequired: "Název kampaně je povinný",
          CodeRequired: "Kód kampaně je povinný",
          CodeInvalidFormat:
            "Kód musí obsahovat pouze malá písmena, čísla a pomlčky. Speciální znaky nejsou povoleny.",
          DescriptionRequired: "Popis je povinný",
          InvalidUrl: "Musí být platná URL adresa",
          InvalidColor:
            "Musí být platná barva v hex formátu (např. #FF9400 nebo #FF940080)",
          MaxLength: "Maximální délka je {{max}} znaků",
          DateRangeRequired:
            "Počáteční a koncové datum jsou povinné při výběru rozsahu datumů",
          EndDateAfterStartDate:
            "Koncové datum musí být po nebo stejné jako počáteční datum",
        },
        PaymentInstructionsTextPlaceholder:
          "Zaplaťte za kafe s Mo.one. My za vás přispejeme na na další večeři pro asistenčního psa.",
        OnlyWithMooneTextPlaceholder:
          "Kdekoliv zaplatíte s Mo.one, my posíláme peníze na podporu výcviku dalšího asistenčního psa. Choďte a vyžadujte platbu jedině s Mo.one. Stačí začít si vytvořit účet zdarma. Haf!",
      },

      Messages: {
        CreateSuccess: "Kampaň byla úspěšně vytvořena! URL: /campaign/{{code}}",
        CreateError: "Nepodařilo se vytvořit kampaň",
        UpdateSuccess: "Kampaň byla úspěšně aktualizována!",
        UpdateError: "Nepodařilo se aktualizovat kampaň",
        PublishSuccess: "Kampaň byla publikována",
        ArchiveSuccess: "Kampaň byla archivována",
        UnpublishSuccess: "Kampaň byla vrácena do konceptu",
        CodeExistsError: "Kód kampaně již existuje nebo je neplatný",
        DeleteConfirm: "Opravdu chcete smazat tuto kampaň?",
        DeleteSuccess: "Kampaň byla úspěšně smazána",
        DeleteError: "Nepodařilo se smazat kampaň",
        RestoreConfirm: "Opravdu chcete obnovit tuto kampaň?",
        RestoreSuccess: "Kampaň byla úspěšně obnovena",
        RestoreError: "Nepodařilo se obnovit kampaň",
        LoadCampaignsError: "Nepodařilo se načíst kampaně",
        EditCampaignTitle: "Upravit kampaň: {{name}}",
      },
    },
    SettlementPoolBoosts: {
      StardustBoost: "Stardust Boost",
      ValorBoost: "Valor Boost",
      Regions: {
        CZ: "Česko",
        SK: "Slovensko",
      },
      BoostAmount: "Boost částka ({{currency}})",
      DistributionRatio: "Poměr rozdělení",
      HunterPoolRatio: "Licence",
      ValorPoolRatio: "Valor body",
      CurrentPoolTotal: "Aktuální pool celkem ({{currency}})",
      PoolTotalLoadError: "Nepodařilo se načíst aktuální pool",
      SaveButton: "Uložit",
      SaveSuccess: "Boost byl úspěšně aktualizován",
      LoadingError: "Nepodařilo se načíst nastavení boostů",
      Validation: {
        BoostAmountNonNegative: "Částka boostu nemůže být záporná",
        RatioSumMustBe100: "Součet poměrů musí být 100",
      },
    },
    VatStatusRefresh: {
      Title: "Registry DPH",
      Description:
        "Znovu ověří stav registrace k DPH všech firem a OSVČ v registrech (CZ: Registr plátců DPH, SK: VIES). Běží na pozadí, výsledek je v logu Workeru.",
      Button: "Aktualizovat stav DPH",
      Loading: "Spouštím...",
      Success: "Aktualizace stavu DPH byla spuštěna.",
      Error: "Aktualizaci stavu DPH se nepodařilo spustit.",
    },
    PaymentSimulation: {
      Title: "Simulace zaplacení (sandbox)",
      Description:
        "Označí sandbox platbu jako zaplacenou, jako by banka vrátila stav „zaplaceno“. Jen pro transakce typu Platba se sandbox bankou ve stavu Zahájeno, Zpracovává se nebo Vyžaduje prošetření. Dostupné pouze na testovacím a staging prostředí.",
      PublicIDLabel: "Kód transakce",
      Button: "Označit jako zaplacenou",
      Loading: "Označuji...",
      ConfirmTitle: "Simulovat zaplacení?",
      ConfirmText:
        "Transakce {{publicID}} bude označena jako zaplacená. Spustí se stejné následné kroky jako u skutečné platby (notifikace, webhook, vyúčtování).",
      Success: "Transakce {{publicID}} je označena jako zaplacená.",
      Errors: {
        NotFound:
          "Transakce nebyla nalezena, nebo je simulace na tomto prostředí vypnutá.",
        Forbidden: "Simulaci může spustit jen administrátor.",
        NotPayment: "Simulovat lze jen transakce typu Platba.",
        NotSandbox:
          "Transakce nemá sandbox platbu. Nejdřív ji zaplaťte sandbox bankou.",
        StatusNotAllowed:
          "Transakce není ve stavu, ze kterého lze zaplacení simulovat.",
        Generic: "Simulaci zaplacení se nepodařilo provést.",
      },
    },
  },
  Notifications: {
    Variants: {
      Critical: "Kritické upozornění",
      Error: "Chyba",
      Announcement: "Oznámení",
      Completed: "Dokončeno",
      Stardust: "Stardust/Valor",
      Raffle: "Slosování",
    },
  },
  UserMenu: {
    ManageAccount: "Spravovat účet {{appName}}",
    MooneLiteInfo:
      "Pokud byste byli zaregistrovaní, tak {{appName}} platí za to, že platíte.",
    Invitations: "Pozvánky",
    Logout: "Odhlásit se",
    Rewards: {
      TotalRewards: "Celkové odměny",
      TotalStardust: "Stardust celkem",
      TotalValor: "Valor celkem",
      MyShare: "Můj podíl",
      OpenRewardsDetails: "Otevřít detaily odměny",
    },
    Notifications: {
      Title: "Notifikace",
      NoNewNotifications: "Žádné nové notifikace",
      NoNotifications: "Žádné notifikace",
      Today: "Dnes",
      Yesterday: "Včera",
      Older: "Starší",
      ShowAll: "Všechny notifikace",
      DeleteAll: "Smazat vše",
    },
  },
  Devices: {
    List: {
      LoadingError: "Chyba při načítání zařízení",
      Name: "Název",
      PayPoint: "Paypoint",
      DateCreated: "Vytvořeno",
      LastUsedAt: "Naposledy použito",
      RevokeConfirm: "Opravdu chcete odpojit toto zařízení?",
      RevokeSuccess: "Zařízení bylo odpojeno",
      RevokeError: "Odpojení zařízení se nezdařilo",
      RegenerateConfirm:
        "Opravdu chcete vygenerovat nový klíč? Stávající klíč přestane fungovat.",
      RegenerateSuccess: "Nový klíč byl vygenerován",
      RegenerateError: "Vygenerování nového klíče se nezdařilo",
      NewDeviceSecret: "Nový klíč zařízení",
      CopyDeviceSecret: "Zkopírovat klíč",
      DeviceSecretCopied: "Klíč byl zkopírován do schránky",
      AddDevice: "Přidat zařízení",
      DeviceName: "Název zařízení",
      SelectPayPoint: "Vyberte paypoint",
      LinkSuccess: "Zařízení bylo připojeno",
      LinkError: "Připojení zařízení se nezdařilo",
      NoTerminalPayPoints:
        "Nemáte žádný volný terminálový paypoint. Nejprve vytvořte paypoint typu Terminál.",
      DeviceSecretWarning:
        "Tento klíč se zobrazí pouze jednou. Zkopírujte ho a bezpečně uložte — později ho nebude možné znovu získat.",
    },
  },
  PaymentGateways: {
    Legend: "Platební brána",
    Description:
      "Přístupové údaje pro integraci platební brány Mo.one do vašeho e-shopu. Client secret se zobrazí pouze jednou při vygenerování.",
    ClientID: "Client ID",
    CopyClientID: "Zkopírovat Client ID",
    ClientIDCopied: "Client ID bylo zkopírováno",
    LastUsedAt: "Naposledy použito",
    NoCredential: "Přístupové údaje zatím nebyly vygenerovány.",
    Generate: "Vygenerovat přístupové údaje",
    Regenerate: "Nový client secret",
    Revoke: "Zrušit přístupové údaje",
    Secret: {
      CreatedTitle: "Přístupové údaje vytvořeny",
      RegeneratedTitle: "Nový client secret vygenerován",
      Warning:
        "Client secret se zobrazí pouze jednou. Zkopírujte ho a bezpečně uložte — později ho nebude možné znovu získat.",
      ClientID: "Client ID",
      ClientSecret: "Client secret",
      Copied: "Zkopírováno do schránky",
      Close: "Zavřít",
    },
    Messages: {
      GenerateError: "Vygenerování přístupových údajů se nezdařilo",
      RegenerateConfirmTitle: "Vygenerovat nový client secret",
      RegenerateConfirm:
        "Opravdu chcete vygenerovat nový client secret? Stávající okamžitě přestane fungovat a je nutné ho aktualizovat v e-shopu.",
      RegenerateError: "Vygenerování nového client secretu se nezdařilo",
      RevokeConfirmTitle: "Zrušit přístupové údaje",
      RevokeConfirm:
        "Opravdu chcete zrušit přístupové údaje? E-shop okamžitě přestane přijímat platby, dokud nevygenerujete nové.",
      RevokeSuccess: "Přístupové údaje byly zrušeny",
      RevokeError: "Zrušení přístupových údajů se nezdařilo",
    },
  },
  TerminalPin: {
    Title: "PIN pro terminál",
    Description:
      "Tento čtyřmístný PIN zadáte na terminálu při přihlášení. Slouží k identifikaci, kdo terminál obsluhuje.",
    NoPinYet:
      "PIN ještě nemáte přidělený. Bude vygenerován, jakmile vás merchant přiřadí na terminálový paypoint.",
    Reveal: "Zobrazit",
    Hide: "Skrýt",
    Regenerate: "Vygenerovat nový PIN",
    RegenerateConfirm:
      "Opravdu chcete vygenerovat nový PIN? Stávající PIN přestane fungovat.",
    RegenerateSuccess: "Nový PIN byl vygenerován",
    RegenerateError: "Vygenerování nového PINu se nezdařilo",
  },
  UserSettings: {
    BalanceVisibility: {
      Title: "Zobrazení zůstatku",
      Label: "Zobrazovat zůstatek na hlavní obrazovce",
      Description:
        "Pokud je vypnuto, zůstatek je skrytý a zobrazí se až po kliknutí na ikonu oka.",
    },
    QuickPayment: {
      Title: "Rychlá platba",
    },
  },
  Sso: {
    Consent: {
      Intro: "Aplikace {{app}} žádá o přístup k vašemu účtu {{appName}}.",
      PermissionsHeading: "Aplikace získá:",
      RevokeHint:
        "Přístup můžete kdykoli odebrat v nastavení v sekci Připojené aplikace.",
      Allow: "Povolit",
      Deny: "Zamítnout",
      Redirecting: "Pokračujeme do aplikace…",
      ReauthTitle: "Přihlaste se znovu",
      ReauthText:
        "Aplikace {{app}} vyžaduje čerstvé přihlášení. Po opětovném přihlášení budete pokračovat zpět sem.",
      ReauthButton: "Přihlásit se znovu",
      SignedInAs: "Přihlášeni jako {{who}}",
      UseAnotherAccount: "Použít jiný účet",
      MissingRequest:
        "Chybí identifikace požadavku o přihlášení. Začněte prosím znovu z aplikace, do které se přihlašujete.",
    },
    ConnectedApps: {
      Empty: "Zatím jste se přes {{appName}} nepřihlásili do žádné aplikace.",
      ConnectedAt: "Připojeno {{date}}",
      Disconnect: "Odpojit",
      DisconnectConfirmTitle: "Odpojit aplikaci",
      DisconnectConfirm:
        "Aplikace {{app}} ztratí přístup k vašemu účtu. Při příštím přihlášení vás znovu požádá o souhlas.",
      DisconnectSuccess: "Aplikace byla odpojena.",
      DisconnectError: "Aplikaci se nepodařilo odpojit.",
      LoadError: "Připojené aplikace se nepodařilo načíst.",
    },
    Scopes: {
      OpenId: "Přihlášení",
      Profile: "Vaše jméno",
      Email: "Vaši e-mailovou adresu",
      OfflineAccess: "Zůstat přihlášeni (bez opakovaného přihlašování)",
      Contexts: "Jednat za vaše role v {{appName}}",
      Payments: "Přijímat platby za vaši firmu",
      Merchant: "Spravovat zaměstnance, platební místa a PINy vaší firmy",
      Hunter: "Vaše terminály, body a affiliate odkaz",
      TerminalsManage: "Sklad terminálů",
      DirectoryRead: "Seznamy uživatelů a hunterů",
      CouponsCreate: "Vydávání kupónů",
      LoyaltyRead: "Věrnostní program",
    },
    Errors: {
      RequestNotFound:
        "Požadavek o přihlášení neexistuje. Začněte prosím znovu z aplikace.",
      RequestExpired:
        "Požadavek o přihlášení vypršel. Začněte prosím znovu z aplikace.",
      RequestNotPending:
        "Tento požadavek už byl vyřízen. Začněte prosím znovu z aplikace.",
      IdentityRequired:
        "Váš účet je potřeba nejdřív dokončit. Přihlaste se do {{appName}} a zkuste to znovu.",
      IdentityNotActive:
        "Váš účet není aktivní, přihlášení do aplikací není možné.",
      BackOfficeNotAllowed:
        "Administrátorským účtem se do partnerských aplikací přihlásit nelze.",
      ConsentNotFound: "Souhlas už neplatí. Začněte prosím znovu z aplikace.",
      ClientNotFound: "Aplikace není registrovaná.",
      Unknown: "Přihlášení do aplikace se nepodařilo.",
    },
  },
  Beta: {
    Badge: "Beta",
    RoadmapUrl: "https://mo.one/roadmap",
    AuthCard: {
      Title: "Vítejte v Betě {{appName}}!",
      Body: "Pracujeme na vylepšeních. Plány najdete v <roadmap>Roadmapě</roadmap>.",
    },
    Drawer: {
      Title: "Vítejte v Betě {{appName}}!",
      BodyFirst:
        "Na aplikaci stále pracujeme a každý den ji posouváme o kus dál. Pokud narazíte na chybu, dejte nám prosím vědět pomocí tlačítka <reportButton /> v horní části obrazovky.",
      BodySecond:
        "Pokud vás zajímá, kam {{appName}} směřuje, nahlédněte do <roadmap>naší Roadmapy</roadmap>.",
      BodyThird: "Děkujeme, že nám pomáháte růst.",
      Continue: "Pokračovat",
      Close: "Zavřít",
    },
    MenuItem: "{{appName}} Beta",
  },
};
